/* eslint-disable */
import { PlexUserRelationState } from '@all-hands-hq/plex-graphql-schema';
import { SlateNode } from '@all-hands-hq/plex-graphql-schema';
import { AnswerUserRelationState } from '@all-hands-hq/plex-graphql-schema';
import { PostUserRelationState } from '@all-hands-hq/plex-graphql-schema';
import { QuestionUserRelationState } from '@all-hands-hq/plex-graphql-schema';
import { TaskUserRelationState } from '@all-hands-hq/plex-graphql-schema';
import gql from 'graphql-tag';
import * as ApolloReactCommon from '@apollo/client';
import * as ApolloReactHooks from '@apollo/client';
export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: any }> = { [K in keyof T]: T[K] };

/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  DateTime: any;
  PlexUserRelationState: PlexUserRelationState;
  SlateNode: SlateNode;
  AnswerUserRelationState: AnswerUserRelationState;
  PostUserRelationState: PostUserRelationState;
  QuestionUserRelationState: QuestionUserRelationState;
  TaskUserRelationState: TaskUserRelationState;
};

export enum AccessControlEnum {
  User = 'USER',
  DomainAdmin = 'DOMAIN_ADMIN'
}

export enum AfterUpsertAnswerAction {
  None = 'NONE',
  Approve = 'APPROVE',
  ApproveAndPublish = 'APPROVE_AND_PUBLISH'
}

export type AnalyticsItems = {
  __typename?: 'AnalyticsItems';
  posts: AnalyticsPosts;
  questions: AnalyticsQuestions;
};

export enum AnalyticsItemType {
  Post = 'POST',
  Question = 'QUESTION',
  All = 'ALL'
}

export type AnalyticsPosts = {
  __typename?: 'AnalyticsPosts';
  nextCursor?: Maybe<Scalars['Int']>;
  items: Array<Post>;
};

export type AnalyticsQuestions = {
  __typename?: 'AnalyticsQuestions';
  nextCursor?: Maybe<Scalars['Int']>;
  items: Array<Question>;
};

export type AnalyticsSummary = {
  __typename?: 'AnalyticsSummary';
  audience: Scalars['Int'];
  impressions: Scalars['Int'];
  clicks: Scalars['Int'];
  commentsCount: Scalars['Int'];
  reactionsCount: Scalars['Int'];
  items: AnalyticsItems;
};


export type AnalyticsSummaryAudienceArgs = {
  plexId: Scalars['String'];
};


export type AnalyticsSummaryImpressionsArgs = {
  plexId: Scalars['String'];
};


export type AnalyticsSummaryClicksArgs = {
  plexId: Scalars['String'];
};


export type AnalyticsSummaryCommentsCountArgs = {
  plexId: Scalars['String'];
};


export type AnalyticsSummaryReactionsCountArgs = {
  plexId: Scalars['String'];
};


export type AnalyticsSummaryItemsArgs = {
  plexId: Scalars['String'];
  targetType: AnalyticsItemType;
  cursor?: Maybe<Scalars['Int']>;
  limit: Scalars['Int'];
  timeOrder: TimeOrder;
};

export type Answer = {
  __typename?: 'Answer';
  id: Scalars['String'];
  body: Array<Scalars['SlateNode']>;
  publishedAt: Scalars['DateTime'];
  user: PlexRegisteredUser;
  currentUserReactions: Array<ReactionType>;
  currentUserRelation: Scalars['AnswerUserRelationState'];
  reactionCounts: Array<ReactionCount>;
  questionId: Scalars['String'];
  question: Question;
  primaryLinkId?: Maybe<Scalars['String']>;
  primaryLink?: Maybe<LinkMetadata>;
  links: Array<LinkMetadata>;
  mentions: Array<PlexRegisteredUser>;
  deleted: Scalars['Boolean'];
};

export type AnswerApproval = {
  answerId: Scalars['String'];
  checked: Scalars['Boolean'];
};

export type AnswerInCreateQuestionInput = {
  body: Array<Scalars['SlateNode']>;
  primaryLinkId?: Maybe<Scalars['String']>;
  afterAction?: Maybe<AfterUpsertAnswerAction>;
};

export type AnswerInUpdateQuestionInput = {
  body: Array<Scalars['SlateNode']>;
  primaryLinkId?: Maybe<Scalars['String']>;
};

export type AnswerReactionInput = {
  answerId: Scalars['String'];
  type: ReactionType;
  checked: Scalars['Boolean'];
};


export type AttachmentLinkMetadata = {
  __typename?: 'AttachmentLinkMetadata';
  url: Scalars['String'];
  extension: Scalars['String'];
};

export type Board = {
  __typename?: 'Board';
  id: Scalars['String'];
  name: Scalars['String'];
  description: Scalars['String'];
  plexId: Scalars['String'];
  position: BoardPosition;
  plex: Plex;
  faqCount: Scalars['Int'];
  deleted: Scalars['Boolean'];
  questions: FetchQuestionsResponse;
  source?: Maybe<DocumentSource>;
};


export type BoardFaqCountArgs = {
  filterPublishStatus: FilterPublishStatus;
  labelIds: Array<Scalars['String']>;
};


export type BoardQuestionsArgs = {
  cursor?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  filterPublishStatus: FilterPublishStatus;
  labelIds: Array<Scalars['String']>;
};

export type BoardPosition = {
  __typename?: 'BoardPosition';
  id: Scalars['String'];
  positionInPlex: Scalars['Int'];
};

export type BoardPositionUpdate = {
  __typename?: 'BoardPositionUpdate';
  updatedPositions: Array<BoardPosition>;
};

export type BoardSourceInput = {
  externalEntityId: Scalars['String'];
  headingIds: Array<Scalars['String']>;
};

export type BoardTemplate = {
  __typename?: 'BoardTemplate';
  id: Scalars['String'];
  name: Scalars['String'];
  type: PlexType;
  templates: Array<QuestionTemplate>;
};

export enum CardType {
  Generic = 'GENERIC',
  Faq = 'FAQ'
}

export type ChangeBoardPositionInput = {
  boardId: Scalars['String'];
  newPosition: Scalars['Int'];
};

export type ChangeEvent = {
  __typename?: 'ChangeEvent';
  id: Scalars['String'];
  plexId: Scalars['String'];
  author: User;
  eventType: ChangeEventType;
  targetType: ChangeEventTargetType;
  targetId: Scalars['String'];
  eventTarget: ChangeEventTarget;
  createdAt: Scalars['DateTime'];
  plex: Plex;
  updateDeltaBefore?: Maybe<ChangeEventDelta>;
  updateDeltaAfter?: Maybe<ChangeEventDelta>;
};

export type ChangeEventDelta = {
  __typename?: 'ChangeEventDelta';
  v1?: Maybe<ChangeEventDeltaV1>;
};

export type ChangeEventDeltaAnswer = {
  __typename?: 'ChangeEventDeltaAnswer';
  mentions?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type ChangeEventDeltaPost = {
  __typename?: 'ChangeEventDeltaPost';
  publishStatus?: Maybe<PublishStatus>;
  title?: Maybe<Scalars['String']>;
  primaryLink?: Maybe<Scalars['String']>;
  mentions?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type ChangeEventDeltaQuestion = {
  __typename?: 'ChangeEventDeltaQuestion';
  text?: Maybe<Scalars['String']>;
  status?: Maybe<QuestionStatus>;
  acceptedAnswerId?: Maybe<Scalars['String']>;
};

export type ChangeEventDeltaV1 = {
  __typename?: 'ChangeEventDeltaV1';
  post?: Maybe<ChangeEventDeltaPost>;
  question?: Maybe<ChangeEventDeltaQuestion>;
  answer?: Maybe<ChangeEventDeltaAnswer>;
};

export type ChangeEventTarget = ChangeEventTargetBoard | ChangeEventTargetPost | ChangeEventTargetEvent | ChangeEventTargetQuestion | ChangeEventTargetComment | ChangeEventTargetAnswer | ChangeEventTargetUnavailable;

export type ChangeEventTargetAnswer = {
  __typename?: 'ChangeEventTargetAnswer';
  answer: Answer;
};

export type ChangeEventTargetBoard = {
  __typename?: 'ChangeEventTargetBoard';
  board: Board;
};

export type ChangeEventTargetComment = {
  __typename?: 'ChangeEventTargetComment';
  comment: Comment;
};

export type ChangeEventTargetEvent = {
  __typename?: 'ChangeEventTargetEvent';
  event: Post;
};

export type ChangeEventTargetPost = {
  __typename?: 'ChangeEventTargetPost';
  post: Post;
};

export type ChangeEventTargetQuestion = {
  __typename?: 'ChangeEventTargetQuestion';
  question: Question;
};

export enum ChangeEventTargetType {
  Post = 'POST',
  Question = 'QUESTION',
  Comment = 'COMMENT',
  Answer = 'ANSWER',
  Event = 'EVENT',
  Board = 'BOARD'
}

export type ChangeEventTargetUnavailable = {
  __typename?: 'ChangeEventTargetUnavailable';
  reason: Scalars['String'];
};

export enum ChangeEventType {
  Create = 'CREATE',
  Update = 'UPDATE',
  Delete = 'DELETE'
}

export type ChangeQuestionPositionInput = {
  questionId: Scalars['String'];
  newPosition: Scalars['Int'];
};

export type Channel = {
  __typename?: 'Channel';
  id: Scalars['String'];
  type: ChannelType;
  externalId: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  deleted?: Maybe<Scalars['Boolean']>;
};

export type ChannelInput = {
  id?: Maybe<Scalars['String']>;
  type: ChannelType;
  externalId: Scalars['String'];
  name?: Maybe<Scalars['String']>;
};

export enum ChannelType {
  Gmail = 'GMAIL',
  Slack = 'SLACK'
}

export type Comment = {
  __typename?: 'Comment';
  id: Scalars['String'];
  type: CommentType;
  body: Array<Scalars['SlateNode']>;
  postId?: Maybe<Scalars['String']>;
  questionId?: Maybe<Scalars['String']>;
  commenter: PlexRegisteredUser;
  createdAt: Scalars['DateTime'];
  currentUserReactions: Array<ReactionType>;
  reactionCounts: Array<ReactionCount>;
  externalSource?: Maybe<ChannelType>;
  deleted?: Maybe<Scalars['Boolean']>;
  post?: Maybe<Post>;
  question?: Maybe<Question>;
  links: Array<LinkMetadata>;
  mentions: Array<PlexRegisteredUser>;
};

export type CommentReaction = {
  __typename?: 'CommentReaction';
  id: Scalars['String'];
  type: ReactionType;
  reactingUser: PlexRegisteredUser;
  createdAt: Scalars['DateTime'];
};

export enum CommentType {
  Feedback = 'FEEDBACK',
  Question = 'QUESTION'
}

export type CreateAnswerInput = {
  questionId: Scalars['String'];
  body: Array<Scalars['SlateNode']>;
  primaryLinkId?: Maybe<Scalars['String']>;
  afterAction?: Maybe<AfterUpsertAnswerAction>;
};

export type CreateBoardInput = {
  plexId: Scalars['String'];
  name: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  source?: Maybe<BoardSourceInput>;
};

export type CreateEventInput = {
  plexId: Scalars['String'];
  publishStatus: PublishStatus;
  title: Scalars['String'];
  body: Array<Scalars['SlateNode']>;
  primaryLinkId?: Maybe<Scalars['String']>;
  picture?: Maybe<Scalars['String']>;
  labelIds: Array<Scalars['String']>;
  eventDate: Scalars['DateTime'];
  googleCalendarId?: Maybe<Scalars['String']>;
  googleCalendarEventId?: Maybe<Scalars['String']>;
};

export type CreateFactReviewProcessInput = {
  plexId: Scalars['String'];
  factId: Scalars['String'];
  authorIds: Array<Scalars['String']>;
  reviewerIds: Array<Scalars['String']>;
  reviewableBy?: Maybe<Scalars['DateTime']>;
  reviewBy: Scalars['DateTime'];
};

export type CreateOrUpdatePlexResponse = Plex | PlexInputError;

export type CreatePostCommentInput = {
  postId: Scalars['String'];
  type: CommentType;
  body: Array<Scalars['SlateNode']>;
};

export type CreatePostInput = {
  plexId: Scalars['String'];
  publishStatus: PublishStatus;
  title: Scalars['String'];
  body: Array<Scalars['SlateNode']>;
  primaryLinkId?: Maybe<Scalars['String']>;
  picture?: Maybe<Scalars['String']>;
  labelIds: Array<Scalars['String']>;
  source?: Maybe<PostSourceInput>;
};

export type CreateQuestionCommentInput = {
  questionId: Scalars['String'];
  type: CommentType;
  body: Array<Scalars['SlateNode']>;
};

export type CreateQuestionInput = {
  plexId: Scalars['String'];
  questionTemplateId?: Maybe<Scalars['String']>;
  text: Scalars['String'];
  isDraft: Scalars['Boolean'];
  labelIds?: Maybe<Array<Scalars['String']>>;
  type: CardType;
  boardId?: Maybe<Scalars['String']>;
  positionInBoard?: Maybe<Scalars['Int']>;
  answer?: Maybe<AnswerInCreateQuestionInput>;
};

export type CreateTaskInput = {
  plexId: Scalars['String'];
  type: TaskType;
  publishStatus: PublishStatus;
  status: TaskStatus;
  dueDate?: Maybe<Scalars['DateTime']>;
  assigneeId?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  body: Array<Scalars['SlateNode']>;
  labelIds?: Maybe<Array<Scalars['String']>>;
  sourceEntityRelation?: Maybe<SourceEntityRelationInput>;
};


export enum DepartmentEnum {
  Product = 'PRODUCT',
  Sales = 'SALES',
  Marketing = 'MARKETING',
  CustomerSuccess = 'CUSTOMER_SUCCESS',
  Engineering = 'ENGINEERING',
  Operations = 'OPERATIONS',
  Finance = 'FINANCE',
  Legal = 'LEGAL'
}

export type DocumentSource = GoogleDocumentSource;

export type Domain = {
  __typename?: 'Domain';
  id: Scalars['String'];
  plexes?: Maybe<PlexesResponse>;
  slackChannels?: Maybe<SlackChannelResponse>;
  search?: Maybe<SearchResponse>;
  url?: Maybe<Scalars['String']>;
  orgName?: Maybe<Scalars['String']>;
  industry?: Maybe<IndustryEnum>;
  email?: Maybe<Scalars['String']>;
  address?: Maybe<Scalars['String']>;
  authorizedDomain?: Maybe<Scalars['Boolean']>;
  picture?: Maybe<Scalars['String']>;
  slackWorkspace?: Maybe<SlackWorkspace>;
  paymentInformation?: Maybe<PaymentInformation>;
  isBillingCurrent?: Maybe<Scalars['Boolean']>;
  subscriptionInformation?: Maybe<SubscriptionInformation>;
  users: DomainUsersResponse;
};


export type DomainPlexesArgs = {
  cursor?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
};


export type DomainSlackChannelsArgs = {
  cursor?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
};


export type DomainSearchArgs = {
  query: Scalars['String'];
  cursor?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  filters: SearchFilters;
  sortOrder?: Maybe<SearchSortOrder>;
};


export type DomainUsersArgs = {
  limit?: Maybe<Scalars['Int']>;
  cursor?: Maybe<Scalars['String']>;
};

export type DomainInput = {
  orgName?: Maybe<Scalars['String']>;
  industry?: Maybe<IndustryEnum>;
  email?: Maybe<Scalars['String']>;
  address?: Maybe<Scalars['String']>;
  authorizedDomain?: Maybe<Scalars['Boolean']>;
  picture?: Maybe<Scalars['String']>;
  resetSlackIntegration?: Maybe<Scalars['Boolean']>;
};

export type DomainUsersResponse = {
  __typename?: 'DomainUsersResponse';
  nextCursor?: Maybe<Scalars['String']>;
  users: Array<PlexRegisteredUser>;
};

export type EntityRelation = {
  __typename?: 'EntityRelation';
  id: Scalars['String'];
  sourceType: EntityType;
  sourceId: Scalars['String'];
  source?: Maybe<RelatableEntity>;
  type: EntityRelationType;
  targetType: EntityType;
  targetId: Scalars['String'];
  target?: Maybe<RelatableEntity>;
  deleted: Scalars['Boolean'];
};

export type EntityRelationInput = {
  sourceType: EntityType;
  sourceId: Scalars['String'];
  type: EntityRelationType;
  targetType: EntityType;
  targetId: Scalars['String'];
};

export enum EntityRelationType {
  DependsOn = 'DEPENDS_ON',
  DependencyOf = 'DEPENDENCY_OF',
  CreatedVia = 'CREATED_VIA'
}

export enum EntityType {
  Task = 'TASK',
  Event = 'EVENT',
  FactReviewProcess = 'FACT_REVIEW_PROCESS'
}

export type FactReviewProcess = {
  __typename?: 'FactReviewProcess';
  id: Scalars['String'];
  plexId: Scalars['String'];
  plex: Plex;
  factId: Scalars['String'];
  fact: Question;
  authorIds: Array<Scalars['String']>;
  authors: Array<PlexRegisteredUser>;
  reviewerIds: Array<Scalars['String']>;
  reviewers: Array<PlexRegisteredUser>;
  reviewableBy?: Maybe<Scalars['DateTime']>;
  reviewBy: Scalars['DateTime'];
  createdEntities: Array<EntityRelation>;
};

export type FaqNotification = {
  __typename?: 'FaqNotification';
  id: Scalars['String'];
  isRead: Scalars['Boolean'];
};

export type FeedBoardsResponse = {
  __typename?: 'FeedBoardsResponse';
  items: Array<Board>;
  nextCursor?: Maybe<Scalars['Int']>;
};

export type FeedItemAnalytics = {
  __typename?: 'FeedItemAnalytics';
  parentId: Scalars['String'];
  parentType: FeedItemType;
  plexId: Scalars['String'];
  audienceBy: Array<UserWithTimestamp>;
  impressionsBy: Array<UserWithTimestamp>;
  clicksBy: Array<UserWithTimestamp>;
  audience: Scalars['Int'];
  impressions: Scalars['Int'];
  clicks: Scalars['Int'];
  commentsCount: Scalars['Int'];
  reactionsCount: Scalars['Int'];
};

export enum FeedItemType {
  Post = 'POST',
  Question = 'QUESTION',
  Plex = 'PLEX'
}

export type FeedNotification = FaqNotification | PostNotification | PlexNotification;

export type FetchQuestionsResponse = {
  __typename?: 'FetchQuestionsResponse';
  items: Array<Question>;
  nextCursor?: Maybe<Scalars['Int']>;
};

export enum FilterPublishStatus {
  Draft = 'DRAFT',
  Internal = 'INTERNAL',
  Published = 'PUBLISHED',
  All = 'ALL'
}

export type GenericLink = {
  __typename?: 'GenericLink';
  url: Scalars['String'];
};

export type GoogleCalendar = {
  __typename?: 'GoogleCalendar';
  id: Scalars['String'];
  internalId?: Maybe<Scalars['String']>;
  summary?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
};

export type GoogleCalendarEvent = {
  __typename?: 'GoogleCalendarEvent';
  id: Scalars['String'];
  summary?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  startTime?: Maybe<Scalars['DateTime']>;
  endTime?: Maybe<Scalars['DateTime']>;
  creator?: Maybe<Scalars['String']>;
  htmlLink?: Maybe<Scalars['String']>;
  isRecurring?: Maybe<Scalars['Boolean']>;
};

export type GoogleCalendarEventInput = {
  plexId: Scalars['String'];
  calendarId: Scalars['String'];
  eventId: Scalars['String'];
};

export type GoogleCalendarEventsResponse = {
  __typename?: 'GoogleCalendarEventsResponse';
  events: Array<GoogleCalendarEvent>;
  nextCursor?: Maybe<Scalars['String']>;
};

export type GoogleCalendarInput = {
  id?: Maybe<Scalars['String']>;
  googleCalendarId: Scalars['String'];
};

export type GoogleDoc = {
  __typename?: 'GoogleDoc';
  id: Scalars['String'];
  title: Scalars['String'];
  content: Array<Scalars['SlateNode']>;
};

export type GoogleDocError = {
  __typename?: 'GoogleDocError';
  code: GoogleDocErrorCode;
};

export enum GoogleDocErrorCode {
  AccessDenied = 'ACCESS_DENIED',
  DocumentContentParseFailed = 'DOCUMENT_CONTENT_PARSE_FAILED',
  GoogleDocsConnectionNotEnabled = 'GOOGLE_DOCS_CONNECTION_NOT_ENABLED'
}

export type GoogleDocLinkMetadata = {
  __typename?: 'GoogleDocLinkMetadata';
  fileId: Scalars['String'];
  headingId?: Maybe<Scalars['String']>;
  bookmarkId?: Maybe<Scalars['String']>;
  fileMetadata?: Maybe<GoogleDriveFileMetadata>;
  document?: Maybe<GoogleDocResponse>;
};

export type GoogleDocResponse = GoogleDocError | GoogleDoc;

export type GoogleDocumentSource = {
  __typename?: 'GoogleDocumentSource';
  externalEntityId: Scalars['String'];
  url: Scalars['String'];
  headingIds: Array<Scalars['String']>;
};

export type GoogleDriveFileLinkMetadata = {
  __typename?: 'GoogleDriveFileLinkMetadata';
  fileId: Scalars['String'];
  fileMetadata?: Maybe<GoogleDriveFileMetadata>;
};

export type GoogleDriveFileMetadata = {
  __typename?: 'GoogleDriveFileMetadata';
  externalEntityId: Scalars['String'];
  title: Scalars['String'];
  mimeType: Scalars['String'];
  extension: Scalars['String'];
};

export type GoogleSheetsLinkMetadata = {
  __typename?: 'GoogleSheetsLinkMetadata';
  fileId: Scalars['String'];
  fileMetadata?: Maybe<GoogleDriveFileMetadata>;
};

export type GoogleSlidesLinkMetadata = {
  __typename?: 'GoogleSlidesLinkMetadata';
  fileId: Scalars['String'];
  fileMetadata?: Maybe<GoogleDriveFileMetadata>;
};

export type ImageLinkMetadata = {
  __typename?: 'ImageLinkMetadata';
  url: Scalars['String'];
};

export type ImportBoardFaqInput = {
  faqId?: Maybe<Scalars['String']>;
  question: Scalars['SlateNode'];
  answer: Array<Scalars['SlateNode']>;
};

export type ImportBoardInput = {
  plexId: Scalars['String'];
  boardName: Scalars['SlateNode'];
  importedQuestions: Array<ImportBoardFaqInput>;
  externalEntityId: Scalars['String'];
};

export type ImportFactInput = {
  boardId: Scalars['String'];
  question: Scalars['SlateNode'];
  answer: Array<Scalars['SlateNode']>;
  externalEntityId: Scalars['String'];
};

export enum IndustryEnum {
  Technology = 'TECHNOLOGY'
}

export type InvalidLink = {
  __typename?: 'InvalidLink';
  url: Scalars['String'];
};

export enum ItemType {
  Post = 'POST',
  Question = 'QUESTION'
}

export type Label = {
  __typename?: 'Label';
  id: Scalars['String'];
  name: Scalars['String'];
};

export enum LanguageEnum {
  En = 'EN'
}

export type LinkMetadata = {
  __typename?: 'LinkMetadata';
  id: Scalars['String'];
  details: LinkMetadataDetails;
};

export type LinkMetadataDetails = PlexPostLinkMetadata | PlexFactLinkMetadata | ImageLinkMetadata | AttachmentLinkMetadata | GoogleDocLinkMetadata | GoogleDriveFileLinkMetadata | GoogleSheetsLinkMetadata | GoogleSlidesLinkMetadata | GenericLink | InvalidLink;

export type LoggedInQuery = {
  __typename?: 'LoggedInQuery';
  feedBoards?: Maybe<FeedBoardsResponse>;
  questionById?: Maybe<Question>;
  plexById?: Maybe<Plex>;
  boardById?: Maybe<Board>;
  factAnswerById?: Maybe<Answer>;
  labels?: Maybe<Array<Label>>;
  postById?: Maybe<Post>;
  plexes?: Maybe<PlexesResponse>;
  searchUsers?: Maybe<SearchUsersResponse>;
  notifications?: Maybe<Array<FeedNotification>>;
  notificationsActivity?: Maybe<NotificationsActivityResponse>;
  notificationsActivityUnreadCount?: Maybe<Scalars['Int']>;
  stripePublicKey?: Maybe<Scalars['String']>;
  commentById?: Maybe<Comment>;
};


export type LoggedInQueryFeedBoardsArgs = {
  cursor?: Maybe<Scalars['Int']>;
  limit?: Scalars['Int'];
  plexIds: Array<Scalars['String']>;
};


export type LoggedInQueryQuestionByIdArgs = {
  id: Scalars['String'];
};


export type LoggedInQueryPlexByIdArgs = {
  id: Scalars['String'];
};


export type LoggedInQueryBoardByIdArgs = {
  id: Scalars['String'];
};


export type LoggedInQueryFactAnswerByIdArgs = {
  id: Scalars['String'];
};


export type LoggedInQueryPostByIdArgs = {
  postId: Scalars['String'];
};


export type LoggedInQueryPlexesArgs = {
  cursor?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  ids?: Maybe<Array<Scalars['String']>>;
};


export type LoggedInQuerySearchUsersArgs = {
  searchQuery?: Maybe<Scalars['String']>;
  onlySignedUpUsers?: Maybe<Scalars['Boolean']>;
};


export type LoggedInQueryNotificationsActivityArgs = {
  cursor?: Maybe<Scalars['Int']>;
  limit?: Scalars['Int'];
};


export type LoggedInQueryCommentByIdArgs = {
  id: Scalars['String'];
};

export type Mutation = {
  __typename?: 'Mutation';
  subscribeToPlex?: Maybe<PlexUserRelation>;
  leavePlex?: Maybe<PlexUserRelation>;
  createPlex: CreateOrUpdatePlexResponse;
  updatePlex: CreateOrUpdatePlexResponse;
  deletePlex?: Maybe<Plex>;
  createPost?: Maybe<Post>;
  updatePost?: Maybe<Post>;
  createEvent?: Maybe<Post>;
  updateEvent?: Maybe<Post>;
  importEventFromGoogleCalendar?: Maybe<Post>;
  publishPost?: Maybe<Post>;
  deletePost?: Maybe<Post>;
  createPostComment?: Maybe<Post>;
  deletePostComment?: Maybe<Comment>;
  reactToComment?: Maybe<Comment>;
  reactToQuestion?: Maybe<Question>;
  reactToPost?: Maybe<Post>;
  createBoard?: Maybe<Board>;
  createBoardFromTemplate: Board;
  updateBoard?: Maybe<Board>;
  deleteBoard?: Maybe<Board>;
  importBoard?: Maybe<Board>;
  syncBoard?: Maybe<Board>;
  changeBoardPosition: BoardPositionUpdate;
  importFact: Question;
  createQuestion?: Maybe<Question>;
  updateQuestion?: Maybe<Question>;
  publishQuestion?: Maybe<Question>;
  deleteQuestion?: Maybe<Question>;
  changeQuestionPosition: QuestionPositionUpdate;
  createQuestionComment?: Maybe<Question>;
  updateComment?: Maybe<Comment>;
  promoteCommentToAnswer: Question;
  ignoreQuestionTemplate?: Maybe<Question>;
  createAnswer?: Maybe<Answer>;
  updateAnswer?: Maybe<Answer>;
  reactToAnswer?: Maybe<Answer>;
  approveAnswer?: Maybe<Question>;
  deleteAnswer?: Maybe<Answer>;
  createLabel?: Maybe<Label>;
  share?: Maybe<ShareResponse>;
  updateUserSettings?: Maybe<User>;
  updateDomainUser?: Maybe<PlexRegisteredUser>;
  seenUserNotifications?: Maybe<Array<FeedNotification>>;
  seenNotificationActivity?: Maybe<NotificationActivity>;
  deleteNotificationActivity?: Maybe<NotificationActivity>;
  watchPost?: Maybe<Post>;
  watchQuestion?: Maybe<Question>;
  syncFromGoogleDocToPost: Post;
  linkGoogleCalendar: Plex;
  unlinkGoogleCalendar: Plex;
  updatePaymentMethod: Domain;
  uploadFile: UploadFileResponse;
  createTask: Task;
  updateTask: Task;
  deleteTask: Task;
  createEntityRelation: EntityRelation;
  deleteEntityRelation: EntityRelation;
  analyticsQuestionClick?: Maybe<Scalars['Boolean']>;
  analyticsQuestionImpression?: Maybe<Scalars['Boolean']>;
  analyticsPostClick?: Maybe<Scalars['Boolean']>;
  analyticsPostImpression?: Maybe<Scalars['Boolean']>;
  createFactReviewProcess: FactReviewProcess;
  updateFactReviewProcess: FactReviewProcess;
};


export type MutationSubscribeToPlexArgs = {
  plexId: Scalars['String'];
};


export type MutationLeavePlexArgs = {
  plexId: Scalars['String'];
};


export type MutationCreatePlexArgs = {
  plex: PlexInput;
};


export type MutationUpdatePlexArgs = {
  id: Scalars['String'];
  plex: PlexInput;
};


export type MutationDeletePlexArgs = {
  id: Scalars['String'];
};


export type MutationCreatePostArgs = {
  post: CreatePostInput;
};


export type MutationUpdatePostArgs = {
  post: UpdatePostInput;
};


export type MutationCreateEventArgs = {
  event: CreateEventInput;
};


export type MutationUpdateEventArgs = {
  event: UpdateEventInput;
};


export type MutationImportEventFromGoogleCalendarArgs = {
  event: GoogleCalendarEventInput;
};


export type MutationPublishPostArgs = {
  publishPostInput: PublishPostInput;
};


export type MutationDeletePostArgs = {
  id: Scalars['String'];
};


export type MutationCreatePostCommentArgs = {
  comment: CreatePostCommentInput;
};


export type MutationDeletePostCommentArgs = {
  id: Scalars['String'];
};


export type MutationReactToCommentArgs = {
  reaction: ReactionInput;
};


export type MutationReactToQuestionArgs = {
  reaction: QuestionReactionInput;
};


export type MutationReactToPostArgs = {
  reaction: PostReactionInput;
};


export type MutationCreateBoardArgs = {
  board: CreateBoardInput;
};


export type MutationCreateBoardFromTemplateArgs = {
  plexId: Scalars['String'];
  templateId: Scalars['String'];
  questionTemplateIds: Array<Scalars['String']>;
};


export type MutationUpdateBoardArgs = {
  id: Scalars['String'];
  board: UpdateBoardInput;
};


export type MutationDeleteBoardArgs = {
  id: Scalars['String'];
  faqDestinationBoard: Scalars['String'];
  deleteAllFaqs: Scalars['Boolean'];
};


export type MutationImportBoardArgs = {
  input: ImportBoardInput;
};


export type MutationSyncBoardArgs = {
  input: SyncBoardInput;
};


export type MutationChangeBoardPositionArgs = {
  input: ChangeBoardPositionInput;
};


export type MutationImportFactArgs = {
  input: ImportFactInput;
};


export type MutationCreateQuestionArgs = {
  question: CreateQuestionInput;
};


export type MutationUpdateQuestionArgs = {
  question: UpdateQuestionInput;
};


export type MutationPublishQuestionArgs = {
  publishQuestionInput: PublishQuestionInput;
};


export type MutationDeleteQuestionArgs = {
  id: Scalars['String'];
};


export type MutationChangeQuestionPositionArgs = {
  input: ChangeQuestionPositionInput;
};


export type MutationCreateQuestionCommentArgs = {
  comment: CreateQuestionCommentInput;
};


export type MutationUpdateCommentArgs = {
  comment: UpdateCommentInput;
};


export type MutationPromoteCommentToAnswerArgs = {
  commentId: Scalars['String'];
};


export type MutationIgnoreQuestionTemplateArgs = {
  plexId: Scalars['String'];
  templateId: Scalars['String'];
};


export type MutationCreateAnswerArgs = {
  answer: CreateAnswerInput;
};


export type MutationUpdateAnswerArgs = {
  answer: UpdateAnswerInput;
};


export type MutationReactToAnswerArgs = {
  answer: AnswerReactionInput;
};


export type MutationApproveAnswerArgs = {
  answerApproval: AnswerApproval;
};


export type MutationDeleteAnswerArgs = {
  id: Scalars['String'];
};


export type MutationCreateLabelArgs = {
  name: Scalars['String'];
};


export type MutationShareArgs = {
  shareInput: ShareInput;
};


export type MutationUpdateUserSettingsArgs = {
  userSettingsInput: UserSettingsInput;
};


export type MutationUpdateDomainUserArgs = {
  userId: Scalars['String'];
  status?: Maybe<UserStatus>;
  accessControl?: Maybe<AccessControlEnum>;
};


export type MutationSeenUserNotificationsArgs = {
  postsIds: Array<Scalars['String']>;
  faqsIds: Array<Scalars['String']>;
};


export type MutationSeenNotificationActivityArgs = {
  id: Scalars['String'];
};


export type MutationDeleteNotificationActivityArgs = {
  id: Scalars['String'];
};


export type MutationWatchPostArgs = {
  payload: WatchPostPayload;
};


export type MutationWatchQuestionArgs = {
  payload: WatchQuestionPayload;
};


export type MutationSyncFromGoogleDocToPostArgs = {
  documentId: Scalars['String'];
  postId: Scalars['String'];
};


export type MutationLinkGoogleCalendarArgs = {
  plexId: Scalars['String'];
  googleCalendarId: Scalars['String'];
};


export type MutationUnlinkGoogleCalendarArgs = {
  plexId: Scalars['String'];
  googleCalendarId: Scalars['String'];
};


export type MutationUpdatePaymentMethodArgs = {
  paymentMethodId?: Maybe<Scalars['String']>;
  billingEmail?: Maybe<Scalars['String']>;
  billingAddress?: Maybe<Scalars['String']>;
};


export type MutationUploadFileArgs = {
  url: Scalars['String'];
};


export type MutationCreateTaskArgs = {
  task: CreateTaskInput;
};


export type MutationUpdateTaskArgs = {
  task: UpdateTaskInput;
};


export type MutationDeleteTaskArgs = {
  id: Scalars['String'];
};


export type MutationCreateEntityRelationArgs = {
  input: EntityRelationInput;
};


export type MutationDeleteEntityRelationArgs = {
  entityRelationId: Scalars['String'];
};


export type MutationAnalyticsQuestionClickArgs = {
  id: Scalars['String'];
};


export type MutationAnalyticsQuestionImpressionArgs = {
  id: Scalars['String'];
};


export type MutationAnalyticsPostClickArgs = {
  id: Scalars['String'];
};


export type MutationAnalyticsPostImpressionArgs = {
  id: Scalars['String'];
};


export type MutationCreateFactReviewProcessArgs = {
  input: CreateFactReviewProcessInput;
};


export type MutationUpdateFactReviewProcessArgs = {
  input: UpdateFactReviewProcessInput;
};

export type NotificationActivity = {
  __typename?: 'NotificationActivity';
  id: Scalars['String'];
  userId: Scalars['String'];
  event: ChangeEvent;
  isRead: Scalars['Boolean'];
  deleted: Scalars['Boolean'];
  totalUnreadCount: Scalars['Int'];
};

export type NotificationsActivityResponse = {
  __typename?: 'NotificationsActivityResponse';
  items: Array<NotificationActivity>;
  nextCursor?: Maybe<Scalars['Int']>;
};

export type NotificationSubscriptionPayload = {
  __typename?: 'NotificationSubscriptionPayload';
  notifications: Array<FeedNotification>;
  userId: Scalars['String'];
};

export enum OnboardingStep {
  GetStarted = 'GET_STARTED',
  GetPluggedIntoPlex = 'GET_PLUGGED_INTO_PLEX',
  KnowEachOther = 'KNOW_EACH_OTHER'
}

export type PaymentInformation = {
  __typename?: 'PaymentInformation';
  id: Scalars['String'];
  cardholderName: Scalars['String'];
  cardBrand: Scalars['String'];
  cardLastFourDigits: Scalars['String'];
  cardExpiration: Scalars['String'];
  billingEmail: Scalars['String'];
  billingAddress: Scalars['String'];
};

export type Plex = {
  __typename?: 'Plex';
  id: Scalars['String'];
  permalink: Scalars['String'];
  name: Scalars['String'];
  domainId?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  color?: Maybe<Scalars['String']>;
  currentUserRelation: PlexUserRelation;
  settings: PlexSettings;
  summary: PlexSummary;
  deleted?: Maybe<Scalars['Boolean']>;
  notifications: PlexNotification;
  defaultBoardId: Scalars['String'];
  questionTemplates?: Maybe<Array<PlexQuestionTemplate>>;
  channels?: Maybe<Array<Channel>>;
  googleCalendars: Array<PlexGoogleCalendar>;
  boards: Array<Board>;
  analytics: AnalyticsSummary;
};

export type PlexesResponse = {
  __typename?: 'PlexesResponse';
  nextCursor?: Maybe<Scalars['String']>;
  items: Array<Plex>;
};

export type PlexFactLinkMetadata = {
  __typename?: 'PlexFactLinkMetadata';
  factId: Scalars['String'];
  fact?: Maybe<Question>;
};

export type PlexGoogleCalendar = {
  __typename?: 'PlexGoogleCalendar';
  id: Scalars['String'];
  googleCalendarId: Scalars['String'];
  summary?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
};

export type PlexInput = {
  name: Scalars['String'];
  color?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  addedMembers: Array<PlexMemberInput>;
  removedMembers: Array<PlexMemberInput>;
  channels?: Maybe<Array<ChannelInput>>;
  googleCalendars?: Maybe<Array<GoogleCalendarInput>>;
};

export type PlexInputError = {
  __typename?: 'PlexInputError';
  addedMembers: Array<PlexMemberInputError>;
};

export type PlexInvitedUser = {
  __typename?: 'PlexInvitedUser';
  email: Scalars['String'];
};

export type PlexMember = {
  __typename?: 'PlexMember';
  user: PlexMemberUser;
  role: PlexMemberRole;
};

export type PlexMemberInput = {
  role: PlexMemberRole;
  type: PlexMemberInputType;
  id: Scalars['String'];
};

export type PlexMemberInputError = {
  __typename?: 'PlexMemberInputError';
  type: PlexMemberInputType;
  id: Scalars['String'];
  message: Scalars['String'];
};

export enum PlexMemberInputType {
  Email = 'EMAIL',
  PlexUserId = 'PLEX_USER_ID'
}

export enum PlexMemberRole {
  Owner = 'OWNER',
  Manager = 'MANAGER',
  Writer = 'WRITER',
  Reader = 'READER'
}

export type PlexMemberUser = PlexRegisteredUser | PlexInvitedUser;

export type PlexNotification = {
  __typename?: 'PlexNotification';
  id: Scalars['String'];
  count: Scalars['Int'];
};

export type PlexPostLinkMetadata = {
  __typename?: 'PlexPostLinkMetadata';
  postId: Scalars['String'];
  post?: Maybe<Post>;
};

export type PlexQuestionTemplate = {
  __typename?: 'PlexQuestionTemplate';
  id: Scalars['String'];
  plexId: Scalars['String'];
  questionTemplateId: Scalars['String'];
  text: Scalars['String'];
  question?: Maybe<Question>;
};

export type PlexRegisteredUser = {
  __typename?: 'PlexRegisteredUser';
  id: Scalars['String'];
  email: Scalars['String'];
  name: Scalars['String'];
  picture: Scalars['String'];
  jobTitle?: Maybe<Scalars['String']>;
  status?: Maybe<UserStatus>;
  accessControl?: Maybe<AccessControlEnum>;
};

export type PlexSettings = {
  __typename?: 'PlexSettings';
  members: Array<PlexMember>;
  type: PlexType;
};

export type PlexSummary = {
  __typename?: 'PlexSummary';
  id: Scalars['String'];
  members: Array<PublicPlexMember>;
  channelsCount: Scalars['Int'];
  postsCount: Scalars['Int'];
  faqsCount: Scalars['Int'];
  events: Array<ChangeEvent>;
};

export enum PlexType {
  Project = 'PROJECT',
  Product = 'PRODUCT',
  Customer = 'CUSTOMER'
}

export type PlexUserRelation = {
  __typename?: 'PlexUserRelation';
  id: Scalars['String'];
  role?: Maybe<PlexMemberRole>;
  state: Scalars['PlexUserRelationState'];
};


export type Post = {
  __typename?: 'Post';
  id: Scalars['String'];
  permalink: Scalars['String'];
  type: PostType;
  author: PlexRegisteredUser;
  currentUserRelation: Scalars['PostUserRelationState'];
  plexId: Scalars['String'];
  plex: Plex;
  publishStatus: PublishStatus;
  title: Scalars['String'];
  body: Array<Scalars['SlateNode']>;
  commentsCount: Scalars['Int'];
  comments: Array<Comment>;
  publishedDate: Scalars['DateTime'];
  primaryLinkId?: Maybe<Scalars['String']>;
  primaryLink?: Maybe<LinkMetadata>;
  picture?: Maybe<Scalars['String']>;
  eventDate: Scalars['DateTime'];
  deleted?: Maybe<Scalars['Boolean']>;
  currentUserReactions: Array<ReactionType>;
  reactionCounts: Array<ReactionCount>;
  labels: Array<Label>;
  notification: PostNotification;
  watching?: Maybe<Scalars['Boolean']>;
  links: Array<LinkMetadata>;
  mentions: Array<PlexRegisteredUser>;
  analytics?: Maybe<FeedItemAnalytics>;
  source?: Maybe<DocumentSource>;
};

export type PostFilters = {
  plexIds: Array<Scalars['String']>;
  types: Array<PostType>;
  publishStatuses: Array<PublishStatus>;
  before?: Maybe<Scalars['DateTime']>;
  onOrAfter?: Maybe<Scalars['DateTime']>;
  labelIds: Array<Scalars['String']>;
};

export type PostNotification = {
  __typename?: 'PostNotification';
  id: Scalars['String'];
  isRead: Scalars['Boolean'];
};

export type PostReactionInput = {
  postId: Scalars['String'];
  type: ReactionType;
  checked: Scalars['Boolean'];
};

export type PostSourceInput = {
  externalEntityId: Scalars['String'];
  headingIds: Array<Scalars['String']>;
};

export type PostsResponse = {
  __typename?: 'PostsResponse';
  nextCursor?: Maybe<Scalars['String']>;
  items: Array<Post>;
};

export enum PostType {
  Post = 'POST',
  Event = 'EVENT',
  Milestone = 'MILESTONE',
  Task = 'TASK'
}


export type PublicPlexMember = {
  __typename?: 'PublicPlexMember';
  name: Scalars['String'];
  picture: Scalars['String'];
  role: PlexMemberRole;
};

export type PublishPostInput = {
  postId: Scalars['String'];
  checked: Scalars['Boolean'];
};

export type PublishQuestionInput = {
  questionId: Scalars['String'];
  checked: Scalars['Boolean'];
};

export enum PublishStatus {
  Draft = 'DRAFT',
  Internal = 'INTERNAL',
  Published = 'PUBLISHED'
}

export type Query = {
  __typename?: 'Query';
  currentUser?: Maybe<User>;
  loggedIn?: Maybe<LoggedInQuery>;
  linkMetadata: LinkMetadata;
  posts: PostsResponse;
  tasks: TasksResponse;
  taskById: Task;
  boardTemplates: Array<BoardTemplate>;
  factReviewProcessById: FactReviewProcess;
};


export type QueryLinkMetadataArgs = {
  url: Scalars['String'];
};


export type QueryPostsArgs = {
  cursor?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  timeOrder: TimeOrder;
  filters: PostFilters;
};


export type QueryTasksArgs = {
  cursor?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  filters: TaskFilters;
  order: TasksOrder;
};


export type QueryTaskByIdArgs = {
  taskId: Scalars['String'];
};


export type QueryFactReviewProcessByIdArgs = {
  id: Scalars['String'];
};

export type Question = {
  __typename?: 'Question';
  id: Scalars['String'];
  permalink: Scalars['String'];
  text: Scalars['String'];
  status: QuestionStatus;
  deleted: Scalars['Boolean'];
  createdAt: Scalars['DateTime'];
  publishChangedAt: Scalars['DateTime'];
  author?: Maybe<PlexRegisteredUser>;
  type: CardType;
  plexId: Scalars['String'];
  plex: Plex;
  templateId?: Maybe<Scalars['String']>;
  template?: Maybe<PlexQuestionTemplate>;
  acceptedAnswerId?: Maybe<Scalars['String']>;
  acceptedAnswer?: Maybe<Answer>;
  answers: Array<Answer>;
  answersCount: Scalars['Int'];
  comments: Array<Comment>;
  commentsCount: Scalars['Int'];
  currentUserRelation: Scalars['QuestionUserRelationState'];
  reactionCounts: Array<ReactionCount>;
  currentUserReactions: Array<ReactionType>;
  labels: Array<Label>;
  notification: FaqNotification;
  watching?: Maybe<Scalars['Boolean']>;
  positionInBoard: QuestionPosition;
  boardId: Scalars['String'];
  board: Board;
  analytics?: Maybe<FeedItemAnalytics>;
  source?: Maybe<DocumentSource>;
};

export type QuestionPosition = {
  __typename?: 'QuestionPosition';
  id: Scalars['String'];
  positionInBoard: Scalars['Int'];
};

export type QuestionPositionUpdate = {
  __typename?: 'QuestionPositionUpdate';
  boardId: Scalars['String'];
  plexId: Scalars['String'];
  positions: Array<QuestionPosition>;
};

export type QuestionReactionInput = {
  questionId: Scalars['String'];
  type: ReactionType;
  checked: Scalars['Boolean'];
};

export type QuestionsInBoard = {
  __typename?: 'QuestionsInBoard';
  boardId: Scalars['String'];
  questions: Array<Question>;
  board: Board;
  nextCursor?: Maybe<Scalars['String']>;
  totalFaqCount: Scalars['Int'];
};

export enum QuestionStatus {
  Ignored = 'IGNORED',
  Draft = 'DRAFT',
  Internal = 'INTERNAL',
  Published = 'PUBLISHED'
}

export type QuestionTemplate = {
  __typename?: 'QuestionTemplate';
  id: Scalars['String'];
  text: Scalars['String'];
};


export type ReactionCount = {
  __typename?: 'ReactionCount';
  type: ReactionType;
  count: Scalars['Int'];
};

export type ReactionInput = {
  commentId: Scalars['String'];
  type: ReactionType;
  checked: Scalars['Boolean'];
};

export enum ReactionType {
  Like = 'LIKE',
  Vote = 'VOTE',
  AnalyticsClick = 'ANALYTICS_CLICK',
  AnalyticsImpression = 'ANALYTICS_IMPRESSION'
}

export type RelatableEntity = Task | FactReviewProcess;

export enum SearchDocumentType {
  Post = 'POST',
  Question = 'QUESTION',
  Event = 'EVENT',
  Milestone = 'MILESTONE',
  Task = 'TASK'
}

export type SearchFilters = {
  plexIds: Array<Scalars['String']>;
  types: Array<SearchDocumentType>;
  labelIds: Array<Scalars['String']>;
};

export type SearchPostBody = {
  __typename?: 'SearchPostBody';
  title?: Maybe<Scalars['String']>;
  body?: Maybe<Scalars['String']>;
  author?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  plexId?: Maybe<Scalars['String']>;
  publishStatus?: Maybe<PublishStatus>;
  postType?: Maybe<PostType>;
  permalink: Scalars['String'];
};

export type SearchQuestionBody = {
  __typename?: 'SearchQuestionBody';
  text?: Maybe<Scalars['String']>;
  author?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  plexId?: Maybe<Scalars['String']>;
  questionStatus?: Maybe<QuestionStatus>;
  acceptedAnswerBody?: Maybe<Scalars['String']>;
  permalink: Scalars['String'];
};

export type SearchResponse = {
  __typename?: 'SearchResponse';
  nextCursor?: Maybe<Scalars['String']>;
  items: Array<SearchResult>;
};

export type SearchResult = {
  __typename?: 'SearchResult';
  id: Scalars['String'];
  body: SearchResultBody;
};

export type SearchResultBody = SearchPostBody | SearchQuestionBody;

export enum SearchSortOrder {
  Score = 'SCORE',
  CreatedAt = 'CREATED_AT',
  UpdatedAt = 'UPDATED_AT'
}

export type SearchUser = {
  __typename?: 'SearchUser';
  id: Scalars['String'];
  plexUserId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  picture?: Maybe<Scalars['String']>;
  source: UserSource;
};

export type SearchUsersResponse = {
  __typename?: 'SearchUsersResponse';
  results: Array<SearchUser>;
};

export type ShareInput = {
  itemId: Scalars['String'];
  itemType: ItemType;
  channelId: Scalars['String'];
  channelType: ChannelType;
  note?: Maybe<Scalars['String']>;
};

export type ShareResponse = {
  __typename?: 'ShareResponse';
  id: Scalars['String'];
  sharedDate: Scalars['DateTime'];
};

export type SlackChannel = {
  __typename?: 'SlackChannel';
  id: Scalars['String'];
  name: Scalars['String'];
};

export type SlackChannelResponse = {
  __typename?: 'SlackChannelResponse';
  results: Array<SlackChannel>;
  nextCursor?: Maybe<Scalars['String']>;
};

export type SlackWorkspace = {
  __typename?: 'SlackWorkspace';
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  slackId?: Maybe<Scalars['String']>;
};


export type SourceEntityRelationInput = {
  sourceType: EntityType;
  sourceId: Scalars['String'];
  type: EntityRelationType;
};

export type Subscription = {
  __typename?: 'Subscription';
  board: Board;
  posts: Post;
  comment?: Maybe<Comment>;
  question?: Maybe<Question>;
  questionPosition: QuestionPositionUpdate;
  answer?: Maybe<Answer>;
  userNotifications: NotificationSubscriptionPayload;
  notificationActivity: NotificationActivity;
};


export type SubscriptionBoardArgs = {
  plexIds: Array<Scalars['String']>;
};


export type SubscriptionPostsArgs = {
  filters: PostFilters;
};


export type SubscriptionCommentArgs = {
  id: Scalars['String'];
  isPost: Scalars['Boolean'];
};


export type SubscriptionQuestionArgs = {
  boardId: Scalars['String'];
  filterPublishStatus: FilterPublishStatus;
  labelIds: Array<Scalars['String']>;
};


export type SubscriptionQuestionPositionArgs = {
  boardId: Scalars['String'];
};


export type SubscriptionAnswerArgs = {
  questionId: Scalars['String'];
};

export type SubscriptionInformation = {
  __typename?: 'SubscriptionInformation';
  id: Scalars['String'];
  numberOfSeats: Scalars['Int'];
  status: SubscriptionStatus;
  trialEnd?: Maybe<Scalars['DateTime']>;
  currentPeriodEnd?: Maybe<Scalars['DateTime']>;
};

export enum SubscriptionStatus {
  Trialing = 'TRIALING',
  Active = 'ACTIVE',
  PastDue = 'PAST_DUE',
  Unpaid = 'UNPAID',
  Unknown = 'UNKNOWN'
}

export type SyncBoardInput = {
  boardId: Scalars['String'];
  boardName: Scalars['SlateNode'];
  importedQuestions: Array<ImportBoardFaqInput>;
  externalEntityId: Scalars['String'];
};

export type Task = {
  __typename?: 'Task';
  id: Scalars['String'];
  permalink: Scalars['String'];
  type: TaskType;
  status: TaskStatus;
  publishStatus: PublishStatus;
  plexId: Scalars['String'];
  plex: Plex;
  author: PlexRegisteredUser;
  assignee?: Maybe<PlexRegisteredUser>;
  title: Scalars['String'];
  body: Array<Scalars['SlateNode']>;
  links: Array<LinkMetadata>;
  mentions: Array<PlexRegisteredUser>;
  dueDate?: Maybe<Scalars['DateTime']>;
  createdAt: Scalars['DateTime'];
  deleted: Scalars['Boolean'];
  currentUserRelation: Scalars['TaskUserRelationState'];
  relatedEntities: Array<EntityRelation>;
  postContainerId?: Maybe<Scalars['String']>;
  postContainer?: Maybe<Post>;
  labels: Array<Label>;
};

export type TaskFilters = {
  plexIds: Array<Scalars['String']>;
  types: Array<TaskType>;
  publishStatuses: Array<PublishStatus>;
  labelIds: Array<Scalars['String']>;
  userTaskRelation?: Maybe<UserTaskRelation>;
};

export enum TasksOrder {
  CreatedAtDesc = 'CREATED_AT_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  DueDateDesc = 'DUE_DATE_DESC',
  DueDateAsc = 'DUE_DATE_ASC',
  StatusDesc = 'STATUS_DESC',
  StatusAsc = 'STATUS_ASC'
}

export type TasksResponse = {
  __typename?: 'TasksResponse';
  nextCursor?: Maybe<Scalars['String']>;
  items: Array<Task>;
};

export enum TaskStatus {
  Open = 'OPEN',
  InProgress = 'IN_PROGRESS',
  Done = 'DONE'
}

export enum TaskType {
  Task = 'TASK',
  Milestone = 'MILESTONE'
}


export enum TimeOrder {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type UpdateAnswerInput = {
  id: Scalars['String'];
  body: Array<Scalars['SlateNode']>;
  primaryLinkId?: Maybe<Scalars['String']>;
  afterAction?: Maybe<AfterUpsertAnswerAction>;
};

export type UpdateBoardInput = {
  name: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  source?: Maybe<BoardSourceInput>;
};

export type UpdateCommentInput = {
  id: Scalars['String'];
  type: CommentType;
  body: Array<Scalars['SlateNode']>;
};

export type UpdateEventInput = {
  id: Scalars['String'];
  publishStatus: PublishStatus;
  title: Scalars['String'];
  body: Array<Scalars['SlateNode']>;
  primaryLinkId?: Maybe<Scalars['String']>;
  picture?: Maybe<Scalars['String']>;
  labelIds: Array<Scalars['String']>;
  eventDate: Scalars['DateTime'];
};

export type UpdateFactReviewProcessInput = {
  id: Scalars['String'];
  authorIds: Array<Scalars['String']>;
  reviewerIds: Array<Scalars['String']>;
  reviewableBy?: Maybe<Scalars['DateTime']>;
  reviewBy: Scalars['DateTime'];
};

export type UpdatePostInput = {
  id: Scalars['String'];
  publishStatus: PublishStatus;
  title: Scalars['String'];
  body: Array<Scalars['SlateNode']>;
  primaryLinkId?: Maybe<Scalars['String']>;
  picture?: Maybe<Scalars['String']>;
  labelIds: Array<Scalars['String']>;
  source?: Maybe<PostSourceInput>;
};

export type UpdateQuestionInput = {
  id: Scalars['String'];
  text: Scalars['String'];
  changeDraftToInternal?: Maybe<Scalars['Boolean']>;
  labelIds?: Maybe<Array<Scalars['String']>>;
  boardId?: Maybe<Scalars['String']>;
  positionInBoard?: Maybe<Scalars['Int']>;
  answer?: Maybe<AnswerInUpdateQuestionInput>;
};

export type UpdateTaskInput = {
  id: Scalars['String'];
  publishStatus?: Maybe<PublishStatus>;
  status?: Maybe<TaskStatus>;
  dueDate?: Maybe<Scalars['DateTime']>;
  assigneeId?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  body?: Maybe<Array<Scalars['SlateNode']>>;
  labelIds?: Maybe<Array<Scalars['String']>>;
};

export type UploadFileResponse = {
  __typename?: 'UploadFileResponse';
  plexAssetUrl: Scalars['String'];
};

export type User = {
  __typename?: 'User';
  id: Scalars['String'];
  name: Scalars['String'];
  givenName?: Maybe<Scalars['String']>;
  familyName?: Maybe<Scalars['String']>;
  picture: Scalars['String'];
  email: Scalars['String'];
  locale: Scalars['String'];
  completedOnboardingSteps: Array<OnboardingStep>;
  defaultStatus: Scalars['String'];
  timeZone?: Maybe<Scalars['String']>;
  language?: Maybe<LanguageEnum>;
  displayFilter?: Maybe<Scalars['Boolean']>;
  feedDisplay?: Maybe<Scalars['Boolean']>;
  displayTimeline?: Maybe<Scalars['Boolean']>;
  baseDisplay?: Maybe<Scalars['Boolean']>;
  jobTitle?: Maybe<Scalars['String']>;
  jobDepartment?: Maybe<DepartmentEnum>;
  accessControl?: Maybe<AccessControlEnum>;
  hasExtraGSuiteScopes?: Maybe<Scalars['Boolean']>;
  status: UserStatus;
  googleCalendars?: Maybe<Array<GoogleCalendar>>;
  googleCalendarEvents?: Maybe<GoogleCalendarEventsResponse>;
  domain?: Maybe<Domain>;
  plexes?: Maybe<Array<Plex>>;
};


export type UserGoogleCalendarEventsArgs = {
  calendarId: Scalars['String'];
  query?: Maybe<Scalars['String']>;
  cursor?: Maybe<Scalars['String']>;
  startTimeMax?: Maybe<Scalars['DateTime']>;
  startTimeMin?: Maybe<Scalars['DateTime']>;
  limit?: Maybe<Scalars['Int']>;
};

export type UserSettingsInput = {
  name?: Maybe<Scalars['String']>;
  picture?: Maybe<Scalars['String']>;
  jobTitle?: Maybe<Scalars['String']>;
  jobDepartment?: Maybe<DepartmentEnum>;
  resetOnboardingSteps?: Maybe<Scalars['Boolean']>;
  completedOnboardingStep?: Maybe<OnboardingStep>;
  defaultStatus?: Maybe<Scalars['String']>;
  timeZone?: Maybe<Scalars['String']>;
  language?: Maybe<LanguageEnum>;
  displayFilter?: Maybe<Scalars['Boolean']>;
  feedDisplay?: Maybe<Scalars['Boolean']>;
  displayTimeline?: Maybe<Scalars['Boolean']>;
  baseDisplay?: Maybe<Scalars['Boolean']>;
  domain?: Maybe<DomainInput>;
};

export enum UserSource {
  Directory = 'DIRECTORY',
  Contacts = 'CONTACTS',
  Groups = 'GROUPS',
  Slack = 'SLACK',
  Plex = 'PLEX'
}

export enum UserStatus {
  Active = 'ACTIVE',
  Invited = 'INVITED',
  Disabled = 'DISABLED'
}

export enum UserTaskRelation {
  AssignedToMe = 'ASSIGNED_TO_ME',
  CreatedByMe = 'CREATED_BY_ME'
}

export type UserWithTimestamp = {
  __typename?: 'UserWithTimestamp';
  user: User;
  atDate: Scalars['DateTime'];
};

export enum VisibilityStatus {
  Draft = 'DRAFT',
  Internal = 'INTERNAL',
  Public = 'PUBLIC'
}

export type WatchPostPayload = {
  postId: Scalars['String'];
  watching: Scalars['Boolean'];
};

export type WatchQuestionPayload = {
  questionId: Scalars['String'];
  watching: Scalars['Boolean'];
};

export type AnalyticsItemsFragment = { __typename?: 'AnalyticsItems', posts: { __typename?: 'AnalyticsPosts', nextCursor?: Maybe<number>, items: Array<{ __typename?: 'Post', id: string, title: string, body: Array<SlateNode>, mentions: Array<(
        { __typename?: 'PlexRegisteredUser' }
        & MentionsPlexRegisteredUserFragment
      )>, links: Array<(
        { __typename?: 'LinkMetadata' }
        & LinkPreviewMetadataFragment
      )>, analytics?: Maybe<{ __typename?: 'FeedItemAnalytics', audience: number, impressions: number, clicks: number, commentsCount: number, reactionsCount: number }> }> }, questions: { __typename?: 'AnalyticsQuestions', nextCursor?: Maybe<number>, items: Array<{ __typename?: 'Question', id: string, text: string, acceptedAnswer?: Maybe<{ __typename?: 'Answer', body: Array<SlateNode>, mentions: Array<(
          { __typename?: 'PlexRegisteredUser' }
          & MentionsPlexRegisteredUserFragment
        )>, links: Array<(
          { __typename?: 'LinkMetadata' }
          & LinkPreviewMetadataFragment
        )> }>, analytics?: Maybe<{ __typename?: 'FeedItemAnalytics', audience: number, impressions: number, clicks: number, commentsCount: number, reactionsCount: number }> }> } };

export type AnalyticsOneItemFragment = { __typename?: 'FeedItemAnalytics', audience: number, impressions: number, clicks: number, commentsCount: number, reactionsCount: number, audienceBy: Array<(
    { __typename?: 'UserWithTimestamp' }
    & UserWithTimestampFragment
  )>, impressionsBy: Array<(
    { __typename?: 'UserWithTimestamp' }
    & UserWithTimestampFragment
  )>, clicksBy: Array<(
    { __typename?: 'UserWithTimestamp' }
    & UserWithTimestampFragment
  )> };

export type UserWithTimestampFragment = { __typename?: 'UserWithTimestamp', atDate: any, user: { __typename?: 'User', id: string, name: string, picture: string, jobTitle?: Maybe<string> } };

export type BaseAnswerFragment = { __typename?: 'Answer', id: string, body: Array<SlateNode>, publishedAt: any, currentUserReactions: Array<ReactionType>, currentUserRelation: AnswerUserRelationState, deleted: boolean, user: { __typename?: 'PlexRegisteredUser', id: string, name: string, picture: string, email: string, jobTitle?: Maybe<string> }, reactionCounts: Array<{ __typename?: 'ReactionCount', type: ReactionType, count: number }>, question: { __typename?: 'Question', id: string, text: string, createdAt: any, status: QuestionStatus, author?: Maybe<{ __typename?: 'PlexRegisteredUser', id: string, name: string, email: string, picture: string, jobTitle?: Maybe<string> }> }, primaryLink?: Maybe<{ __typename?: 'LinkMetadata', id: string, details: (
      { __typename?: 'PlexPostLinkMetadata' }
      & FeedLinkPreviewMetadataDetails_PlexPostLinkMetadata_Fragment
    ) | (
      { __typename?: 'PlexFactLinkMetadata' }
      & FeedLinkPreviewMetadataDetails_PlexFactLinkMetadata_Fragment
    ) | (
      { __typename?: 'ImageLinkMetadata' }
      & FeedLinkPreviewMetadataDetails_ImageLinkMetadata_Fragment
    ) | (
      { __typename?: 'AttachmentLinkMetadata' }
      & FeedLinkPreviewMetadataDetails_AttachmentLinkMetadata_Fragment
    ) | (
      { __typename?: 'GoogleDocLinkMetadata' }
      & FeedLinkPreviewMetadataDetails_GoogleDocLinkMetadata_Fragment
    ) | (
      { __typename?: 'GoogleDriveFileLinkMetadata' }
      & FeedLinkPreviewMetadataDetails_GoogleDriveFileLinkMetadata_Fragment
    ) | (
      { __typename?: 'GoogleSheetsLinkMetadata' }
      & FeedLinkPreviewMetadataDetails_GoogleSheetsLinkMetadata_Fragment
    ) | (
      { __typename?: 'GoogleSlidesLinkMetadata' }
      & FeedLinkPreviewMetadataDetails_GoogleSlidesLinkMetadata_Fragment
    ) | (
      { __typename?: 'GenericLink' }
      & FeedLinkPreviewMetadataDetails_GenericLink_Fragment
    ) | (
      { __typename?: 'InvalidLink' }
      & FeedLinkPreviewMetadataDetails_InvalidLink_Fragment
    ) }>, links: Array<(
    { __typename?: 'LinkMetadata' }
    & LinkPreviewMetadataFragment
  )>, mentions: Array<(
    { __typename?: 'PlexRegisteredUser' }
    & MentionsPlexRegisteredUserFragment
  )> };

export type ChangeEventAnswerFragment = { __typename?: 'Answer', id: string, body: Array<SlateNode>, publishedAt: any, currentUserRelation: AnswerUserRelationState, deleted: boolean, user: { __typename?: 'PlexRegisteredUser', id: string, name: string, picture: string, email: string, jobTitle?: Maybe<string> }, question: { __typename?: 'Question', id: string, permalink: string, text: string, plex: { __typename?: 'Plex', id: string, name: string, currentUserRelation: { __typename?: 'PlexUserRelation', id: string, state: PlexUserRelationState } } } };

export type FullAnswerFragment = { __typename?: 'Answer', id: string, body: Array<SlateNode>, publishedAt: any, currentUserReactions: Array<ReactionType>, currentUserRelation: AnswerUserRelationState, deleted: boolean, user: { __typename?: 'PlexRegisteredUser', id: string, name: string, picture: string, email: string, jobTitle?: Maybe<string> }, reactionCounts: Array<{ __typename?: 'ReactionCount', type: ReactionType, count: number }>, question: { __typename?: 'Question', id: string, text: string, createdAt: any, status: QuestionStatus, answersCount: number, acceptedAnswerId?: Maybe<string>, plex: { __typename?: 'Plex', id: string, name: string, color?: Maybe<string>, currentUserRelation: { __typename?: 'PlexUserRelation', id: string, state: PlexUserRelationState } }, author?: Maybe<{ __typename?: 'PlexRegisteredUser', id: string, name: string, email: string, picture: string, jobTitle?: Maybe<string> }> }, primaryLink?: Maybe<(
    { __typename?: 'LinkMetadata' }
    & LinkPreviewMetadataFragment
  )>, links: Array<(
    { __typename?: 'LinkMetadata' }
    & LinkPreviewMetadataFragment
  )>, mentions: Array<(
    { __typename?: 'PlexRegisteredUser' }
    & MentionsPlexRegisteredUserFragment
  )> };

export type BoardDetailsFragment = (
  { __typename?: 'Board', plex: { __typename?: 'Plex', id: string, name: string, color?: Maybe<string>, defaultBoardId: string, currentUserRelation: (
      { __typename?: 'PlexUserRelation' }
      & FullPlexUserRelationFragment
    ) } }
  & BoardOverviewFragment
);

export type BoardOverviewFragment = { __typename?: 'Board', id: string, name: string, description: string, plexId: string, position: { __typename?: 'BoardPosition', id: string, positionInPlex: number }, plex: { __typename?: 'Plex', id: string, name: string, currentUserRelation: (
      { __typename?: 'PlexUserRelation' }
      & FullPlexUserRelationFragment
    ) }, source?: Maybe<{ __typename: 'GoogleDocumentSource', url: string }> };

export type FeedBoardResponseFragment = (
  { __typename?: 'Board', faqCount: number, deleted: boolean, questions: { __typename?: 'FetchQuestionsResponse', nextCursor?: Maybe<number>, items: Array<(
      { __typename?: 'Question' }
      & FeedQuestionDetailsFragment
    )> } }
  & BoardOverviewFragment
);

export type FullBoardTemplateFragment = { __typename?: 'BoardTemplate', id: string, name: string, templates: Array<{ __typename?: 'QuestionTemplate', id: string, text: string }> };

export type ChangeEventCommentFragment = { __typename?: 'Comment', id: string, deleted?: Maybe<boolean>, type: CommentType, body: Array<SlateNode>, currentUserReactions: Array<ReactionType>, createdAt: any, mentions: Array<(
    { __typename?: 'PlexRegisteredUser' }
    & MentionsPlexRegisteredUserFragment
  )>, links: Array<(
    { __typename?: 'LinkMetadata' }
    & LinkPreviewMetadataFragment
  )>, commenter: { __typename?: 'PlexRegisteredUser', id: string, name: string, picture: string, jobTitle?: Maybe<string> } };

export type FullCommentFragment = { __typename?: 'Comment', id: string, deleted?: Maybe<boolean>, type: CommentType, body: Array<SlateNode>, currentUserReactions: Array<ReactionType>, externalSource?: Maybe<ChannelType>, createdAt: any, links: Array<(
    { __typename?: 'LinkMetadata' }
    & LinkPreviewMetadataFragment
  )>, mentions: Array<(
    { __typename?: 'PlexRegisteredUser' }
    & MentionsPlexRegisteredUserFragment
  )>, commenter: { __typename?: 'PlexRegisteredUser', id: string, name: string, picture: string, jobTitle?: Maybe<string> }, reactionCounts: Array<{ __typename?: 'ReactionCount', type: ReactionType, count: number }> };

export type DomainFragment = { __typename?: 'Domain', id: string, url?: Maybe<string>, orgName?: Maybe<string>, industry?: Maybe<IndustryEnum>, email?: Maybe<string>, address?: Maybe<string>, authorizedDomain?: Maybe<boolean>, picture?: Maybe<string>, isBillingCurrent?: Maybe<boolean>, slackWorkspace?: Maybe<{ __typename?: 'SlackWorkspace', name?: Maybe<string>, slackId?: Maybe<string> }> };

export type PaymentInformationFragment = { __typename?: 'Domain', id: string, isBillingCurrent?: Maybe<boolean>, paymentInformation?: Maybe<{ __typename?: 'PaymentInformation', id: string, cardholderName: string, cardBrand: string, cardLastFourDigits: string, cardExpiration: string, billingEmail: string, billingAddress: string }>, subscriptionInformation?: Maybe<{ __typename?: 'SubscriptionInformation', id: string, numberOfSeats: number, status: SubscriptionStatus, trialEnd?: Maybe<any>, currentPeriodEnd?: Maybe<any> }> };

export type TaskDetailsEntityRelationFragment = { __typename?: 'EntityRelation', id: string, type: EntityRelationType, targetType: EntityType, targetId: string, deleted: boolean, target?: Maybe<{ __typename: 'Task', id: string, title: string, status: TaskStatus, permalink: string, type: TaskType, assignee?: Maybe<{ __typename?: 'PlexRegisteredUser', id: string, name: string, picture: string }> } | { __typename: 'FactReviewProcess' }> };

export type FactReviewProcessDetailsFragment = { __typename?: 'FactReviewProcess', id: string, reviewableBy?: Maybe<any>, reviewBy: any, fact: { __typename?: 'Question', id: string, text: string, permalink: string }, plex: { __typename?: 'Plex', id: string, name: string, color?: Maybe<string> }, authors: Array<{ __typename?: 'PlexRegisteredUser', id: string, name: string, picture: string }>, reviewers: Array<{ __typename?: 'PlexRegisteredUser', id: string, name: string, picture: string }> };

export type LinkPreviewMetadataFragment = { __typename?: 'LinkMetadata', id: string, details: (
    { __typename?: 'PlexPostLinkMetadata' }
    & LinkPreviewMetadataDetails_PlexPostLinkMetadata_Fragment
  ) | (
    { __typename?: 'PlexFactLinkMetadata' }
    & LinkPreviewMetadataDetails_PlexFactLinkMetadata_Fragment
  ) | (
    { __typename?: 'ImageLinkMetadata' }
    & LinkPreviewMetadataDetails_ImageLinkMetadata_Fragment
  ) | (
    { __typename?: 'AttachmentLinkMetadata' }
    & LinkPreviewMetadataDetails_AttachmentLinkMetadata_Fragment
  ) | (
    { __typename?: 'GoogleDocLinkMetadata' }
    & LinkPreviewMetadataDetails_GoogleDocLinkMetadata_Fragment
  ) | (
    { __typename?: 'GoogleDriveFileLinkMetadata' }
    & LinkPreviewMetadataDetails_GoogleDriveFileLinkMetadata_Fragment
  ) | (
    { __typename?: 'GoogleSheetsLinkMetadata' }
    & LinkPreviewMetadataDetails_GoogleSheetsLinkMetadata_Fragment
  ) | (
    { __typename?: 'GoogleSlidesLinkMetadata' }
    & LinkPreviewMetadataDetails_GoogleSlidesLinkMetadata_Fragment
  ) | (
    { __typename?: 'GenericLink' }
    & LinkPreviewMetadataDetails_GenericLink_Fragment
  ) | (
    { __typename?: 'InvalidLink' }
    & LinkPreviewMetadataDetails_InvalidLink_Fragment
  ) };

export type AttachmentLinkMetadataFragment = { __typename?: 'AttachmentLinkMetadata', url: string, extension: string };

type FeedLinkPreviewMetadataDetails_PlexPostLinkMetadata_Fragment = (
  { __typename: 'PlexPostLinkMetadata' }
  & PlexPostLinkMetadataFragment
);

type FeedLinkPreviewMetadataDetails_PlexFactLinkMetadata_Fragment = (
  { __typename: 'PlexFactLinkMetadata' }
  & PlexFactLinkMetadataFragment
);

type FeedLinkPreviewMetadataDetails_ImageLinkMetadata_Fragment = (
  { __typename: 'ImageLinkMetadata' }
  & ImageLinkMetadataFragment
);

type FeedLinkPreviewMetadataDetails_AttachmentLinkMetadata_Fragment = (
  { __typename: 'AttachmentLinkMetadata' }
  & AttachmentLinkMetadataFragment
);

type FeedLinkPreviewMetadataDetails_GoogleDocLinkMetadata_Fragment = (
  { __typename: 'GoogleDocLinkMetadata' }
  & GoogleDocLinkMetadataFragment
);

type FeedLinkPreviewMetadataDetails_GoogleDriveFileLinkMetadata_Fragment = (
  { __typename: 'GoogleDriveFileLinkMetadata' }
  & GoogleDriveFileLinkMetadataFragment
);

type FeedLinkPreviewMetadataDetails_GoogleSheetsLinkMetadata_Fragment = (
  { __typename: 'GoogleSheetsLinkMetadata' }
  & GoogleSheetsLinkMetadataFragment
);

type FeedLinkPreviewMetadataDetails_GoogleSlidesLinkMetadata_Fragment = (
  { __typename: 'GoogleSlidesLinkMetadata' }
  & GoogleSlidesLinkMetadataFragment
);

type FeedLinkPreviewMetadataDetails_GenericLink_Fragment = (
  { __typename: 'GenericLink' }
  & GenericLinkMetadataFragment
);

type FeedLinkPreviewMetadataDetails_InvalidLink_Fragment = (
  { __typename: 'InvalidLink' }
  & InvalidLinkMetadataFragment
);

export type FeedLinkPreviewMetadataDetailsFragment = FeedLinkPreviewMetadataDetails_PlexPostLinkMetadata_Fragment | FeedLinkPreviewMetadataDetails_PlexFactLinkMetadata_Fragment | FeedLinkPreviewMetadataDetails_ImageLinkMetadata_Fragment | FeedLinkPreviewMetadataDetails_AttachmentLinkMetadata_Fragment | FeedLinkPreviewMetadataDetails_GoogleDocLinkMetadata_Fragment | FeedLinkPreviewMetadataDetails_GoogleDriveFileLinkMetadata_Fragment | FeedLinkPreviewMetadataDetails_GoogleSheetsLinkMetadata_Fragment | FeedLinkPreviewMetadataDetails_GoogleSlidesLinkMetadata_Fragment | FeedLinkPreviewMetadataDetails_GenericLink_Fragment | FeedLinkPreviewMetadataDetails_InvalidLink_Fragment;

export type GenericLinkMetadataFragment = { __typename?: 'GenericLink', url: string };

export type GoogleDocLinkMetadataFragment = { __typename?: 'GoogleDocLinkMetadata', fileMetadata?: Maybe<{ __typename?: 'GoogleDriveFileMetadata', title: string }> };

export type GoogleDriveFileLinkMetadataFragment = { __typename?: 'GoogleDriveFileLinkMetadata', fileMetadata?: Maybe<{ __typename?: 'GoogleDriveFileMetadata', title: string, extension: string }> };

export type GoogleSheetsLinkMetadataFragment = { __typename?: 'GoogleSheetsLinkMetadata', fileMetadata?: Maybe<{ __typename?: 'GoogleDriveFileMetadata', title: string }> };

export type GoogleSlidesLinkMetadataFragment = { __typename?: 'GoogleSlidesLinkMetadata', fileMetadata?: Maybe<{ __typename?: 'GoogleDriveFileMetadata', title: string }> };

export type ImageLinkMetadataFragment = { __typename?: 'ImageLinkMetadata', url: string };

export type InvalidLinkMetadataFragment = { __typename?: 'InvalidLink', url: string };

type LinkPreviewMetadataDetails_PlexPostLinkMetadata_Fragment = (
  { __typename: 'PlexPostLinkMetadata' }
  & PlexPostLinkMetadataFragment
);

type LinkPreviewMetadataDetails_PlexFactLinkMetadata_Fragment = (
  { __typename: 'PlexFactLinkMetadata' }
  & PlexFactLinkMetadataFragment
);

type LinkPreviewMetadataDetails_ImageLinkMetadata_Fragment = (
  { __typename: 'ImageLinkMetadata' }
  & ImageLinkMetadataFragment
);

type LinkPreviewMetadataDetails_AttachmentLinkMetadata_Fragment = (
  { __typename: 'AttachmentLinkMetadata' }
  & AttachmentLinkMetadataFragment
);

type LinkPreviewMetadataDetails_GoogleDocLinkMetadata_Fragment = (
  { __typename: 'GoogleDocLinkMetadata' }
  & GoogleDocLinkMetadataFragment
);

type LinkPreviewMetadataDetails_GoogleDriveFileLinkMetadata_Fragment = (
  { __typename: 'GoogleDriveFileLinkMetadata' }
  & GoogleDriveFileLinkMetadataFragment
);

type LinkPreviewMetadataDetails_GoogleSheetsLinkMetadata_Fragment = (
  { __typename: 'GoogleSheetsLinkMetadata' }
  & GoogleSheetsLinkMetadataFragment
);

type LinkPreviewMetadataDetails_GoogleSlidesLinkMetadata_Fragment = (
  { __typename: 'GoogleSlidesLinkMetadata' }
  & GoogleSlidesLinkMetadataFragment
);

type LinkPreviewMetadataDetails_GenericLink_Fragment = (
  { __typename: 'GenericLink' }
  & GenericLinkMetadataFragment
);

type LinkPreviewMetadataDetails_InvalidLink_Fragment = (
  { __typename: 'InvalidLink' }
  & InvalidLinkMetadataFragment
);

export type LinkPreviewMetadataDetailsFragment = LinkPreviewMetadataDetails_PlexPostLinkMetadata_Fragment | LinkPreviewMetadataDetails_PlexFactLinkMetadata_Fragment | LinkPreviewMetadataDetails_ImageLinkMetadata_Fragment | LinkPreviewMetadataDetails_AttachmentLinkMetadata_Fragment | LinkPreviewMetadataDetails_GoogleDocLinkMetadata_Fragment | LinkPreviewMetadataDetails_GoogleDriveFileLinkMetadata_Fragment | LinkPreviewMetadataDetails_GoogleSheetsLinkMetadata_Fragment | LinkPreviewMetadataDetails_GoogleSlidesLinkMetadata_Fragment | LinkPreviewMetadataDetails_GenericLink_Fragment | LinkPreviewMetadataDetails_InvalidLink_Fragment;

export type PlexFactLinkMetadataFragment = { __typename?: 'PlexFactLinkMetadata', fact?: Maybe<{ __typename?: 'Question', id: string, permalink: string, text: string, plex: { __typename?: 'Plex', id: string, name: string } }> };

export type PlexPostLinkMetadataFragment = { __typename?: 'PlexPostLinkMetadata', post?: Maybe<{ __typename?: 'Post', id: string, permalink: string, title: string, plex: { __typename?: 'Plex', id: string, name: string } }> };

export type ChangeEventFragment = { __typename?: 'ChangeEvent', id: string, createdAt: any, eventType: ChangeEventType, targetType: ChangeEventTargetType, author: { __typename?: 'User', id: string, name: string, picture: string, email: string, jobTitle?: Maybe<string> }, plex: { __typename?: 'Plex', id: string, name: string, color?: Maybe<string> }, eventTarget: { __typename?: 'ChangeEventTargetBoard', board: { __typename?: 'Board', id: string, name: string, faqCount: number } } | { __typename?: 'ChangeEventTargetPost', post: (
      { __typename?: 'Post' }
      & ChangeEventPostDetailsFragment
    ) } | { __typename?: 'ChangeEventTargetEvent', event: (
      { __typename?: 'Post' }
      & ChangeEventPostDetailsFragment
    ) } | { __typename?: 'ChangeEventTargetQuestion', question: (
      { __typename?: 'Question' }
      & ChangeEventQuestionOverviewFragment
    ) } | { __typename?: 'ChangeEventTargetComment', comment: (
      { __typename?: 'Comment', post?: Maybe<(
        { __typename?: 'Post' }
        & ChangeEventPostDetailsFragment
      )>, question?: Maybe<(
        { __typename?: 'Question' }
        & ChangeEventQuestionOverviewFragment
      )> }
      & ChangeEventCommentFragment
    ) } | { __typename?: 'ChangeEventTargetAnswer', answer: (
      { __typename?: 'Answer' }
      & ChangeEventAnswerFragment
    ) } | { __typename?: 'ChangeEventTargetUnavailable' }, updateDeltaBefore?: Maybe<{ __typename?: 'ChangeEventDelta', v1?: Maybe<{ __typename?: 'ChangeEventDeltaV1', post?: Maybe<{ __typename?: 'ChangeEventDeltaPost', mentions?: Maybe<Array<Maybe<string>>> }>, question?: Maybe<{ __typename?: 'ChangeEventDeltaQuestion', acceptedAnswerId?: Maybe<string> }>, answer?: Maybe<{ __typename?: 'ChangeEventDeltaAnswer', mentions?: Maybe<Array<Maybe<string>>> }> }> }>, updateDeltaAfter?: Maybe<{ __typename?: 'ChangeEventDelta', v1?: Maybe<{ __typename?: 'ChangeEventDeltaV1', post?: Maybe<{ __typename?: 'ChangeEventDeltaPost', mentions?: Maybe<Array<Maybe<string>>> }>, question?: Maybe<{ __typename?: 'ChangeEventDeltaQuestion', acceptedAnswerId?: Maybe<string> }>, answer?: Maybe<{ __typename?: 'ChangeEventDeltaAnswer', mentions?: Maybe<Array<Maybe<string>>> }> }> }> };

export type FaqNotificationFragment = { __typename: 'FaqNotification', id: string, isRead: boolean };

type FeedNotification_FaqNotification_Fragment = (
  { __typename: 'FaqNotification' }
  & FaqNotificationFragment
);

type FeedNotification_PostNotification_Fragment = (
  { __typename: 'PostNotification' }
  & PostNotificationFragment
);

type FeedNotification_PlexNotification_Fragment = (
  { __typename: 'PlexNotification' }
  & PlexNotificationFragment
);

export type FeedNotificationFragment = FeedNotification_FaqNotification_Fragment | FeedNotification_PostNotification_Fragment | FeedNotification_PlexNotification_Fragment;

export type NotificationActivityFragment = { __typename?: 'NotificationActivity', id: string, isRead: boolean, deleted: boolean, event: (
    { __typename?: 'ChangeEvent' }
    & ChangeEventFragment
  ) };

export type PlexNotificationFragment = { __typename: 'PlexNotification', id: string, count: number };

export type PlexSummaryChangeEventFragment = { __typename?: 'ChangeEvent', id: string, createdAt: any, eventType: ChangeEventType, targetType: ChangeEventTargetType, author: { __typename?: 'User', id: string, name: string, picture: string, email: string, jobTitle?: Maybe<string> }, eventTarget: { __typename?: 'ChangeEventTargetBoard', board: { __typename?: 'Board', id: string, name: string, faqCount: number } } | { __typename?: 'ChangeEventTargetPost', post: { __typename?: 'Post', id: string, title: string, permalink: string } } | { __typename?: 'ChangeEventTargetEvent', event: { __typename?: 'Post', id: string, title: string, permalink: string } } | { __typename?: 'ChangeEventTargetQuestion', question: { __typename?: 'Question', id: string, text: string, permalink: string } } | { __typename?: 'ChangeEventTargetComment', comment: { __typename?: 'Comment', id: string, body: Array<SlateNode>, post?: Maybe<{ __typename?: 'Post', id: string, title: string, permalink: string }>, question?: Maybe<{ __typename?: 'Question', id: string, text: string, permalink: string }>, mentions: Array<(
        { __typename?: 'PlexRegisteredUser' }
        & MentionsPlexRegisteredUserFragment
      )>, links: Array<(
        { __typename?: 'LinkMetadata' }
        & LinkPreviewMetadataFragment
      )> } } | { __typename?: 'ChangeEventTargetAnswer', answer: { __typename?: 'Answer', id: string, question: { __typename?: 'Question', id: string, text: string, permalink: string } } } | { __typename?: 'ChangeEventTargetUnavailable' }, updateDeltaBefore?: Maybe<{ __typename?: 'ChangeEventDelta', v1?: Maybe<{ __typename?: 'ChangeEventDeltaV1', post?: Maybe<{ __typename?: 'ChangeEventDeltaPost', mentions?: Maybe<Array<Maybe<string>>> }>, question?: Maybe<{ __typename?: 'ChangeEventDeltaQuestion', acceptedAnswerId?: Maybe<string> }>, answer?: Maybe<{ __typename?: 'ChangeEventDeltaAnswer', mentions?: Maybe<Array<Maybe<string>>> }> }> }>, updateDeltaAfter?: Maybe<{ __typename?: 'ChangeEventDelta', v1?: Maybe<{ __typename?: 'ChangeEventDeltaV1', post?: Maybe<{ __typename?: 'ChangeEventDeltaPost', mentions?: Maybe<Array<Maybe<string>>> }>, question?: Maybe<{ __typename?: 'ChangeEventDeltaQuestion', acceptedAnswerId?: Maybe<string> }>, answer?: Maybe<{ __typename?: 'ChangeEventDeltaAnswer', mentions?: Maybe<Array<Maybe<string>>> }> }> }> };

export type PostNotificationFragment = { __typename: 'PostNotification', id: string, isRead: boolean };

export type FullPlexFragment = (
  { __typename?: 'Plex', id: string, name: string, color?: Maybe<string>, description?: Maybe<string>, defaultBoardId: string, deleted?: Maybe<boolean>, channels?: Maybe<Array<{ __typename?: 'Channel', id: string, type: ChannelType, name?: Maybe<string>, externalId: string }>>, googleCalendars: Array<{ __typename?: 'PlexGoogleCalendar', id: string, googleCalendarId: string, description?: Maybe<string>, summary?: Maybe<string> }>, settings: { __typename?: 'PlexSettings', members: Array<{ __typename?: 'PlexMember', role: PlexMemberRole, user: { __typename: 'PlexRegisteredUser', id: string, email: string, name: string, picture: string } | { __typename: 'PlexInvitedUser', email: string } }> } }
  & PlexOverviewFragment
);

export type PlexDetailsFragment = { __typename?: 'Plex', id: string, name: string, description?: Maybe<string>, color?: Maybe<string>, defaultBoardId: string, deleted?: Maybe<boolean>, questionTemplates?: Maybe<Array<(
    { __typename?: 'PlexQuestionTemplate' }
    & PlexQuestionTemplateDetailsFragment
  )>>, currentUserRelation: (
    { __typename?: 'PlexUserRelation' }
    & FullPlexUserRelationFragment
  ) };

export type PlexDomainSummaryFragment = { __typename?: 'Plex', id: string, name: string, description?: Maybe<string>, deleted?: Maybe<boolean>, color?: Maybe<string>, defaultBoardId: string, currentUserRelation: (
    { __typename?: 'PlexUserRelation' }
    & FullPlexUserRelationFragment
  ), summary: { __typename?: 'PlexSummary', id: string, members: Array<{ __typename?: 'PublicPlexMember', name: string, picture: string, role: PlexMemberRole }> } };

export type PlexOverviewFragment = { __typename?: 'Plex', id: string, permalink: string, name: string, color?: Maybe<string>, deleted?: Maybe<boolean>, defaultBoardId: string, notifications: (
    { __typename?: 'PlexNotification' }
    & PlexNotificationFragment
  ), currentUserRelation: (
    { __typename?: 'PlexUserRelation' }
    & FullPlexUserRelationFragment
  ) };

export type PlexSnackbarFragment = { __typename?: 'Plex', id: string, name: string, description?: Maybe<string>, deleted?: Maybe<boolean>, color?: Maybe<string>, defaultBoardId: string, currentUserRelation: (
    { __typename?: 'PlexUserRelation' }
    & FullPlexUserRelationFragment
  ) };

export type PlexSummaryFragment = { __typename?: 'Plex', id: string, name: string, description?: Maybe<string>, deleted?: Maybe<boolean>, defaultBoardId: string, notifications: (
    { __typename?: 'PlexNotification' }
    & PlexNotificationFragment
  ), currentUserRelation: (
    { __typename?: 'PlexUserRelation' }
    & FullPlexUserRelationFragment
  ), summary: { __typename?: 'PlexSummary', id: string, channelsCount: number, postsCount: number, faqsCount: number, members: Array<{ __typename?: 'PublicPlexMember', name: string, picture: string, role: PlexMemberRole }>, events: Array<(
      { __typename?: 'ChangeEvent' }
      & PlexSummaryChangeEventFragment
    )> } };

export type PlexSummaryOverviewFragment = { __typename?: 'Plex', id: string, name: string, description?: Maybe<string>, color?: Maybe<string>, deleted?: Maybe<boolean>, notifications: (
    { __typename?: 'PlexNotification' }
    & PlexNotificationFragment
  ), currentUserRelation: (
    { __typename?: 'PlexUserRelation' }
    & FullPlexUserRelationFragment
  ), summary: { __typename?: 'PlexSummary', id: string, members: Array<{ __typename?: 'PublicPlexMember', name: string, picture: string, role: PlexMemberRole }>, events: Array<(
      { __typename?: 'ChangeEvent' }
      & ChangeEventFragment
    )> } };

export type FullPlexInputErrorFragment = { __typename: 'PlexInputError', addedMembers: Array<{ __typename: 'PlexMemberInputError', type: PlexMemberInputType, id: string, message: string }> };

export type PlexQuestionTemplateDetailsFragment = { __typename?: 'PlexQuestionTemplate', id: string, questionTemplateId: string, text: string, question?: Maybe<{ __typename?: 'Question', id: string, status: QuestionStatus, deleted: boolean }> };

export type MentionsPlexRegisteredUserFragment = { __typename?: 'PlexRegisteredUser', email: string, name: string };

export type FullPlexUserRelationFragment = { __typename?: 'PlexUserRelation', id: string, role?: Maybe<PlexMemberRole>, state: PlexUserRelationState };

export type ChangeEventPostDetailsFragment = { __typename?: 'Post', id: string, permalink: string, currentUserRelation: PostUserRelationState, deleted?: Maybe<boolean>, title: string, body: Array<SlateNode>, publishStatus: PublishStatus, publishedDate: any, type: PostType, eventDate: any, watching?: Maybe<boolean>, plex: { __typename?: 'Plex', id: string, name: string, color?: Maybe<string>, currentUserRelation: (
      { __typename?: 'PlexUserRelation' }
      & FullPlexUserRelationFragment
    ) }, author: { __typename?: 'PlexRegisteredUser', id: string, name: string, picture: string, jobTitle?: Maybe<string> }, labels: Array<{ __typename?: 'Label', id: string, name: string }> };

export type FeedPostDetailsFragment = { __typename?: 'Post', id: string, currentUserRelation: PostUserRelationState, deleted?: Maybe<boolean>, title: string, body: Array<SlateNode>, publishStatus: PublishStatus, publishedDate: any, picture?: Maybe<string>, commentsCount: number, type: PostType, eventDate: any, watching?: Maybe<boolean>, currentUserReactions: Array<ReactionType>, permalink: string, plex: { __typename?: 'Plex', id: string, name: string, color?: Maybe<string>, currentUserRelation: (
      { __typename?: 'PlexUserRelation' }
      & FullPlexUserRelationFragment
    ) }, author: { __typename?: 'PlexRegisteredUser', id: string, name: string, picture: string, jobTitle?: Maybe<string> }, primaryLink?: Maybe<{ __typename?: 'LinkMetadata', id: string, details: (
      { __typename?: 'PlexPostLinkMetadata' }
      & FeedLinkPreviewMetadataDetails_PlexPostLinkMetadata_Fragment
    ) | (
      { __typename?: 'PlexFactLinkMetadata' }
      & FeedLinkPreviewMetadataDetails_PlexFactLinkMetadata_Fragment
    ) | (
      { __typename?: 'ImageLinkMetadata' }
      & FeedLinkPreviewMetadataDetails_ImageLinkMetadata_Fragment
    ) | (
      { __typename?: 'AttachmentLinkMetadata' }
      & FeedLinkPreviewMetadataDetails_AttachmentLinkMetadata_Fragment
    ) | (
      { __typename?: 'GoogleDocLinkMetadata' }
      & FeedLinkPreviewMetadataDetails_GoogleDocLinkMetadata_Fragment
    ) | (
      { __typename?: 'GoogleDriveFileLinkMetadata' }
      & FeedLinkPreviewMetadataDetails_GoogleDriveFileLinkMetadata_Fragment
    ) | (
      { __typename?: 'GoogleSheetsLinkMetadata' }
      & FeedLinkPreviewMetadataDetails_GoogleSheetsLinkMetadata_Fragment
    ) | (
      { __typename?: 'GoogleSlidesLinkMetadata' }
      & FeedLinkPreviewMetadataDetails_GoogleSlidesLinkMetadata_Fragment
    ) | (
      { __typename?: 'GenericLink' }
      & FeedLinkPreviewMetadataDetails_GenericLink_Fragment
    ) | (
      { __typename?: 'InvalidLink' }
      & FeedLinkPreviewMetadataDetails_InvalidLink_Fragment
    ) }>, labels: Array<{ __typename?: 'Label', id: string, name: string }>, notification: (
    { __typename?: 'PostNotification' }
    & PostNotificationFragment
  ), mentions: Array<(
    { __typename?: 'PlexRegisteredUser' }
    & MentionsPlexRegisteredUserFragment
  )>, links: Array<(
    { __typename?: 'LinkMetadata' }
    & LinkPreviewMetadataFragment
  )> };

export type PostDetailsFragment = { __typename?: 'Post', id: string, currentUserRelation: PostUserRelationState, deleted?: Maybe<boolean>, title: string, body: Array<SlateNode>, publishStatus: PublishStatus, publishedDate: any, picture?: Maybe<string>, commentsCount: number, type: PostType, eventDate: any, watching?: Maybe<boolean>, currentUserReactions: Array<ReactionType>, permalink: string, plex: { __typename?: 'Plex', id: string, name: string, color?: Maybe<string>, currentUserRelation: (
      { __typename?: 'PlexUserRelation' }
      & FullPlexUserRelationFragment
    ) }, author: { __typename?: 'PlexRegisteredUser', id: string, name: string, picture: string, jobTitle?: Maybe<string> }, primaryLink?: Maybe<(
    { __typename?: 'LinkMetadata' }
    & LinkPreviewMetadataFragment
  )>, links: Array<(
    { __typename?: 'LinkMetadata' }
    & LinkPreviewMetadataFragment
  )>, labels: Array<{ __typename?: 'Label', id: string, name: string }>, notification: (
    { __typename?: 'PostNotification' }
    & PostNotificationFragment
  ), mentions: Array<(
    { __typename?: 'PlexRegisteredUser' }
    & MentionsPlexRegisteredUserFragment
  )>, source?: Maybe<{ __typename: 'GoogleDocumentSource', url: string, headingIds: Array<string> }> };

export type ChangeEventQuestionOverviewFragment = { __typename?: 'Question', id: string, permalink: string, text: string, status: QuestionStatus, deleted: boolean, createdAt: any, publishChangedAt: any, currentUserRelation: QuestionUserRelationState, watching?: Maybe<boolean>, boardId: string, plex: { __typename?: 'Plex', id: string, name: string, color?: Maybe<string>, currentUserRelation: (
      { __typename?: 'PlexUserRelation' }
      & FullPlexUserRelationFragment
    ) }, acceptedAnswer?: Maybe<(
    { __typename?: 'Answer' }
    & ChangeEventAnswerFragment
  )>, author?: Maybe<{ __typename?: 'PlexRegisteredUser', id: string, name: string, email: string, picture: string, jobTitle?: Maybe<string> }>, labels: Array<{ __typename?: 'Label', id: string, name: string }> };

export type QuestionDetailsFragment = { __typename?: 'Question', id: string, text: string, status: QuestionStatus, type: CardType, answersCount: number, currentUserRelation: QuestionUserRelationState, deleted: boolean, createdAt: any, publishChangedAt: any, commentsCount: number, currentUserReactions: Array<ReactionType>, watching?: Maybe<boolean>, boardId: string, permalink: string, plex: { __typename?: 'Plex', id: string, name: string, color?: Maybe<string>, currentUserRelation: (
      { __typename?: 'PlexUserRelation' }
      & FullPlexUserRelationFragment
    ) }, acceptedAnswer?: Maybe<(
    { __typename?: 'Answer' }
    & FullAnswerFragment
  )>, answers: Array<(
    { __typename?: 'Answer' }
    & FullAnswerFragment
  )>, author?: Maybe<{ __typename?: 'PlexRegisteredUser', id: string, name: string, email: string, picture: string, jobTitle?: Maybe<string> }>, comments: Array<{ __typename?: 'Comment', id: string, deleted?: Maybe<boolean> }>, reactionCounts: Array<{ __typename?: 'ReactionCount', type: ReactionType, count: number }>, labels: Array<{ __typename?: 'Label', id: string, name: string }>, notification: (
    { __typename?: 'FaqNotification' }
    & FaqNotificationFragment
  ), positionInBoard: { __typename?: 'QuestionPosition', id: string, positionInBoard: number }, source?: Maybe<{ __typename: 'GoogleDocumentSource', url: string }> };

export type QuestionOverviewFragment = { __typename?: 'Question', id: string, text: string, status: QuestionStatus, type: CardType, deleted: boolean, createdAt: any, publishChangedAt: any, commentsCount: number, currentUserRelation: QuestionUserRelationState, currentUserReactions: Array<ReactionType>, watching?: Maybe<boolean>, boardId: string, permalink: string, plex: { __typename?: 'Plex', id: string, name: string, color?: Maybe<string>, currentUserRelation: (
      { __typename?: 'PlexUserRelation' }
      & FullPlexUserRelationFragment
    ) }, acceptedAnswer?: Maybe<(
    { __typename?: 'Answer' }
    & BaseAnswerFragment
  )>, author?: Maybe<{ __typename?: 'PlexRegisteredUser', id: string, name: string, email: string, picture: string, jobTitle?: Maybe<string> }>, labels: Array<{ __typename?: 'Label', id: string, name: string }>, notification: (
    { __typename?: 'FaqNotification' }
    & FaqNotificationFragment
  ), positionInBoard: { __typename?: 'QuestionPosition', id: string, positionInBoard: number } };

export type TaskDetailsFragment = { __typename?: 'Task', id: string, permalink: string, type: TaskType, deleted: boolean, status: TaskStatus, publishStatus: PublishStatus, createdAt: any, title: string, dueDate?: Maybe<any>, body: Array<SlateNode>, currentUserRelation: TaskUserRelationState, labels: Array<{ __typename?: 'Label', id: string, name: string }>, mentions: Array<(
    { __typename?: 'PlexRegisteredUser' }
    & MentionsPlexRegisteredUserFragment
  )>, links: Array<(
    { __typename?: 'LinkMetadata' }
    & LinkPreviewMetadataFragment
  )>, plex: { __typename?: 'Plex', id: string, name: string, color?: Maybe<string>, currentUserRelation: (
      { __typename?: 'PlexUserRelation' }
      & FullPlexUserRelationFragment
    ) }, author: { __typename?: 'PlexRegisteredUser', id: string, name: string, picture: string, jobTitle?: Maybe<string> }, assignee?: Maybe<{ __typename?: 'PlexRegisteredUser', id: string, name: string, picture: string }>, relatedEntities: Array<(
    { __typename?: 'EntityRelation' }
    & TaskDetailsEntityRelationFragment
  )>, postContainer?: Maybe<(
    { __typename?: 'Post' }
    & PostDetailsFragment
  )> };

export type UserPlexesFragment = { __typename?: 'User', id: string, plexes?: Maybe<Array<(
    { __typename?: 'Plex' }
    & PlexOverviewFragment
  )>> };

export type UserSettingsFragment = { __typename?: 'User', name: string, email: string, givenName?: Maybe<string>, familyName?: Maybe<string>, picture: string, locale: string, hasExtraGSuiteScopes?: Maybe<boolean>, jobTitle?: Maybe<string>, jobDepartment?: Maybe<DepartmentEnum>, completedOnboardingSteps: Array<OnboardingStep>, defaultStatus: string, timeZone?: Maybe<string>, language?: Maybe<LanguageEnum>, displayFilter?: Maybe<boolean>, feedDisplay?: Maybe<boolean>, displayTimeline?: Maybe<boolean>, baseDisplay?: Maybe<boolean>, accessControl?: Maybe<AccessControlEnum>, status: UserStatus, domain?: Maybe<{ __typename?: 'Domain', id: string, orgName?: Maybe<string>, url?: Maybe<string>, industry?: Maybe<IndustryEnum>, email?: Maybe<string>, address?: Maybe<string>, authorizedDomain?: Maybe<boolean>, picture?: Maybe<string>, slackWorkspace?: Maybe<{ __typename?: 'SlackWorkspace', name?: Maybe<string>, slackId?: Maybe<string> }> }> };

export type FeedAnswerFragment = { __typename?: 'Answer', id: string, body: Array<SlateNode>, currentUserRelation: AnswerUserRelationState, deleted: boolean, primaryLink?: Maybe<{ __typename?: 'LinkMetadata', id: string, details: (
      { __typename?: 'PlexPostLinkMetadata' }
      & LinkPreviewMetadataDetails_PlexPostLinkMetadata_Fragment
    ) | (
      { __typename?: 'PlexFactLinkMetadata' }
      & LinkPreviewMetadataDetails_PlexFactLinkMetadata_Fragment
    ) | (
      { __typename?: 'ImageLinkMetadata' }
      & LinkPreviewMetadataDetails_ImageLinkMetadata_Fragment
    ) | (
      { __typename?: 'AttachmentLinkMetadata' }
      & LinkPreviewMetadataDetails_AttachmentLinkMetadata_Fragment
    ) | (
      { __typename?: 'GoogleDocLinkMetadata' }
      & LinkPreviewMetadataDetails_GoogleDocLinkMetadata_Fragment
    ) | (
      { __typename?: 'GoogleDriveFileLinkMetadata' }
      & LinkPreviewMetadataDetails_GoogleDriveFileLinkMetadata_Fragment
    ) | (
      { __typename?: 'GoogleSheetsLinkMetadata' }
      & LinkPreviewMetadataDetails_GoogleSheetsLinkMetadata_Fragment
    ) | (
      { __typename?: 'GoogleSlidesLinkMetadata' }
      & LinkPreviewMetadataDetails_GoogleSlidesLinkMetadata_Fragment
    ) | (
      { __typename?: 'GenericLink' }
      & LinkPreviewMetadataDetails_GenericLink_Fragment
    ) | (
      { __typename?: 'InvalidLink' }
      & LinkPreviewMetadataDetails_InvalidLink_Fragment
    ) }>, links: Array<(
    { __typename?: 'LinkMetadata' }
    & LinkPreviewMetadataFragment
  )>, mentions: Array<(
    { __typename?: 'PlexRegisteredUser' }
    & MentionsPlexRegisteredUserFragment
  )> };

export type FeedQuestionDetailsFragment = { __typename?: 'Question', id: string, boardId: string, type: CardType, text: string, createdAt: any, publishChangedAt: any, commentsCount: number, answersCount: number, status: QuestionStatus, currentUserReactions: Array<ReactionType>, currentUserRelation: QuestionUserRelationState, watching?: Maybe<boolean>, permalink: string, deleted: boolean, author?: Maybe<{ __typename?: 'PlexRegisteredUser', id: string, name: string, email: string, picture: string, jobTitle?: Maybe<string> }>, positionInBoard: { __typename?: 'QuestionPosition', id: string, positionInBoard: number }, acceptedAnswer?: Maybe<(
    { __typename?: 'Answer' }
    & FeedAnswerFragment
  )>, labels: Array<{ __typename?: 'Label', id: string, name: string }>, notification: { __typename?: 'FaqNotification', id: string, isRead: boolean } };

export type ApproveAnswerMutationVariables = Exact<{
  answerApproval: AnswerApproval;
}>;


export type ApproveAnswerMutation = { __typename?: 'Mutation', approveAnswer?: Maybe<{ __typename?: 'Question', id: string, acceptedAnswerId?: Maybe<string>, acceptedAnswer?: Maybe<(
      { __typename?: 'Answer' }
      & FullAnswerFragment
    )> }> };

export type ChangeBoardPositionMutationVariables = Exact<{
  input: ChangeBoardPositionInput;
}>;


export type ChangeBoardPositionMutation = { __typename?: 'Mutation', changeBoardPosition: { __typename?: 'BoardPositionUpdate', updatedPositions: Array<{ __typename?: 'BoardPosition', id: string, positionInPlex: number }> } };

export type ChangeQuestionPositionMutationVariables = Exact<{
  input: ChangeQuestionPositionInput;
}>;


export type ChangeQuestionPositionMutation = { __typename?: 'Mutation', changeQuestionPosition: { __typename?: 'QuestionPositionUpdate', positions: Array<{ __typename?: 'QuestionPosition', id: string, positionInBoard: number }> } };

export type CreateAnswerMutationVariables = Exact<{
  answer: CreateAnswerInput;
}>;


export type CreateAnswerMutation = { __typename?: 'Mutation', createAnswer?: Maybe<(
    { __typename?: 'Answer' }
    & FullAnswerFragment
  )> };

export type CreateBoardMutationVariables = Exact<{
  board: CreateBoardInput;
}>;


export type CreateBoardMutation = { __typename?: 'Mutation', createBoard?: Maybe<(
    { __typename?: 'Board' }
    & BoardDetailsFragment
  )> };

export type CreateBoardFromTemplateMutationVariables = Exact<{
  plexId: Scalars['String'];
  templateId: Scalars['String'];
  questionTemplateIds: Array<Scalars['String']>;
}>;


export type CreateBoardFromTemplateMutation = { __typename?: 'Mutation', createBoardFromTemplate: (
    { __typename?: 'Board' }
    & BoardDetailsFragment
  ) };

export type CreateEventMutationVariables = Exact<{
  event: CreateEventInput;
}>;


export type CreateEventMutation = { __typename?: 'Mutation', createEvent?: Maybe<(
    { __typename?: 'Post', plex: { __typename?: 'Plex', id: string, summary: { __typename?: 'PlexSummary', id: string, postsCount: number } } }
    & PostDetailsFragment
  )> };

export type CreateFactMutationVariables = Exact<{
  question: CreateQuestionInput;
  filterPublishStatus: FilterPublishStatus;
  labelIds: Array<Scalars['String']>;
}>;


export type CreateFactMutation = { __typename?: 'Mutation', createQuestion?: Maybe<(
    { __typename?: 'Question', board: (
      { __typename?: 'Board', faqCount: number }
      & BoardOverviewFragment
    ), plex: { __typename?: 'Plex', id: string, summary: { __typename?: 'PlexSummary', id: string, faqsCount: number } } }
    & QuestionDetailsFragment
  )> };

export type CreateFactReviewProcessMutationVariables = Exact<{
  input: CreateFactReviewProcessInput;
}>;


export type CreateFactReviewProcessMutation = { __typename?: 'Mutation', createFactReviewProcess: { __typename?: 'FactReviewProcess', id: string, createdEntities: Array<{ __typename?: 'EntityRelation', id: string, source?: Maybe<(
        { __typename: 'Task' }
        & TaskDetailsFragment
      ) | { __typename: 'FactReviewProcess' }> }> } };

export type CreateLabelMutationVariables = Exact<{
  name: Scalars['String'];
}>;


export type CreateLabelMutation = { __typename?: 'Mutation', createLabel?: Maybe<{ __typename?: 'Label', id: string, name: string }> };

export type CreatePlexMutationVariables = Exact<{
  plex: PlexInput;
}>;


export type CreatePlexMutation = { __typename?: 'Mutation', createPlex: (
    { __typename?: 'Plex' }
    & FullPlexFragment
  ) | (
    { __typename?: 'PlexInputError' }
    & FullPlexInputErrorFragment
  ) };

export type CreatePostMutationVariables = Exact<{
  post: CreatePostInput;
}>;


export type CreatePostMutation = { __typename?: 'Mutation', createPost?: Maybe<(
    { __typename?: 'Post', plex: { __typename?: 'Plex', id: string, summary: { __typename?: 'PlexSummary', id: string, postsCount: number } } }
    & PostDetailsFragment
  )> };

export type CreatePostCommentMutationVariables = Exact<{
  comment: CreatePostCommentInput;
}>;


export type CreatePostCommentMutation = { __typename?: 'Mutation', createPostComment?: Maybe<{ __typename?: 'Post', id: string, commentsCount: number, comments: Array<(
      { __typename?: 'Comment' }
      & FullCommentFragment
    )> }> };

export type CreateQuestionCommentMutationVariables = Exact<{
  comment: CreateQuestionCommentInput;
}>;


export type CreateQuestionCommentMutation = { __typename?: 'Mutation', createQuestionComment?: Maybe<{ __typename?: 'Question', id: string, comments: Array<(
      { __typename?: 'Comment' }
      & FullCommentFragment
    )> }> };

export type CreateTaskMutationVariables = Exact<{
  task: CreateTaskInput;
}>;


export type CreateTaskMutation = { __typename?: 'Mutation', createTask: (
    { __typename?: 'Task' }
    & TaskDetailsFragment
  ) };

export type CreateTaskEntityRelationMutationVariables = Exact<{
  sourceId: Scalars['String'];
  type: EntityRelationType;
  targetType: EntityType;
  targetId: Scalars['String'];
}>;


export type CreateTaskEntityRelationMutation = { __typename?: 'Mutation', createEntityRelation: { __typename?: 'EntityRelation', id: string, source?: Maybe<(
      { __typename: 'Task' }
      & TaskDetailsFragment
    ) | { __typename: 'FactReviewProcess' }> } };

export type CreateTaskUnderMilestoneMutationVariables = Exact<{
  task: CreateTaskInput;
}>;


export type CreateTaskUnderMilestoneMutation = { __typename?: 'Mutation', createTask: { __typename?: 'Task', id: string, relatedEntities: Array<{ __typename?: 'EntityRelation', id: string, target?: Maybe<(
        { __typename: 'Task' }
        & TaskDetailsFragment
      ) | { __typename: 'FactReviewProcess' }> }> } };

export type DeleteAnswerMutationVariables = Exact<{
  answerId: Scalars['String'];
}>;


export type DeleteAnswerMutation = { __typename?: 'Mutation', deleteAnswer?: Maybe<{ __typename?: 'Answer', id: string, deleted: boolean }> };

export type DeleteBoardMutationVariables = Exact<{
  boardId: Scalars['String'];
  faqDestinationBoard: Scalars['String'];
  deleteAllFaqs: Scalars['Boolean'];
}>;


export type DeleteBoardMutation = { __typename?: 'Mutation', deleteBoard?: Maybe<{ __typename?: 'Board', id: string, deleted: boolean }> };

export type DeleteCommentMutationVariables = Exact<{
  commentId: Scalars['String'];
}>;


export type DeleteCommentMutation = { __typename?: 'Mutation', deletePostComment?: Maybe<{ __typename?: 'Comment', id: string, deleted?: Maybe<boolean> }> };

export type DeleteNotificationActivityMutationVariables = Exact<{
  notificationActivityId: Scalars['String'];
}>;


export type DeleteNotificationActivityMutation = { __typename?: 'Mutation', deleteNotificationActivity?: Maybe<{ __typename?: 'NotificationActivity', id: string, deleted: boolean }> };

export type DeletePlexMutationVariables = Exact<{
  plexId: Scalars['String'];
}>;


export type DeletePlexMutation = { __typename?: 'Mutation', deletePlex?: Maybe<{ __typename?: 'Plex', id: string, deleted?: Maybe<boolean> }> };

export type DeletePostMutationVariables = Exact<{
  postId: Scalars['String'];
}>;


export type DeletePostMutation = { __typename?: 'Mutation', deletePost?: Maybe<{ __typename?: 'Post', id: string, deleted?: Maybe<boolean>, plex: { __typename?: 'Plex', id: string, summary: { __typename?: 'PlexSummary', id: string, postsCount: number } } }> };

export type DeleteQuestionMutationVariables = Exact<{
  questionId: Scalars['String'];
  filterPublishStatus: FilterPublishStatus;
  labelIds: Array<Scalars['String']>;
}>;


export type DeleteQuestionMutation = { __typename?: 'Mutation', deleteQuestion?: Maybe<{ __typename?: 'Question', id: string, deleted: boolean, board: { __typename?: 'Board', id: string, faqCount: number }, plex: { __typename?: 'Plex', id: string, summary: { __typename?: 'PlexSummary', id: string, faqsCount: number } } }> };

export type DeleteTaskMutationVariables = Exact<{
  taskId: Scalars['String'];
}>;


export type DeleteTaskMutation = { __typename?: 'Mutation', deleteTask: { __typename?: 'Task', id: string, deleted: boolean, postContainer?: Maybe<{ __typename?: 'Post', id: string, deleted?: Maybe<boolean> }> } };

export type IgnoreQuestionTemplateMutationVariables = Exact<{
  plexId: Scalars['String'];
  templateId: Scalars['String'];
}>;


export type IgnoreQuestionTemplateMutation = { __typename?: 'Mutation', ignoreQuestionTemplate?: Maybe<(
    { __typename?: 'Question' }
    & QuestionDetailsFragment
  )> };

export type ImportFactMutationVariables = Exact<{
  input: ImportFactInput;
  filterPublishStatus: FilterPublishStatus;
  labelIds: Array<Scalars['String']>;
}>;


export type ImportFactMutation = { __typename?: 'Mutation', importFact: (
    { __typename?: 'Question', board: (
      { __typename?: 'Board', faqCount: number }
      & BoardOverviewFragment
    ), plex: { __typename?: 'Plex', id: string, summary: { __typename?: 'PlexSummary', id: string, faqsCount: number } } }
    & QuestionDetailsFragment
  ) };

export type ImportFaqsFromGoogleDocMutationVariables = Exact<{
  input: ImportBoardInput;
}>;


export type ImportFaqsFromGoogleDocMutation = { __typename?: 'Mutation', importBoard?: Maybe<(
    { __typename?: 'Board' }
    & BoardDetailsFragment
  )> };

export type ImportGoogleCalendarEventMutationVariables = Exact<{
  event: GoogleCalendarEventInput;
}>;


export type ImportGoogleCalendarEventMutation = { __typename?: 'Mutation', importEventFromGoogleCalendar?: Maybe<(
    { __typename?: 'Post' }
    & PostDetailsFragment
  )> };

export type LeavePlexMutationVariables = Exact<{
  plexId: Scalars['String'];
}>;


export type LeavePlexMutation = { __typename?: 'Mutation', leavePlex?: Maybe<(
    { __typename?: 'PlexUserRelation' }
    & FullPlexUserRelationFragment
  )> };

export type PromoteCommentToAnswerMutationVariables = Exact<{
  commentId: Scalars['String'];
}>;


export type PromoteCommentToAnswerMutation = { __typename?: 'Mutation', promoteCommentToAnswer: (
    { __typename?: 'Question' }
    & QuestionDetailsFragment
  ) };

export type PublishFactMutationVariables = Exact<{
  publishQuestionInput: PublishQuestionInput;
}>;


export type PublishFactMutation = { __typename?: 'Mutation', publishQuestion?: Maybe<(
    { __typename?: 'Question' }
    & QuestionDetailsFragment
  )> };

export type PublishPostMutationVariables = Exact<{
  publishPostInput: PublishPostInput;
}>;


export type PublishPostMutation = { __typename?: 'Mutation', publishPost?: Maybe<(
    { __typename?: 'Post' }
    & PostDetailsFragment
  )> };

export type ReactToAnswerMutationVariables = Exact<{
  reaction: AnswerReactionInput;
}>;


export type ReactToAnswerMutation = { __typename?: 'Mutation', reactToAnswer?: Maybe<{ __typename?: 'Answer', id: string, currentUserReactions: Array<ReactionType>, reactionCounts: Array<{ __typename?: 'ReactionCount', type: ReactionType, count: number }> }> };

export type ReactToCommentMutationVariables = Exact<{
  reaction: ReactionInput;
}>;


export type ReactToCommentMutation = { __typename?: 'Mutation', reactToComment?: Maybe<{ __typename?: 'Comment', id: string, currentUserReactions: Array<ReactionType>, reactionCounts: Array<{ __typename?: 'ReactionCount', type: ReactionType, count: number }> }> };

export type ReactToQuestionMutationVariables = Exact<{
  reaction: QuestionReactionInput;
}>;


export type ReactToQuestionMutation = { __typename?: 'Mutation', reactToQuestion?: Maybe<{ __typename?: 'Question', id: string, currentUserReactions: Array<ReactionType>, reactionCounts: Array<{ __typename?: 'ReactionCount', type: ReactionType, count: number }> }> };

export type ResetOnboardingMutationVariables = Exact<{ [key: string]: never; }>;


export type ResetOnboardingMutation = { __typename?: 'Mutation', updateUserSettings?: Maybe<(
    { __typename?: 'User', id: string }
    & UserSettingsFragment
  )> };

export type SeenNotificationActivityMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type SeenNotificationActivityMutation = { __typename?: 'Mutation', seenNotificationActivity?: Maybe<(
    { __typename?: 'NotificationActivity' }
    & NotificationActivityFragment
  )> };

export type SeenUserNotificationsMutationVariables = Exact<{
  postsIds: Array<Scalars['String']>;
  faqsIds: Array<Scalars['String']>;
}>;


export type SeenUserNotificationsMutation = { __typename?: 'Mutation', seenUserNotifications?: Maybe<Array<(
    { __typename?: 'FaqNotification' }
    & FeedNotification_FaqNotification_Fragment
  ) | (
    { __typename?: 'PostNotification' }
    & FeedNotification_PostNotification_Fragment
  ) | (
    { __typename?: 'PlexNotification' }
    & FeedNotification_PlexNotification_Fragment
  )>> };

export type ShareMutationVariables = Exact<{
  shareInput: ShareInput;
}>;


export type ShareMutation = { __typename?: 'Mutation', share?: Maybe<{ __typename?: 'ShareResponse', id: string, sharedDate: any }> };

export type SubscribeToPlexMutationVariables = Exact<{
  plexId: Scalars['String'];
}>;


export type SubscribeToPlexMutation = { __typename?: 'Mutation', subscribeToPlex?: Maybe<(
    { __typename?: 'PlexUserRelation' }
    & FullPlexUserRelationFragment
  )> };

export type SyncBoardMutationVariables = Exact<{
  input: SyncBoardInput;
}>;


export type SyncBoardMutation = { __typename?: 'Mutation', syncBoard?: Maybe<(
    { __typename?: 'Board' }
    & BoardDetailsFragment
  )> };

export type UpdateAnswerMutationVariables = Exact<{
  answer: UpdateAnswerInput;
}>;


export type UpdateAnswerMutation = { __typename?: 'Mutation', updateAnswer?: Maybe<(
    { __typename?: 'Answer' }
    & FullAnswerFragment
  )> };

export type UpdateBoardMutationVariables = Exact<{
  id: Scalars['String'];
  board: UpdateBoardInput;
}>;


export type UpdateBoardMutation = { __typename?: 'Mutation', updateBoard?: Maybe<(
    { __typename?: 'Board' }
    & BoardDetailsFragment
  )> };

export type UpdateDomainUserMutationVariables = Exact<{
  userId: Scalars['String'];
  status?: Maybe<UserStatus>;
  accessControl?: Maybe<AccessControlEnum>;
}>;


export type UpdateDomainUserMutation = { __typename?: 'Mutation', updateDomainUser?: Maybe<{ __typename?: 'PlexRegisteredUser', id: string, email: string, name: string, picture: string, jobTitle?: Maybe<string>, status?: Maybe<UserStatus>, accessControl?: Maybe<AccessControlEnum> }> };

export type UpdateEventMutationVariables = Exact<{
  event: UpdateEventInput;
}>;


export type UpdateEventMutation = { __typename?: 'Mutation', updateEvent?: Maybe<(
    { __typename?: 'Post' }
    & PostDetailsFragment
  )> };

export type UpdateFactMutationVariables = Exact<{
  question: UpdateQuestionInput;
}>;


export type UpdateFactMutation = { __typename?: 'Mutation', updateQuestion?: Maybe<(
    { __typename?: 'Question' }
    & QuestionDetailsFragment
  )> };

export type UpdateFactReviewProcessMutationVariables = Exact<{
  input: UpdateFactReviewProcessInput;
}>;


export type UpdateFactReviewProcessMutation = { __typename?: 'Mutation', updateFactReviewProcess: (
    { __typename?: 'FactReviewProcess', id: string, createdEntities: Array<{ __typename?: 'EntityRelation', id: string, source?: Maybe<(
        { __typename: 'Task' }
        & TaskDetailsFragment
      ) | { __typename: 'FactReviewProcess' }> }> }
    & FactReviewProcessDetailsFragment
  ) };

export type UpdatePaymentInformationMutationVariables = Exact<{
  paymentMethodId?: Maybe<Scalars['String']>;
  billingEmail?: Maybe<Scalars['String']>;
  billingAddress?: Maybe<Scalars['String']>;
}>;


export type UpdatePaymentInformationMutation = { __typename?: 'Mutation', updatePaymentMethod: (
    { __typename?: 'Domain' }
    & PaymentInformationFragment
  ) };

export type UpdatePlexMutationVariables = Exact<{
  id: Scalars['String'];
  plex: PlexInput;
}>;


export type UpdatePlexMutation = { __typename?: 'Mutation', updatePlex: (
    { __typename?: 'Plex' }
    & FullPlexFragment
  ) | (
    { __typename?: 'PlexInputError' }
    & FullPlexInputErrorFragment
  ) };

export type UpdatePostMutationVariables = Exact<{
  post: UpdatePostInput;
}>;


export type UpdatePostMutation = { __typename?: 'Mutation', updatePost?: Maybe<(
    { __typename?: 'Post' }
    & PostDetailsFragment
  )> };

export type UpdateTaskMutationVariables = Exact<{
  task: UpdateTaskInput;
}>;


export type UpdateTaskMutation = { __typename?: 'Mutation', updateTask: (
    { __typename?: 'Task' }
    & TaskDetailsFragment
  ) };

export type UpdateUserSettingsMutationVariables = Exact<{
  userSettingsInput: UserSettingsInput;
}>;


export type UpdateUserSettingsMutation = { __typename?: 'Mutation', updateUserSettings?: Maybe<(
    { __typename?: 'User', id: string }
    & UserSettingsFragment
  )> };

export type UploadFileMutationVariables = Exact<{
  url: Scalars['String'];
}>;


export type UploadFileMutation = { __typename?: 'Mutation', uploadFile: { __typename?: 'UploadFileResponse', plexAssetUrl: string } };

export type WatchPostMutationVariables = Exact<{
  payload: WatchPostPayload;
}>;


export type WatchPostMutation = { __typename?: 'Mutation', watchPost?: Maybe<(
    { __typename?: 'Post' }
    & PostDetailsFragment
  )> };

export type WatchQuestionMutationVariables = Exact<{
  payload: WatchQuestionPayload;
}>;


export type WatchQuestionMutation = { __typename?: 'Mutation', watchQuestion?: Maybe<(
    { __typename?: 'Question' }
    & QuestionDetailsFragment
  )> };

export type AnalyticsPostClickMutationVariables = Exact<{
  postId: Scalars['String'];
}>;


export type AnalyticsPostClickMutation = { __typename?: 'Mutation', analyticsPostClick?: Maybe<boolean> };

export type AnalyticsPostImpressionMutationVariables = Exact<{
  postId: Scalars['String'];
}>;


export type AnalyticsPostImpressionMutation = { __typename?: 'Mutation', analyticsPostImpression?: Maybe<boolean> };

export type AnalyticsQuestionClickMutationVariables = Exact<{
  questionId: Scalars['String'];
}>;


export type AnalyticsQuestionClickMutation = { __typename?: 'Mutation', analyticsQuestionClick?: Maybe<boolean> };

export type AnalyticsQuestionImpressionMutationVariables = Exact<{
  questionId: Scalars['String'];
}>;


export type AnalyticsQuestionImpressionMutation = { __typename?: 'Mutation', analyticsQuestionImpression?: Maybe<boolean> };

export type DeleteTaskEntityRelationMutationVariables = Exact<{
  entityRelationId: Scalars['String'];
}>;


export type DeleteTaskEntityRelationMutation = { __typename?: 'Mutation', deleteEntityRelation: (
    { __typename?: 'EntityRelation' }
    & TaskDetailsEntityRelationFragment
  ) };

export type DomainPlexesQueryVariables = Exact<{
  cursor?: Maybe<Scalars['String']>;
}>;


export type DomainPlexesQuery = { __typename?: 'Query', currentUser?: Maybe<{ __typename?: 'User', id: string, domain?: Maybe<{ __typename?: 'Domain', id: string, plexes?: Maybe<{ __typename?: 'PlexesResponse', nextCursor?: Maybe<string>, items: Array<(
          { __typename?: 'Plex' }
          & PlexDomainSummaryFragment
        )> }> }> }> };

export type DomainSlackChannelsQueryVariables = Exact<{
  cursor?: Maybe<Scalars['String']>;
}>;


export type DomainSlackChannelsQuery = { __typename?: 'Query', currentUser?: Maybe<{ __typename?: 'User', id: string, domain?: Maybe<{ __typename?: 'Domain', id: string, slackChannels?: Maybe<{ __typename?: 'SlackChannelResponse', nextCursor?: Maybe<string>, results: Array<{ __typename?: 'SlackChannel', id: string, name: string }> }> }> }> };

export type GetBoardBeforeSyncQueryVariables = Exact<{
  boardId: Scalars['String'];
}>;


export type GetBoardBeforeSyncQuery = { __typename?: 'Query', loggedIn?: Maybe<{ __typename?: 'LoggedInQuery', boardById?: Maybe<{ __typename?: 'Board', id: string, plexId: string, source?: Maybe<{ __typename: 'GoogleDocumentSource', url: string, headingIds: Array<string> }>, questions: { __typename?: 'FetchQuestionsResponse', items: Array<{ __typename?: 'Question', id: string, source?: Maybe<{ __typename: 'GoogleDocumentSource', externalEntityId: string, headingIds: Array<string> }> }> } }> }> };

export type GetBoardByIdQueryVariables = Exact<{
  boardId: Scalars['String'];
}>;


export type GetBoardByIdQuery = { __typename?: 'Query', loggedIn?: Maybe<{ __typename?: 'LoggedInQuery', boardById?: Maybe<(
      { __typename?: 'Board' }
      & BoardDetailsFragment
    )> }> };

export type GetFeedQuestionsInBoardQueryVariables = Exact<{
  boardId: Scalars['String'];
  cursor?: Maybe<Scalars['Int']>;
  filterPublishStatus: FilterPublishStatus;
  labelIds: Array<Scalars['String']>;
}>;


export type GetFeedQuestionsInBoardQuery = { __typename?: 'Query', loggedIn?: Maybe<{ __typename?: 'LoggedInQuery', boardById?: Maybe<{ __typename?: 'Board', questions: { __typename?: 'FetchQuestionsResponse', nextCursor?: Maybe<number>, items: Array<(
          { __typename?: 'Question' }
          & FeedQuestionDetailsFragment
        )> } }> }> };

export type GetBoardTemplatesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetBoardTemplatesQuery = { __typename?: 'Query', boardTemplates: Array<(
    { __typename?: 'BoardTemplate' }
    & FullBoardTemplateFragment
  )> };

export type GetBoardsNamesQueryVariables = Exact<{
  plexId: Scalars['String'];
}>;


export type GetBoardsNamesQuery = { __typename?: 'Query', loggedIn?: Maybe<{ __typename?: 'LoggedInQuery', plexById?: Maybe<{ __typename?: 'Plex', id: string, boards: Array<{ __typename?: 'Board', id: string, name: string }> }> }> };

export type GetCommentQueryVariables = Exact<{
  commentId: Scalars['String'];
}>;


export type GetCommentQuery = { __typename?: 'Query', loggedIn?: Maybe<{ __typename?: 'LoggedInQuery', commentById?: Maybe<{ __typename?: 'Comment', id: string, body: Array<SlateNode>, question?: Maybe<{ __typename?: 'Question', id: string, boardId: string }>, post?: Maybe<{ __typename?: 'Post', id: string, plex: { __typename?: 'Plex', id: string, defaultBoardId: string } }> }> }> };

export type GetDocumentToImportQueryVariables = Exact<{
  url: Scalars['String'];
}>;


export type GetDocumentToImportQuery = { __typename?: 'Query', linkMetadata: { __typename?: 'LinkMetadata', details: { __typename: 'PlexPostLinkMetadata' } | { __typename: 'PlexFactLinkMetadata' } | { __typename: 'ImageLinkMetadata' } | { __typename: 'AttachmentLinkMetadata' } | { __typename: 'GoogleDocLinkMetadata', fileId: string, headingId?: Maybe<string>, bookmarkId?: Maybe<string>, fileMetadata?: Maybe<{ __typename?: 'GoogleDriveFileMetadata', externalEntityId: string }>, document?: Maybe<{ __typename: 'GoogleDocError', code: GoogleDocErrorCode } | { __typename: 'GoogleDoc', title: string, content: Array<SlateNode> }> } | { __typename: 'GoogleDriveFileLinkMetadata' } | { __typename: 'GoogleSheetsLinkMetadata' } | { __typename: 'GoogleSlidesLinkMetadata' } | { __typename: 'GenericLink' } | { __typename: 'InvalidLink' } } };

export type GetDomainUsersQueryVariables = Exact<{
  cursor?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
}>;


export type GetDomainUsersQuery = { __typename?: 'Query', currentUser?: Maybe<{ __typename?: 'User', id: string, domain?: Maybe<{ __typename?: 'Domain', id: string, users: { __typename?: 'DomainUsersResponse', nextCursor?: Maybe<string>, users: Array<{ __typename?: 'PlexRegisteredUser', id: string, email: string, name: string, picture: string, jobTitle?: Maybe<string>, status?: Maybe<UserStatus>, accessControl?: Maybe<AccessControlEnum> }> } }> }> };

export type GetFactAnswerDetailsQueryVariables = Exact<{
  factAnswerId: Scalars['String'];
}>;


export type GetFactAnswerDetailsQuery = { __typename?: 'Query', loggedIn?: Maybe<{ __typename?: 'LoggedInQuery', factAnswerById?: Maybe<(
      { __typename?: 'Answer' }
      & FullAnswerFragment
    )> }> };

export type GetFactReviewProcessQueryVariables = Exact<{
  factReviewProcessId: Scalars['String'];
}>;


export type GetFactReviewProcessQuery = { __typename?: 'Query', factReviewProcessById: (
    { __typename?: 'FactReviewProcess' }
    & FactReviewProcessDetailsFragment
  ) };

export type GetFeedBoardsQueryVariables = Exact<{
  cursor?: Maybe<Scalars['Int']>;
  plexIds: Array<Scalars['String']>;
  filterPublishStatus: FilterPublishStatus;
  labelIds: Array<Scalars['String']>;
}>;


export type GetFeedBoardsQuery = { __typename?: 'Query', loggedIn?: Maybe<{ __typename?: 'LoggedInQuery', feedBoards?: Maybe<{ __typename?: 'FeedBoardsResponse', nextCursor?: Maybe<number>, items: Array<(
        { __typename?: 'Board' }
        & FeedBoardResponseFragment
      )> }> }> };

export type GetGoogleCalendarEventsQueryVariables = Exact<{
  calendarId: Scalars['String'];
  startTimeMin?: Maybe<Scalars['DateTime']>;
  startTimeMax?: Maybe<Scalars['DateTime']>;
  limit?: Maybe<Scalars['Int']>;
  cursor?: Maybe<Scalars['String']>;
}>;


export type GetGoogleCalendarEventsQuery = { __typename?: 'Query', currentUser?: Maybe<{ __typename?: 'User', id: string, googleCalendarEvents?: Maybe<{ __typename?: 'GoogleCalendarEventsResponse', nextCursor?: Maybe<string>, events: Array<{ __typename?: 'GoogleCalendarEvent', id: string, summary?: Maybe<string>, description?: Maybe<string>, creator?: Maybe<string>, startTime?: Maybe<any> }> }> }> };

export type GetGoogleCalendarsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetGoogleCalendarsQuery = { __typename?: 'Query', currentUser?: Maybe<{ __typename?: 'User', id: string, googleCalendars?: Maybe<Array<{ __typename?: 'GoogleCalendar', id: string, summary?: Maybe<string>, description?: Maybe<string> }>> }> };

export type GetLabelsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLabelsQuery = { __typename?: 'Query', loggedIn?: Maybe<{ __typename?: 'LoggedInQuery', labels?: Maybe<Array<{ __typename?: 'Label', id: string, name: string }>> }> };

export type GetLinkMetadataQueryVariables = Exact<{
  url: Scalars['String'];
}>;


export type GetLinkMetadataQuery = { __typename?: 'Query', linkMetadata: (
    { __typename?: 'LinkMetadata' }
    & LinkPreviewMetadataFragment
  ) };

export type GetLoggedInUserQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLoggedInUserQuery = { __typename?: 'Query', currentUser?: Maybe<(
    { __typename?: 'User', id: string, email: string, status: UserStatus, plexes?: Maybe<Array<(
      { __typename?: 'Plex' }
      & PlexOverviewFragment
    )>>, domain?: Maybe<(
      { __typename?: 'Domain' }
      & DomainFragment
    )> }
    & UserSettingsFragment
  )> };

export type GetNotificationsActivityQueryVariables = Exact<{
  cursor?: Maybe<Scalars['Int']>;
}>;


export type GetNotificationsActivityQuery = { __typename?: 'Query', loggedIn?: Maybe<{ __typename?: 'LoggedInQuery', notificationsActivity?: Maybe<{ __typename?: 'NotificationsActivityResponse', nextCursor?: Maybe<number>, items: Array<(
        { __typename?: 'NotificationActivity' }
        & NotificationActivityFragment
      )> }> }> };

export type GetNotificationsActivityUnreadCountQueryVariables = Exact<{ [key: string]: never; }>;


export type GetNotificationsActivityUnreadCountQuery = { __typename?: 'Query', loggedIn?: Maybe<{ __typename?: 'LoggedInQuery', notificationsActivityUnreadCount?: Maybe<number> }> };

export type GetPaymentInformationQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPaymentInformationQuery = { __typename?: 'Query', currentUser?: Maybe<{ __typename?: 'User', id: string, domain?: Maybe<(
      { __typename?: 'Domain' }
      & PaymentInformationFragment
    )> }> };

export type GetPlexQueryVariables = Exact<{
  plexId: Scalars['String'];
}>;


export type GetPlexQuery = { __typename?: 'Query', loggedIn?: Maybe<{ __typename?: 'LoggedInQuery', plexById?: Maybe<(
      { __typename?: 'Plex' }
      & FullPlexFragment
    )> }> };

export type GetPlexDetailsQueryVariables = Exact<{
  plexId: Scalars['String'];
}>;


export type GetPlexDetailsQuery = { __typename?: 'Query', loggedIn?: Maybe<{ __typename?: 'LoggedInQuery', plexById?: Maybe<(
      { __typename?: 'Plex' }
      & PlexDetailsFragment
    )> }> };

export type GetPlexGoogleCalendarsQueryVariables = Exact<{
  plexId: Scalars['String'];
}>;


export type GetPlexGoogleCalendarsQuery = { __typename?: 'Query', loggedIn?: Maybe<{ __typename?: 'LoggedInQuery', plexById?: Maybe<{ __typename?: 'Plex', id: string, googleCalendars: Array<{ __typename?: 'PlexGoogleCalendar', id: string, googleCalendarId: string, description?: Maybe<string>, summary?: Maybe<string> }> }> }> };

export type GetPlexOverviewQueryVariables = Exact<{
  plexId: Scalars['String'];
}>;


export type GetPlexOverviewQuery = { __typename?: 'Query', loggedIn?: Maybe<{ __typename?: 'LoggedInQuery', plexById?: Maybe<(
      { __typename?: 'Plex' }
      & PlexOverviewFragment
    )> }> };

export type GetPlexSummaryQueryVariables = Exact<{
  plexId: Scalars['String'];
}>;


export type GetPlexSummaryQuery = { __typename?: 'Query', loggedIn?: Maybe<{ __typename?: 'LoggedInQuery', plexById?: Maybe<(
      { __typename?: 'Plex' }
      & PlexSummaryFragment
    )> }> };

export type GetPostCommentsQueryVariables = Exact<{
  postId: Scalars['String'];
}>;


export type GetPostCommentsQuery = { __typename?: 'Query', loggedIn?: Maybe<{ __typename?: 'LoggedInQuery', postById?: Maybe<{ __typename?: 'Post', id: string, deleted?: Maybe<boolean>, comments: Array<(
        { __typename?: 'Comment' }
        & FullCommentFragment
      )> }> }> };

export type GetPostQueryVariables = Exact<{
  postId: Scalars['String'];
}>;


export type GetPostQuery = { __typename?: 'Query', loggedIn?: Maybe<{ __typename?: 'LoggedInQuery', postById?: Maybe<(
      { __typename?: 'Post' }
      & PostDetailsFragment
    )> }> };

export type GetPostsQueryVariables = Exact<{
  cursor?: Maybe<Scalars['String']>;
  plexIds: Array<Scalars['String']>;
  types: Array<PostType>;
  publishStatuses: Array<PublishStatus>;
  labelIds: Array<Scalars['String']>;
}>;


export type GetPostsQuery = { __typename?: 'Query', posts: { __typename?: 'PostsResponse', nextCursor?: Maybe<string>, items: Array<(
      { __typename?: 'Post' }
      & FeedPostDetailsFragment
    )> } };

export type GetQuestionCommentsQueryVariables = Exact<{
  questionId: Scalars['String'];
}>;


export type GetQuestionCommentsQuery = { __typename?: 'Query', loggedIn?: Maybe<{ __typename?: 'LoggedInQuery', questionById?: Maybe<{ __typename?: 'Question', id: string, comments: Array<(
        { __typename?: 'Comment' }
        & FullCommentFragment
      )> }> }> };

export type GetQuestionDetailsQueryVariables = Exact<{
  questionId: Scalars['String'];
}>;


export type GetQuestionDetailsQuery = { __typename?: 'Query', loggedIn?: Maybe<{ __typename?: 'LoggedInQuery', questionById?: Maybe<(
      { __typename?: 'Question' }
      & QuestionDetailsFragment
    )> }> };

export type GetStripePublicKeyQueryVariables = Exact<{ [key: string]: never; }>;


export type GetStripePublicKeyQuery = { __typename?: 'Query', loggedIn?: Maybe<{ __typename?: 'LoggedInQuery', stripePublicKey?: Maybe<string> }> };

export type GetTaskDetailsQueryVariables = Exact<{
  taskId: Scalars['String'];
}>;


export type GetTaskDetailsQuery = { __typename?: 'Query', taskById: (
    { __typename?: 'Task' }
    & TaskDetailsFragment
  ) };

export type GetTasksQueryVariables = Exact<{
  cursor?: Maybe<Scalars['String']>;
  plexIds: Array<Scalars['String']>;
  publishStatuses: Array<PublishStatus>;
  types: Array<TaskType>;
  labelIds: Array<Scalars['String']>;
  order: TasksOrder;
}>;


export type GetTasksQuery = { __typename?: 'Query', tasks: { __typename?: 'TasksResponse', nextCursor?: Maybe<string>, items: Array<{ __typename?: 'Task', id: string, permalink: string, type: TaskType, publishStatus: PublishStatus, status: TaskStatus, title: string, body: Array<SlateNode>, dueDate?: Maybe<any>, deleted: boolean, assignee?: Maybe<{ __typename?: 'PlexRegisteredUser', id: string, name: string, picture: string }>, mentions: Array<(
        { __typename?: 'PlexRegisteredUser' }
        & MentionsPlexRegisteredUserFragment
      )>, links: Array<(
        { __typename?: 'LinkMetadata' }
        & LinkPreviewMetadataFragment
      )>, author: { __typename?: 'PlexRegisteredUser', id: string, name: string }, plex: { __typename?: 'Plex', id: string, name: string, color?: Maybe<string> }, labels: Array<{ __typename?: 'Label', id: string, name: string }> }> } };

export type GetTimelineQueryVariables = Exact<{
  cursor?: Maybe<Scalars['String']>;
  plexIds: Array<Scalars['String']>;
  publishStatuses: Array<PublishStatus>;
  labelIds: Array<Scalars['String']>;
  before: Scalars['DateTime'];
  onOrAfter: Scalars['DateTime'];
  types: Array<PostType>;
}>;


export type GetTimelineQuery = { __typename?: 'Query', posts: { __typename?: 'PostsResponse', nextCursor?: Maybe<string>, items: Array<(
      { __typename?: 'Post' }
      & FeedPostDetailsFragment
    )> } };

export type GetUserNotificationsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserNotificationsQuery = { __typename?: 'Query', loggedIn?: Maybe<{ __typename: 'LoggedInQuery', notifications?: Maybe<Array<(
      { __typename: 'FaqNotification' }
      & FeedNotification_FaqNotification_Fragment
    ) | (
      { __typename: 'PostNotification' }
      & FeedNotification_PostNotification_Fragment
    ) | (
      { __typename: 'PlexNotification' }
      & FeedNotification_PlexNotification_Fragment
    )>> }> };

export type SearchCollaboratorsQueryVariables = Exact<{
  query?: Maybe<Scalars['String']>;
  onlySignedUpUsers?: Maybe<Scalars['Boolean']>;
}>;


export type SearchCollaboratorsQuery = { __typename?: 'Query', loggedIn?: Maybe<{ __typename?: 'LoggedInQuery', searchUsers?: Maybe<{ __typename?: 'SearchUsersResponse', results: Array<{ __typename?: 'SearchUser', id: string, plexUserId?: Maybe<string>, name?: Maybe<string>, email: string, picture?: Maybe<string>, source: UserSource }> }> }> };

export type SearchEverythingQueryVariables = Exact<{
  query: Scalars['String'];
  cursor?: Maybe<Scalars['String']>;
  filters: SearchFilters;
  sortOrder: SearchSortOrder;
}>;


export type SearchEverythingQuery = { __typename?: 'Query', currentUser?: Maybe<{ __typename: 'User', id: string, domain?: Maybe<{ __typename: 'Domain', id: string, search?: Maybe<{ __typename?: 'SearchResponse', nextCursor?: Maybe<string>, items: Array<{ __typename: 'SearchResult', id: string, body: { __typename: 'SearchPostBody', permalink: string, title?: Maybe<string>, author?: Maybe<string>, body?: Maybe<string>, createdAt?: Maybe<any>, updatedAt?: Maybe<any>, publishStatus?: Maybe<PublishStatus>, postType?: Maybe<PostType>, plexId?: Maybe<string> } | { __typename: 'SearchQuestionBody', permalink: string, text?: Maybe<string>, author?: Maybe<string>, createdAt?: Maybe<any>, updatedAt?: Maybe<any>, questionStatus?: Maybe<QuestionStatus>, plexId?: Maybe<string>, acceptedAnswerBody?: Maybe<string> } }> }> }> }> };

export type GetAnalyticsItemsQueryVariables = Exact<{
  plexId: Scalars['String'];
  targetType: AnalyticsItemType;
  cursor?: Maybe<Scalars['Int']>;
  timeOrder: TimeOrder;
}>;


export type GetAnalyticsItemsQuery = { __typename?: 'Query', loggedIn?: Maybe<{ __typename?: 'LoggedInQuery', plexById?: Maybe<{ __typename?: 'Plex', id: string, analytics: { __typename?: 'AnalyticsSummary', items: (
          { __typename?: 'AnalyticsItems' }
          & AnalyticsItemsFragment
        ) } }> }> };

export type GetAnalyticsSummaryQueryVariables = Exact<{
  plexId: Scalars['String'];
  targetType: AnalyticsItemType;
  cursor?: Maybe<Scalars['Int']>;
  timeOrder: TimeOrder;
}>;


export type GetAnalyticsSummaryQuery = { __typename?: 'Query', loggedIn?: Maybe<{ __typename?: 'LoggedInQuery', plexById?: Maybe<{ __typename?: 'Plex', id: string, name: string, analytics: { __typename?: 'AnalyticsSummary', audience: number, impressions: number, clicks: number, commentsCount: number, reactionsCount: number, items: (
          { __typename?: 'AnalyticsItems' }
          & AnalyticsItemsFragment
        ) } }> }> };

export type GetPostAnalyticsQueryVariables = Exact<{
  postId: Scalars['String'];
}>;


export type GetPostAnalyticsQuery = { __typename?: 'Query', loggedIn?: Maybe<{ __typename?: 'LoggedInQuery', postById?: Maybe<{ __typename?: 'Post', id: string, title: string, publishStatus: PublishStatus, publishedDate: any, deleted?: Maybe<boolean>, analytics?: Maybe<(
        { __typename?: 'FeedItemAnalytics' }
        & AnalyticsOneItemFragment
      )>, plex: { __typename?: 'Plex', id: string, name: string, color?: Maybe<string> } }> }> };

export type GetQuestionAnalyticsQueryVariables = Exact<{
  questionId: Scalars['String'];
}>;


export type GetQuestionAnalyticsQuery = { __typename?: 'Query', loggedIn?: Maybe<{ __typename?: 'LoggedInQuery', questionById?: Maybe<{ __typename?: 'Question', id: string, text: string, status: QuestionStatus, publishChangedAt: any, deleted: boolean, analytics?: Maybe<(
        { __typename?: 'FeedItemAnalytics' }
        & AnalyticsOneItemFragment
      )>, plex: { __typename?: 'Plex', id: string, name: string, color?: Maybe<string> } }> }> };

export type GetAnswersSubscriptionSubscriptionVariables = Exact<{
  questionId: Scalars['String'];
}>;


export type GetAnswersSubscriptionSubscription = { __typename?: 'Subscription', answer?: Maybe<(
    { __typename?: 'Answer' }
    & FullAnswerFragment
  )> };

export type GetBoardsSubscriptionSubscriptionVariables = Exact<{
  plexIds: Array<Scalars['String']>;
  filterPublishStatus: FilterPublishStatus;
  labelIds: Array<Scalars['String']>;
}>;


export type GetBoardsSubscriptionSubscription = { __typename?: 'Subscription', board: (
    { __typename?: 'Board', faqCount: number, deleted: boolean, questions: { __typename?: 'FetchQuestionsResponse', nextCursor?: Maybe<number>, items: Array<(
        { __typename?: 'Question' }
        & FeedQuestionDetailsFragment
      )> } }
    & BoardOverviewFragment
  ) };

export type GetCommentsSubscriptionSubscriptionVariables = Exact<{
  id: Scalars['String'];
  isPost: Scalars['Boolean'];
}>;


export type GetCommentsSubscriptionSubscription = { __typename?: 'Subscription', comment?: Maybe<(
    { __typename?: 'Comment' }
    & FullCommentFragment
  )> };

export type GetNotificationActivitySubscriptionVariables = Exact<{ [key: string]: never; }>;


export type GetNotificationActivitySubscription = { __typename?: 'Subscription', notificationActivity: (
    { __typename?: 'NotificationActivity', totalUnreadCount: number }
    & NotificationActivityFragment
  ) };

export type GetUserNotificationsSubscriptionSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type GetUserNotificationsSubscriptionSubscription = { __typename?: 'Subscription', userNotifications: { __typename?: 'NotificationSubscriptionPayload', notifications: Array<(
      { __typename?: 'FaqNotification' }
      & FeedNotification_FaqNotification_Fragment
    ) | (
      { __typename?: 'PostNotification' }
      & FeedNotification_PostNotification_Fragment
    ) | (
      { __typename?: 'PlexNotification' }
      & FeedNotification_PlexNotification_Fragment
    )> } };

export type GetPostsSubscriptionSubscriptionVariables = Exact<{
  plexIds: Array<Scalars['String']>;
  types: Array<PostType>;
  publishStatuses: Array<PublishStatus>;
  labelIds: Array<Scalars['String']>;
  before?: Maybe<Scalars['DateTime']>;
  onOrAfter?: Maybe<Scalars['DateTime']>;
}>;


export type GetPostsSubscriptionSubscription = { __typename?: 'Subscription', posts: (
    { __typename?: 'Post', comments: Array<(
      { __typename?: 'Comment' }
      & FullCommentFragment
    )>, plex: { __typename?: 'Plex', id: string, summary: { __typename?: 'PlexSummary', id: string, postsCount: number } } }
    & PostDetailsFragment
  ) };

export type GetQuestionPositionSubscriptionSubscriptionVariables = Exact<{
  boardId: Scalars['String'];
}>;


export type GetQuestionPositionSubscriptionSubscription = { __typename?: 'Subscription', questionPosition: { __typename?: 'QuestionPositionUpdate', boardId: string, positions: Array<{ __typename?: 'QuestionPosition', id: string, positionInBoard: number }> } };

export type GetQuestionsSubscriptionSubscriptionVariables = Exact<{
  boardId: Scalars['String'];
  filterPublishStatus: FilterPublishStatus;
  labelIds: Array<Scalars['String']>;
}>;


export type GetQuestionsSubscriptionSubscription = { __typename?: 'Subscription', question?: Maybe<(
    { __typename?: 'Question', plex: { __typename?: 'Plex', id: string, summary: { __typename?: 'PlexSummary', id: string, faqsCount: number } } }
    & FeedQuestionDetailsFragment
  )> };

export const MentionsPlexRegisteredUserFragmentDoc = gql`
    fragment mentionsPlexRegisteredUser on PlexRegisteredUser {
  email
  name
}
    `;
export const PlexPostLinkMetadataFragmentDoc = gql`
    fragment plexPostLinkMetadata on PlexPostLinkMetadata {
  post {
    id
    permalink
    title
    plex {
      id
      name
    }
  }
}
    `;
export const PlexFactLinkMetadataFragmentDoc = gql`
    fragment plexFactLinkMetadata on PlexFactLinkMetadata {
  fact {
    id
    permalink
    text
    plex {
      id
      name
    }
  }
}
    `;
export const GoogleDocLinkMetadataFragmentDoc = gql`
    fragment googleDocLinkMetadata on GoogleDocLinkMetadata {
  fileMetadata {
    title
  }
}
    `;
export const GoogleDriveFileLinkMetadataFragmentDoc = gql`
    fragment googleDriveFileLinkMetadata on GoogleDriveFileLinkMetadata {
  fileMetadata {
    title
    extension
  }
}
    `;
export const GoogleSheetsLinkMetadataFragmentDoc = gql`
    fragment googleSheetsLinkMetadata on GoogleSheetsLinkMetadata {
  fileMetadata {
    title
  }
}
    `;
export const GoogleSlidesLinkMetadataFragmentDoc = gql`
    fragment googleSlidesLinkMetadata on GoogleSlidesLinkMetadata {
  fileMetadata {
    title
  }
}
    `;
export const ImageLinkMetadataFragmentDoc = gql`
    fragment imageLinkMetadata on ImageLinkMetadata {
  url
}
    `;
export const AttachmentLinkMetadataFragmentDoc = gql`
    fragment attachmentLinkMetadata on AttachmentLinkMetadata {
  url
  extension
}
    `;
export const GenericLinkMetadataFragmentDoc = gql`
    fragment genericLinkMetadata on GenericLink {
  url
}
    `;
export const InvalidLinkMetadataFragmentDoc = gql`
    fragment invalidLinkMetadata on InvalidLink {
  url
}
    `;
export const LinkPreviewMetadataDetailsFragmentDoc = gql`
    fragment linkPreviewMetadataDetails on LinkMetadataDetails {
  __typename
  ... on PlexPostLinkMetadata {
    ...plexPostLinkMetadata
  }
  ... on PlexFactLinkMetadata {
    ...plexFactLinkMetadata
  }
  ... on GoogleDocLinkMetadata {
    ...googleDocLinkMetadata
  }
  ... on GoogleDriveFileLinkMetadata {
    ...googleDriveFileLinkMetadata
  }
  ... on GoogleSheetsLinkMetadata {
    ...googleSheetsLinkMetadata
  }
  ... on GoogleSlidesLinkMetadata {
    ...googleSlidesLinkMetadata
  }
  ... on ImageLinkMetadata {
    ...imageLinkMetadata
  }
  ... on AttachmentLinkMetadata {
    ...attachmentLinkMetadata
  }
  ... on GenericLink {
    ...genericLinkMetadata
  }
  ... on InvalidLink {
    ...invalidLinkMetadata
  }
}
    ${PlexPostLinkMetadataFragmentDoc}
${PlexFactLinkMetadataFragmentDoc}
${GoogleDocLinkMetadataFragmentDoc}
${GoogleDriveFileLinkMetadataFragmentDoc}
${GoogleSheetsLinkMetadataFragmentDoc}
${GoogleSlidesLinkMetadataFragmentDoc}
${ImageLinkMetadataFragmentDoc}
${AttachmentLinkMetadataFragmentDoc}
${GenericLinkMetadataFragmentDoc}
${InvalidLinkMetadataFragmentDoc}`;
export const LinkPreviewMetadataFragmentDoc = gql`
    fragment linkPreviewMetadata on LinkMetadata {
  id
  details {
    ...linkPreviewMetadataDetails
  }
}
    ${LinkPreviewMetadataDetailsFragmentDoc}`;
export const AnalyticsItemsFragmentDoc = gql`
    fragment analyticsItems on AnalyticsItems {
  posts {
    items {
      id
      title
      body
      mentions {
        ...mentionsPlexRegisteredUser
      }
      links {
        ...linkPreviewMetadata
      }
      analytics {
        audience
        impressions
        clicks
        commentsCount
        reactionsCount
      }
    }
    nextCursor
  }
  questions {
    items {
      id
      text
      acceptedAnswer {
        body
        mentions {
          ...mentionsPlexRegisteredUser
        }
        links {
          ...linkPreviewMetadata
        }
      }
      analytics {
        audience
        impressions
        clicks
        commentsCount
        reactionsCount
      }
    }
    nextCursor
  }
}
    ${MentionsPlexRegisteredUserFragmentDoc}
${LinkPreviewMetadataFragmentDoc}`;
export const UserWithTimestampFragmentDoc = gql`
    fragment userWithTimestamp on UserWithTimestamp {
  user {
    id
    name
    picture
    jobTitle
  }
  atDate
}
    `;
export const AnalyticsOneItemFragmentDoc = gql`
    fragment analyticsOneItem on FeedItemAnalytics {
  audience
  impressions
  clicks
  commentsCount
  reactionsCount
  audienceBy {
    ...userWithTimestamp
  }
  impressionsBy {
    ...userWithTimestamp
  }
  clicksBy {
    ...userWithTimestamp
  }
}
    ${UserWithTimestampFragmentDoc}`;
export const FullPlexUserRelationFragmentDoc = gql`
    fragment fullPlexUserRelation on PlexUserRelation {
  id
  role
  state
}
    `;
export const BoardOverviewFragmentDoc = gql`
    fragment boardOverview on Board {
  id
  name
  description
  plexId
  position {
    id
    positionInPlex
  }
  plex {
    id
    name
    currentUserRelation {
      ...fullPlexUserRelation
    }
  }
  source {
    __typename
    ... on GoogleDocumentSource {
      url
    }
  }
}
    ${FullPlexUserRelationFragmentDoc}`;
export const BoardDetailsFragmentDoc = gql`
    fragment boardDetails on Board {
  ...boardOverview
  plex {
    id
    name
    color
    defaultBoardId
    currentUserRelation {
      ...fullPlexUserRelation
    }
  }
}
    ${BoardOverviewFragmentDoc}
${FullPlexUserRelationFragmentDoc}`;
export const FeedAnswerFragmentDoc = gql`
    fragment feedAnswer on Answer {
  id
  body
  primaryLink {
    id
    details {
      ...linkPreviewMetadataDetails
    }
  }
  currentUserRelation
  links {
    ...linkPreviewMetadata
  }
  mentions {
    ...mentionsPlexRegisteredUser
  }
  deleted
}
    ${LinkPreviewMetadataDetailsFragmentDoc}
${LinkPreviewMetadataFragmentDoc}
${MentionsPlexRegisteredUserFragmentDoc}`;
export const FeedQuestionDetailsFragmentDoc = gql`
    fragment feedQuestionDetails on Question {
  id
  author {
    id
    name
    email
    picture
    jobTitle
  }
  boardId
  type
  text
  createdAt
  publishChangedAt
  commentsCount
  positionInBoard {
    id
    positionInBoard
  }
  acceptedAnswer {
    ...feedAnswer
  }
  answersCount
  labels {
    id
    name
  }
  status
  notification {
    id
    isRead
  }
  currentUserReactions
  currentUserRelation
  watching
  permalink
  deleted
}
    ${FeedAnswerFragmentDoc}`;
export const FeedBoardResponseFragmentDoc = gql`
    fragment feedBoardResponse on Board {
  ...boardOverview
  questions(filterPublishStatus: $filterPublishStatus, labelIds: $labelIds) {
    items {
      ...feedQuestionDetails
    }
    nextCursor
  }
  faqCount(filterPublishStatus: $filterPublishStatus, labelIds: $labelIds)
  deleted
}
    ${BoardOverviewFragmentDoc}
${FeedQuestionDetailsFragmentDoc}`;
export const FullBoardTemplateFragmentDoc = gql`
    fragment fullBoardTemplate on BoardTemplate {
  id
  name
  templates {
    id
    text
  }
}
    `;
export const FullCommentFragmentDoc = gql`
    fragment fullComment on Comment {
  id
  deleted
  type
  body
  links {
    ...linkPreviewMetadata
  }
  mentions {
    ...mentionsPlexRegisteredUser
  }
  currentUserReactions
  externalSource
  commenter {
    id
    name
    picture
    jobTitle
  }
  createdAt
  reactionCounts {
    type
    count
  }
}
    ${LinkPreviewMetadataFragmentDoc}
${MentionsPlexRegisteredUserFragmentDoc}`;
export const DomainFragmentDoc = gql`
    fragment domain on Domain {
  id
  url
  orgName
  industry
  email
  address
  authorizedDomain
  slackWorkspace {
    name
    slackId
  }
  picture
  isBillingCurrent
}
    `;
export const PaymentInformationFragmentDoc = gql`
    fragment paymentInformation on Domain {
  id
  paymentInformation {
    id
    cardholderName
    cardBrand
    cardLastFourDigits
    cardExpiration
    billingEmail
    billingAddress
  }
  subscriptionInformation {
    id
    numberOfSeats
    status
    trialEnd
    currentPeriodEnd
  }
  isBillingCurrent
}
    `;
export const FactReviewProcessDetailsFragmentDoc = gql`
    fragment factReviewProcessDetails on FactReviewProcess {
  id
  fact {
    id
    text
    permalink
  }
  plex {
    id
    name
    color
  }
  authors {
    id
    name
    picture
  }
  reviewableBy
  reviewers {
    id
    name
    picture
  }
  reviewBy
}
    `;
export const PostNotificationFragmentDoc = gql`
    fragment postNotification on PostNotification {
  __typename
  id
  isRead
}
    `;
export const FaqNotificationFragmentDoc = gql`
    fragment faqNotification on FaqNotification {
  __typename
  id
  isRead
}
    `;
export const PlexNotificationFragmentDoc = gql`
    fragment plexNotification on PlexNotification {
  __typename
  id
  count
}
    `;
export const FeedNotificationFragmentDoc = gql`
    fragment feedNotification on FeedNotification {
  __typename
  ... on PostNotification {
    __typename
    ...postNotification
  }
  ... on FaqNotification {
    __typename
    ...faqNotification
  }
  ... on PlexNotification {
    __typename
    ...plexNotification
  }
}
    ${PostNotificationFragmentDoc}
${FaqNotificationFragmentDoc}
${PlexNotificationFragmentDoc}`;
export const ChangeEventPostDetailsFragmentDoc = gql`
    fragment changeEventPostDetails on Post {
  id
  permalink
  currentUserRelation
  deleted
  plex {
    id
    name
    color
    currentUserRelation {
      ...fullPlexUserRelation
    }
  }
  title
  body
  publishStatus
  publishedDate
  author {
    id
    name
    picture
    jobTitle
  }
  labels {
    id
    name
  }
  type
  eventDate
  watching
}
    ${FullPlexUserRelationFragmentDoc}`;
export const ChangeEventAnswerFragmentDoc = gql`
    fragment changeEventAnswer on Answer {
  id
  body
  publishedAt
  user {
    id
    name
    picture
    email
    jobTitle
  }
  question {
    id
    permalink
    text
    plex {
      id
      name
      currentUserRelation {
        id
        state
      }
    }
  }
  currentUserRelation
  deleted
}
    `;
export const ChangeEventQuestionOverviewFragmentDoc = gql`
    fragment changeEventQuestionOverview on Question {
  id
  permalink
  text
  status
  plex {
    id
    name
    color
    currentUserRelation {
      ...fullPlexUserRelation
    }
  }
  acceptedAnswer {
    ...changeEventAnswer
  }
  deleted
  createdAt
  publishChangedAt
  author {
    id
    name
    email
    picture
    jobTitle
  }
  labels {
    id
    name
  }
  currentUserRelation
  watching
  boardId
}
    ${FullPlexUserRelationFragmentDoc}
${ChangeEventAnswerFragmentDoc}`;
export const ChangeEventCommentFragmentDoc = gql`
    fragment changeEventComment on Comment {
  id
  deleted
  type
  body
  currentUserReactions
  mentions {
    ...mentionsPlexRegisteredUser
  }
  links {
    ...linkPreviewMetadata
  }
  commenter {
    id
    name
    picture
    jobTitle
  }
  createdAt
}
    ${MentionsPlexRegisteredUserFragmentDoc}
${LinkPreviewMetadataFragmentDoc}`;
export const ChangeEventFragmentDoc = gql`
    fragment changeEvent on ChangeEvent {
  id
  author {
    id
    name
    picture
    email
    jobTitle
  }
  plex {
    id
    name
    color
  }
  createdAt
  eventType
  targetType
  eventTarget {
    ... on ChangeEventTargetBoard {
      board {
        id
        name
        faqCount(filterPublishStatus: ALL, labelIds: [])
      }
    }
    ... on ChangeEventTargetPost {
      post {
        ...changeEventPostDetails
      }
    }
    ... on ChangeEventTargetEvent {
      event {
        ...changeEventPostDetails
      }
    }
    ... on ChangeEventTargetQuestion {
      question {
        ...changeEventQuestionOverview
      }
    }
    ... on ChangeEventTargetAnswer {
      answer {
        ...changeEventAnswer
      }
    }
    ... on ChangeEventTargetComment {
      comment {
        post {
          ...changeEventPostDetails
        }
        question {
          ...changeEventQuestionOverview
        }
        ...changeEventComment
      }
    }
  }
  updateDeltaBefore {
    v1 {
      post {
        mentions
      }
      question {
        acceptedAnswerId
      }
      answer {
        mentions
      }
    }
  }
  updateDeltaAfter {
    v1 {
      post {
        mentions
      }
      question {
        acceptedAnswerId
      }
      answer {
        mentions
      }
    }
  }
}
    ${ChangeEventPostDetailsFragmentDoc}
${ChangeEventQuestionOverviewFragmentDoc}
${ChangeEventAnswerFragmentDoc}
${ChangeEventCommentFragmentDoc}`;
export const NotificationActivityFragmentDoc = gql`
    fragment notificationActivity on NotificationActivity {
  id
  isRead
  event {
    ...changeEvent
  }
  deleted
}
    ${ChangeEventFragmentDoc}`;
export const PlexOverviewFragmentDoc = gql`
    fragment plexOverview on Plex {
  id
  permalink
  name
  color
  deleted
  notifications {
    ...plexNotification
  }
  currentUserRelation {
    ...fullPlexUserRelation
  }
  defaultBoardId
}
    ${PlexNotificationFragmentDoc}
${FullPlexUserRelationFragmentDoc}`;
export const FullPlexFragmentDoc = gql`
    fragment fullPlex on Plex {
  id
  name
  color
  description
  channels {
    id
    type
    name
    externalId
  }
  googleCalendars {
    id
    googleCalendarId
    description
    summary
  }
  settings {
    members {
      user {
        __typename
        ... on PlexRegisteredUser {
          id
          email
          name
          picture
        }
        ... on PlexInvitedUser {
          email
        }
      }
      role
    }
  }
  defaultBoardId
  deleted
  ...plexOverview
}
    ${PlexOverviewFragmentDoc}`;
export const PlexQuestionTemplateDetailsFragmentDoc = gql`
    fragment plexQuestionTemplateDetails on PlexQuestionTemplate {
  id
  questionTemplateId
  text
  question {
    id
    status
    deleted
  }
}
    `;
export const PlexDetailsFragmentDoc = gql`
    fragment plexDetails on Plex {
  id
  name
  description
  color
  questionTemplates {
    ...plexQuestionTemplateDetails
  }
  currentUserRelation {
    ...fullPlexUserRelation
  }
  defaultBoardId
  deleted
}
    ${PlexQuestionTemplateDetailsFragmentDoc}
${FullPlexUserRelationFragmentDoc}`;
export const PlexDomainSummaryFragmentDoc = gql`
    fragment plexDomainSummary on Plex {
  id
  name
  description
  deleted
  color
  defaultBoardId
  currentUserRelation {
    ...fullPlexUserRelation
  }
  summary {
    id
    members {
      name
      picture
      role
    }
  }
}
    ${FullPlexUserRelationFragmentDoc}`;
export const PlexSnackbarFragmentDoc = gql`
    fragment plexSnackbar on Plex {
  id
  name
  description
  deleted
  color
  defaultBoardId
  currentUserRelation {
    ...fullPlexUserRelation
  }
}
    ${FullPlexUserRelationFragmentDoc}`;
export const PlexSummaryChangeEventFragmentDoc = gql`
    fragment plexSummaryChangeEvent on ChangeEvent {
  id
  author {
    id
    name
    picture
    email
    jobTitle
  }
  createdAt
  eventType
  targetType
  eventTarget {
    ... on ChangeEventTargetBoard {
      board {
        id
        name
        faqCount(filterPublishStatus: ALL, labelIds: [])
      }
    }
    ... on ChangeEventTargetPost {
      post {
        id
        title
        permalink
      }
    }
    ... on ChangeEventTargetEvent {
      event {
        id
        title
        permalink
      }
    }
    ... on ChangeEventTargetQuestion {
      question {
        id
        text
        permalink
      }
    }
    ... on ChangeEventTargetAnswer {
      answer {
        id
        question {
          id
          text
          permalink
        }
      }
    }
    ... on ChangeEventTargetComment {
      comment {
        post {
          id
          title
          permalink
        }
        question {
          id
          text
          permalink
        }
        mentions {
          ...mentionsPlexRegisteredUser
        }
        links {
          ...linkPreviewMetadata
        }
        id
        body
      }
    }
  }
  updateDeltaBefore {
    v1 {
      post {
        mentions
      }
      question {
        acceptedAnswerId
      }
      answer {
        mentions
      }
    }
  }
  updateDeltaAfter {
    v1 {
      post {
        mentions
      }
      question {
        acceptedAnswerId
      }
      answer {
        mentions
      }
    }
  }
}
    ${MentionsPlexRegisteredUserFragmentDoc}
${LinkPreviewMetadataFragmentDoc}`;
export const PlexSummaryFragmentDoc = gql`
    fragment plexSummary on Plex {
  id
  name
  description
  notifications {
    ...plexNotification
  }
  deleted
  currentUserRelation {
    ...fullPlexUserRelation
  }
  defaultBoardId
  summary {
    id
    members {
      name
      picture
      role
    }
    channelsCount
    postsCount
    faqsCount
    events {
      ...plexSummaryChangeEvent
    }
  }
}
    ${PlexNotificationFragmentDoc}
${FullPlexUserRelationFragmentDoc}
${PlexSummaryChangeEventFragmentDoc}`;
export const PlexSummaryOverviewFragmentDoc = gql`
    fragment plexSummaryOverview on Plex {
  id
  name
  description
  color
  deleted
  notifications {
    ...plexNotification
  }
  currentUserRelation {
    ...fullPlexUserRelation
  }
  summary {
    id
    members {
      name
      picture
      role
    }
    events {
      ...changeEvent
    }
  }
}
    ${PlexNotificationFragmentDoc}
${FullPlexUserRelationFragmentDoc}
${ChangeEventFragmentDoc}`;
export const FullPlexInputErrorFragmentDoc = gql`
    fragment fullPlexInputError on PlexInputError {
  __typename
  addedMembers {
    __typename
    type
    id
    message
  }
}
    `;
export const FeedLinkPreviewMetadataDetailsFragmentDoc = gql`
    fragment feedLinkPreviewMetadataDetails on LinkMetadataDetails {
  __typename
  ... on PlexPostLinkMetadata {
    ...plexPostLinkMetadata
  }
  ... on PlexFactLinkMetadata {
    ...plexFactLinkMetadata
  }
  ... on GoogleDocLinkMetadata {
    ...googleDocLinkMetadata
  }
  ... on GoogleDriveFileLinkMetadata {
    ...googleDriveFileLinkMetadata
  }
  ... on GoogleSheetsLinkMetadata {
    ...googleSheetsLinkMetadata
  }
  ... on GoogleSlidesLinkMetadata {
    ...googleSlidesLinkMetadata
  }
  ... on ImageLinkMetadata {
    ...imageLinkMetadata
  }
  ... on AttachmentLinkMetadata {
    ...attachmentLinkMetadata
  }
  ... on GenericLink {
    ...genericLinkMetadata
  }
  ... on InvalidLink {
    ...invalidLinkMetadata
  }
}
    ${PlexPostLinkMetadataFragmentDoc}
${PlexFactLinkMetadataFragmentDoc}
${GoogleDocLinkMetadataFragmentDoc}
${GoogleDriveFileLinkMetadataFragmentDoc}
${GoogleSheetsLinkMetadataFragmentDoc}
${GoogleSlidesLinkMetadataFragmentDoc}
${ImageLinkMetadataFragmentDoc}
${AttachmentLinkMetadataFragmentDoc}
${GenericLinkMetadataFragmentDoc}
${InvalidLinkMetadataFragmentDoc}`;
export const FeedPostDetailsFragmentDoc = gql`
    fragment feedPostDetails on Post {
  id
  currentUserRelation
  deleted
  plex {
    id
    name
    color
    currentUserRelation {
      ...fullPlexUserRelation
    }
  }
  title
  body
  publishStatus
  publishedDate
  picture
  author {
    id
    name
    picture
    jobTitle
  }
  commentsCount
  primaryLink {
    id
    details {
      ...feedLinkPreviewMetadataDetails
    }
  }
  labels {
    id
    name
  }
  notification {
    ...postNotification
  }
  mentions {
    ...mentionsPlexRegisteredUser
  }
  links {
    ...linkPreviewMetadata
  }
  type
  eventDate
  watching
  currentUserReactions
  permalink
}
    ${FullPlexUserRelationFragmentDoc}
${FeedLinkPreviewMetadataDetailsFragmentDoc}
${PostNotificationFragmentDoc}
${MentionsPlexRegisteredUserFragmentDoc}
${LinkPreviewMetadataFragmentDoc}`;
export const FullAnswerFragmentDoc = gql`
    fragment fullAnswer on Answer {
  id
  body
  publishedAt
  user {
    id
    name
    picture
    email
    jobTitle
  }
  reactionCounts {
    type
    count
  }
  question {
    id
    text
    plex {
      id
      name
      color
      currentUserRelation {
        id
        state
      }
    }
    createdAt
    status
    answersCount
    author {
      id
      name
      email
      picture
      jobTitle
    }
    acceptedAnswerId
  }
  currentUserReactions
  currentUserRelation
  primaryLink {
    ...linkPreviewMetadata
  }
  links {
    ...linkPreviewMetadata
  }
  mentions {
    ...mentionsPlexRegisteredUser
  }
  deleted
}
    ${LinkPreviewMetadataFragmentDoc}
${MentionsPlexRegisteredUserFragmentDoc}`;
export const QuestionDetailsFragmentDoc = gql`
    fragment questionDetails on Question {
  id
  text
  status
  type
  plex {
    id
    name
    color
    currentUserRelation {
      ...fullPlexUserRelation
    }
  }
  acceptedAnswer {
    ...fullAnswer
  }
  answersCount
  answers {
    ...fullAnswer
  }
  currentUserRelation
  deleted
  createdAt
  publishChangedAt
  author {
    id
    name
    email
    picture
    jobTitle
  }
  commentsCount
  comments {
    id
    deleted
  }
  reactionCounts {
    type
    count
  }
  currentUserReactions
  labels {
    id
    name
  }
  notification {
    ...faqNotification
  }
  watching
  boardId
  positionInBoard {
    id
    positionInBoard
  }
  source {
    __typename
    ... on GoogleDocumentSource {
      url
    }
  }
  permalink
}
    ${FullPlexUserRelationFragmentDoc}
${FullAnswerFragmentDoc}
${FaqNotificationFragmentDoc}`;
export const BaseAnswerFragmentDoc = gql`
    fragment baseAnswer on Answer {
  id
  body
  publishedAt
  user {
    id
    name
    picture
    email
    jobTitle
  }
  reactionCounts {
    type
    count
  }
  question {
    id
    text
    createdAt
    status
    author {
      id
      name
      email
      picture
      jobTitle
    }
  }
  currentUserReactions
  currentUserRelation
  primaryLink {
    id
    details {
      ...feedLinkPreviewMetadataDetails
    }
  }
  links {
    ...linkPreviewMetadata
  }
  mentions {
    ...mentionsPlexRegisteredUser
  }
  deleted
}
    ${FeedLinkPreviewMetadataDetailsFragmentDoc}
${LinkPreviewMetadataFragmentDoc}
${MentionsPlexRegisteredUserFragmentDoc}`;
export const QuestionOverviewFragmentDoc = gql`
    fragment questionOverview on Question {
  id
  text
  status
  type
  plex {
    id
    name
    color
    currentUserRelation {
      ...fullPlexUserRelation
    }
  }
  acceptedAnswer {
    ...baseAnswer
  }
  deleted
  createdAt
  publishChangedAt
  author {
    id
    name
    email
    picture
    jobTitle
  }
  commentsCount
  labels {
    id
    name
  }
  notification {
    ...faqNotification
  }
  currentUserRelation
  currentUserReactions
  watching
  boardId
  positionInBoard {
    id
    positionInBoard
  }
  permalink
}
    ${FullPlexUserRelationFragmentDoc}
${BaseAnswerFragmentDoc}
${FaqNotificationFragmentDoc}`;
export const TaskDetailsEntityRelationFragmentDoc = gql`
    fragment taskDetailsEntityRelation on EntityRelation {
  id
  type
  targetType
  targetId
  target {
    __typename
    ... on Task {
      id
      title
      status
      permalink
      type
      assignee {
        id
        name
        picture
      }
    }
  }
  deleted
}
    `;
export const PostDetailsFragmentDoc = gql`
    fragment postDetails on Post {
  id
  currentUserRelation
  deleted
  plex {
    id
    name
    color
    currentUserRelation {
      ...fullPlexUserRelation
    }
  }
  title
  body
  publishStatus
  publishedDate
  picture
  author {
    id
    name
    picture
    jobTitle
  }
  commentsCount
  primaryLink {
    ...linkPreviewMetadata
  }
  links {
    ...linkPreviewMetadata
  }
  labels {
    id
    name
  }
  notification {
    ...postNotification
  }
  type
  eventDate
  watching
  mentions {
    ...mentionsPlexRegisteredUser
  }
  source {
    __typename
    ... on GoogleDocumentSource {
      url
      headingIds
    }
  }
  currentUserReactions
  permalink
}
    ${FullPlexUserRelationFragmentDoc}
${LinkPreviewMetadataFragmentDoc}
${PostNotificationFragmentDoc}
${MentionsPlexRegisteredUserFragmentDoc}`;
export const TaskDetailsFragmentDoc = gql`
    fragment taskDetails on Task {
  id
  permalink
  type
  deleted
  status
  publishStatus
  createdAt
  title
  labels {
    id
    name
  }
  dueDate
  body
  mentions {
    ...mentionsPlexRegisteredUser
  }
  links {
    ...linkPreviewMetadata
  }
  plex {
    id
    name
    color
    currentUserRelation {
      ...fullPlexUserRelation
    }
  }
  currentUserRelation
  author {
    id
    name
    picture
    jobTitle
  }
  assignee {
    id
    name
    picture
  }
  relatedEntities {
    ...taskDetailsEntityRelation
  }
  postContainer {
    ...postDetails
  }
}
    ${MentionsPlexRegisteredUserFragmentDoc}
${LinkPreviewMetadataFragmentDoc}
${FullPlexUserRelationFragmentDoc}
${TaskDetailsEntityRelationFragmentDoc}
${PostDetailsFragmentDoc}`;
export const UserPlexesFragmentDoc = gql`
    fragment userPlexes on User {
  id
  plexes {
    ...plexOverview
  }
}
    ${PlexOverviewFragmentDoc}`;
export const UserSettingsFragmentDoc = gql`
    fragment userSettings on User {
  name
  email
  givenName
  familyName
  picture
  locale
  hasExtraGSuiteScopes
  jobTitle
  jobDepartment
  completedOnboardingSteps
  defaultStatus
  timeZone
  language
  displayFilter
  feedDisplay
  displayTimeline
  baseDisplay
  accessControl
  status
  domain {
    id
    orgName
    url
    orgName
    industry
    email
    address
    authorizedDomain
    slackWorkspace {
      name
      slackId
    }
    picture
  }
}
    `;
export const ApproveAnswerDocument = gql`
    mutation ApproveAnswer($answerApproval: AnswerApproval!) {
  approveAnswer(answerApproval: $answerApproval) {
    id
    acceptedAnswerId
    acceptedAnswer {
      ...fullAnswer
    }
  }
}
    ${FullAnswerFragmentDoc}`;
export type ApproveAnswerMutationFn = ApolloReactCommon.MutationFunction<ApproveAnswerMutation, ApproveAnswerMutationVariables>;

/**
 * __useApproveAnswerMutation__
 *
 * To run a mutation, you first call `useApproveAnswerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApproveAnswerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approveAnswerMutation, { data, loading, error }] = useApproveAnswerMutation({
 *   variables: {
 *      answerApproval: // value for 'answerApproval'
 *   },
 * });
 */
export function useApproveAnswerMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ApproveAnswerMutation, ApproveAnswerMutationVariables>) {
        return ApolloReactHooks.useMutation<ApproveAnswerMutation, ApproveAnswerMutationVariables>(ApproveAnswerDocument, baseOptions);
      }
export type ApproveAnswerMutationHookResult = ReturnType<typeof useApproveAnswerMutation>;
export type ApproveAnswerMutationResult = ApolloReactCommon.MutationResult<ApproveAnswerMutation>;
export type ApproveAnswerMutationOptions = ApolloReactCommon.BaseMutationOptions<ApproveAnswerMutation, ApproveAnswerMutationVariables>;
export const ChangeBoardPositionDocument = gql`
    mutation ChangeBoardPosition($input: ChangeBoardPositionInput!) {
  changeBoardPosition(input: $input) {
    updatedPositions {
      id
      positionInPlex
    }
  }
}
    `;
export type ChangeBoardPositionMutationFn = ApolloReactCommon.MutationFunction<ChangeBoardPositionMutation, ChangeBoardPositionMutationVariables>;

/**
 * __useChangeBoardPositionMutation__
 *
 * To run a mutation, you first call `useChangeBoardPositionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeBoardPositionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeBoardPositionMutation, { data, loading, error }] = useChangeBoardPositionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useChangeBoardPositionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ChangeBoardPositionMutation, ChangeBoardPositionMutationVariables>) {
        return ApolloReactHooks.useMutation<ChangeBoardPositionMutation, ChangeBoardPositionMutationVariables>(ChangeBoardPositionDocument, baseOptions);
      }
export type ChangeBoardPositionMutationHookResult = ReturnType<typeof useChangeBoardPositionMutation>;
export type ChangeBoardPositionMutationResult = ApolloReactCommon.MutationResult<ChangeBoardPositionMutation>;
export type ChangeBoardPositionMutationOptions = ApolloReactCommon.BaseMutationOptions<ChangeBoardPositionMutation, ChangeBoardPositionMutationVariables>;
export const ChangeQuestionPositionDocument = gql`
    mutation ChangeQuestionPosition($input: ChangeQuestionPositionInput!) {
  changeQuestionPosition(input: $input) {
    positions {
      id
      positionInBoard
    }
  }
}
    `;
export type ChangeQuestionPositionMutationFn = ApolloReactCommon.MutationFunction<ChangeQuestionPositionMutation, ChangeQuestionPositionMutationVariables>;

/**
 * __useChangeQuestionPositionMutation__
 *
 * To run a mutation, you first call `useChangeQuestionPositionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeQuestionPositionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeQuestionPositionMutation, { data, loading, error }] = useChangeQuestionPositionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useChangeQuestionPositionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ChangeQuestionPositionMutation, ChangeQuestionPositionMutationVariables>) {
        return ApolloReactHooks.useMutation<ChangeQuestionPositionMutation, ChangeQuestionPositionMutationVariables>(ChangeQuestionPositionDocument, baseOptions);
      }
export type ChangeQuestionPositionMutationHookResult = ReturnType<typeof useChangeQuestionPositionMutation>;
export type ChangeQuestionPositionMutationResult = ApolloReactCommon.MutationResult<ChangeQuestionPositionMutation>;
export type ChangeQuestionPositionMutationOptions = ApolloReactCommon.BaseMutationOptions<ChangeQuestionPositionMutation, ChangeQuestionPositionMutationVariables>;
export const CreateAnswerDocument = gql`
    mutation CreateAnswer($answer: CreateAnswerInput!) {
  createAnswer(answer: $answer) {
    ...fullAnswer
  }
}
    ${FullAnswerFragmentDoc}`;
export type CreateAnswerMutationFn = ApolloReactCommon.MutationFunction<CreateAnswerMutation, CreateAnswerMutationVariables>;

/**
 * __useCreateAnswerMutation__
 *
 * To run a mutation, you first call `useCreateAnswerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAnswerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAnswerMutation, { data, loading, error }] = useCreateAnswerMutation({
 *   variables: {
 *      answer: // value for 'answer'
 *   },
 * });
 */
export function useCreateAnswerMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateAnswerMutation, CreateAnswerMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateAnswerMutation, CreateAnswerMutationVariables>(CreateAnswerDocument, baseOptions);
      }
export type CreateAnswerMutationHookResult = ReturnType<typeof useCreateAnswerMutation>;
export type CreateAnswerMutationResult = ApolloReactCommon.MutationResult<CreateAnswerMutation>;
export type CreateAnswerMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateAnswerMutation, CreateAnswerMutationVariables>;
export const CreateBoardDocument = gql`
    mutation CreateBoard($board: CreateBoardInput!) {
  createBoard(board: $board) {
    ...boardDetails
  }
}
    ${BoardDetailsFragmentDoc}`;
export type CreateBoardMutationFn = ApolloReactCommon.MutationFunction<CreateBoardMutation, CreateBoardMutationVariables>;

/**
 * __useCreateBoardMutation__
 *
 * To run a mutation, you first call `useCreateBoardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBoardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBoardMutation, { data, loading, error }] = useCreateBoardMutation({
 *   variables: {
 *      board: // value for 'board'
 *   },
 * });
 */
export function useCreateBoardMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateBoardMutation, CreateBoardMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateBoardMutation, CreateBoardMutationVariables>(CreateBoardDocument, baseOptions);
      }
export type CreateBoardMutationHookResult = ReturnType<typeof useCreateBoardMutation>;
export type CreateBoardMutationResult = ApolloReactCommon.MutationResult<CreateBoardMutation>;
export type CreateBoardMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateBoardMutation, CreateBoardMutationVariables>;
export const CreateBoardFromTemplateDocument = gql`
    mutation CreateBoardFromTemplate($plexId: String!, $templateId: String!, $questionTemplateIds: [String!]!) {
  createBoardFromTemplate(plexId: $plexId, templateId: $templateId, questionTemplateIds: $questionTemplateIds) {
    ...boardDetails
  }
}
    ${BoardDetailsFragmentDoc}`;
export type CreateBoardFromTemplateMutationFn = ApolloReactCommon.MutationFunction<CreateBoardFromTemplateMutation, CreateBoardFromTemplateMutationVariables>;

/**
 * __useCreateBoardFromTemplateMutation__
 *
 * To run a mutation, you first call `useCreateBoardFromTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBoardFromTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBoardFromTemplateMutation, { data, loading, error }] = useCreateBoardFromTemplateMutation({
 *   variables: {
 *      plexId: // value for 'plexId'
 *      templateId: // value for 'templateId'
 *      questionTemplateIds: // value for 'questionTemplateIds'
 *   },
 * });
 */
export function useCreateBoardFromTemplateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateBoardFromTemplateMutation, CreateBoardFromTemplateMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateBoardFromTemplateMutation, CreateBoardFromTemplateMutationVariables>(CreateBoardFromTemplateDocument, baseOptions);
      }
export type CreateBoardFromTemplateMutationHookResult = ReturnType<typeof useCreateBoardFromTemplateMutation>;
export type CreateBoardFromTemplateMutationResult = ApolloReactCommon.MutationResult<CreateBoardFromTemplateMutation>;
export type CreateBoardFromTemplateMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateBoardFromTemplateMutation, CreateBoardFromTemplateMutationVariables>;
export const CreateEventDocument = gql`
    mutation CreateEvent($event: CreateEventInput!) {
  createEvent(event: $event) {
    ...postDetails
    plex {
      id
      summary {
        id
        postsCount
      }
    }
  }
}
    ${PostDetailsFragmentDoc}`;
export type CreateEventMutationFn = ApolloReactCommon.MutationFunction<CreateEventMutation, CreateEventMutationVariables>;

/**
 * __useCreateEventMutation__
 *
 * To run a mutation, you first call `useCreateEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEventMutation, { data, loading, error }] = useCreateEventMutation({
 *   variables: {
 *      event: // value for 'event'
 *   },
 * });
 */
export function useCreateEventMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateEventMutation, CreateEventMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateEventMutation, CreateEventMutationVariables>(CreateEventDocument, baseOptions);
      }
export type CreateEventMutationHookResult = ReturnType<typeof useCreateEventMutation>;
export type CreateEventMutationResult = ApolloReactCommon.MutationResult<CreateEventMutation>;
export type CreateEventMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateEventMutation, CreateEventMutationVariables>;
export const CreateFactDocument = gql`
    mutation CreateFact($question: CreateQuestionInput!, $filterPublishStatus: FilterPublishStatus!, $labelIds: [String!]!) {
  createQuestion(question: $question) {
    ...questionDetails
    board {
      ...boardOverview
      faqCount(filterPublishStatus: $filterPublishStatus, labelIds: $labelIds)
    }
    plex {
      id
      summary {
        id
        faqsCount
      }
    }
  }
}
    ${QuestionDetailsFragmentDoc}
${BoardOverviewFragmentDoc}`;
export type CreateFactMutationFn = ApolloReactCommon.MutationFunction<CreateFactMutation, CreateFactMutationVariables>;

/**
 * __useCreateFactMutation__
 *
 * To run a mutation, you first call `useCreateFactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFactMutation, { data, loading, error }] = useCreateFactMutation({
 *   variables: {
 *      question: // value for 'question'
 *      filterPublishStatus: // value for 'filterPublishStatus'
 *      labelIds: // value for 'labelIds'
 *   },
 * });
 */
export function useCreateFactMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateFactMutation, CreateFactMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateFactMutation, CreateFactMutationVariables>(CreateFactDocument, baseOptions);
      }
export type CreateFactMutationHookResult = ReturnType<typeof useCreateFactMutation>;
export type CreateFactMutationResult = ApolloReactCommon.MutationResult<CreateFactMutation>;
export type CreateFactMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateFactMutation, CreateFactMutationVariables>;
export const CreateFactReviewProcessDocument = gql`
    mutation CreateFactReviewProcess($input: CreateFactReviewProcessInput!) {
  createFactReviewProcess(input: $input) {
    id
    createdEntities {
      id
      source {
        __typename
        ... on Task {
          ...taskDetails
        }
      }
    }
  }
}
    ${TaskDetailsFragmentDoc}`;
export type CreateFactReviewProcessMutationFn = ApolloReactCommon.MutationFunction<CreateFactReviewProcessMutation, CreateFactReviewProcessMutationVariables>;

/**
 * __useCreateFactReviewProcessMutation__
 *
 * To run a mutation, you first call `useCreateFactReviewProcessMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFactReviewProcessMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFactReviewProcessMutation, { data, loading, error }] = useCreateFactReviewProcessMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateFactReviewProcessMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateFactReviewProcessMutation, CreateFactReviewProcessMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateFactReviewProcessMutation, CreateFactReviewProcessMutationVariables>(CreateFactReviewProcessDocument, baseOptions);
      }
export type CreateFactReviewProcessMutationHookResult = ReturnType<typeof useCreateFactReviewProcessMutation>;
export type CreateFactReviewProcessMutationResult = ApolloReactCommon.MutationResult<CreateFactReviewProcessMutation>;
export type CreateFactReviewProcessMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateFactReviewProcessMutation, CreateFactReviewProcessMutationVariables>;
export const CreateLabelDocument = gql`
    mutation CreateLabel($name: String!) {
  createLabel(name: $name) {
    id
    name
  }
}
    `;
export type CreateLabelMutationFn = ApolloReactCommon.MutationFunction<CreateLabelMutation, CreateLabelMutationVariables>;

/**
 * __useCreateLabelMutation__
 *
 * To run a mutation, you first call `useCreateLabelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLabelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLabelMutation, { data, loading, error }] = useCreateLabelMutation({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useCreateLabelMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateLabelMutation, CreateLabelMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateLabelMutation, CreateLabelMutationVariables>(CreateLabelDocument, baseOptions);
      }
export type CreateLabelMutationHookResult = ReturnType<typeof useCreateLabelMutation>;
export type CreateLabelMutationResult = ApolloReactCommon.MutationResult<CreateLabelMutation>;
export type CreateLabelMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateLabelMutation, CreateLabelMutationVariables>;
export const CreatePlexDocument = gql`
    mutation CreatePlex($plex: PlexInput!) {
  createPlex(plex: $plex) {
    ...fullPlex
    ...fullPlexInputError
  }
}
    ${FullPlexFragmentDoc}
${FullPlexInputErrorFragmentDoc}`;
export type CreatePlexMutationFn = ApolloReactCommon.MutationFunction<CreatePlexMutation, CreatePlexMutationVariables>;

/**
 * __useCreatePlexMutation__
 *
 * To run a mutation, you first call `useCreatePlexMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePlexMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPlexMutation, { data, loading, error }] = useCreatePlexMutation({
 *   variables: {
 *      plex: // value for 'plex'
 *   },
 * });
 */
export function useCreatePlexMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreatePlexMutation, CreatePlexMutationVariables>) {
        return ApolloReactHooks.useMutation<CreatePlexMutation, CreatePlexMutationVariables>(CreatePlexDocument, baseOptions);
      }
export type CreatePlexMutationHookResult = ReturnType<typeof useCreatePlexMutation>;
export type CreatePlexMutationResult = ApolloReactCommon.MutationResult<CreatePlexMutation>;
export type CreatePlexMutationOptions = ApolloReactCommon.BaseMutationOptions<CreatePlexMutation, CreatePlexMutationVariables>;
export const CreatePostDocument = gql`
    mutation CreatePost($post: CreatePostInput!) {
  createPost(post: $post) {
    ...postDetails
    plex {
      id
      summary {
        id
        postsCount
      }
    }
  }
}
    ${PostDetailsFragmentDoc}`;
export type CreatePostMutationFn = ApolloReactCommon.MutationFunction<CreatePostMutation, CreatePostMutationVariables>;

/**
 * __useCreatePostMutation__
 *
 * To run a mutation, you first call `useCreatePostMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePostMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPostMutation, { data, loading, error }] = useCreatePostMutation({
 *   variables: {
 *      post: // value for 'post'
 *   },
 * });
 */
export function useCreatePostMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreatePostMutation, CreatePostMutationVariables>) {
        return ApolloReactHooks.useMutation<CreatePostMutation, CreatePostMutationVariables>(CreatePostDocument, baseOptions);
      }
export type CreatePostMutationHookResult = ReturnType<typeof useCreatePostMutation>;
export type CreatePostMutationResult = ApolloReactCommon.MutationResult<CreatePostMutation>;
export type CreatePostMutationOptions = ApolloReactCommon.BaseMutationOptions<CreatePostMutation, CreatePostMutationVariables>;
export const CreatePostCommentDocument = gql`
    mutation CreatePostComment($comment: CreatePostCommentInput!) {
  createPostComment(comment: $comment) {
    id
    commentsCount
    comments {
      ...fullComment
    }
  }
}
    ${FullCommentFragmentDoc}`;
export type CreatePostCommentMutationFn = ApolloReactCommon.MutationFunction<CreatePostCommentMutation, CreatePostCommentMutationVariables>;

/**
 * __useCreatePostCommentMutation__
 *
 * To run a mutation, you first call `useCreatePostCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePostCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPostCommentMutation, { data, loading, error }] = useCreatePostCommentMutation({
 *   variables: {
 *      comment: // value for 'comment'
 *   },
 * });
 */
export function useCreatePostCommentMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreatePostCommentMutation, CreatePostCommentMutationVariables>) {
        return ApolloReactHooks.useMutation<CreatePostCommentMutation, CreatePostCommentMutationVariables>(CreatePostCommentDocument, baseOptions);
      }
export type CreatePostCommentMutationHookResult = ReturnType<typeof useCreatePostCommentMutation>;
export type CreatePostCommentMutationResult = ApolloReactCommon.MutationResult<CreatePostCommentMutation>;
export type CreatePostCommentMutationOptions = ApolloReactCommon.BaseMutationOptions<CreatePostCommentMutation, CreatePostCommentMutationVariables>;
export const CreateQuestionCommentDocument = gql`
    mutation CreateQuestionComment($comment: CreateQuestionCommentInput!) {
  createQuestionComment(comment: $comment) {
    id
    comments {
      ...fullComment
    }
  }
}
    ${FullCommentFragmentDoc}`;
export type CreateQuestionCommentMutationFn = ApolloReactCommon.MutationFunction<CreateQuestionCommentMutation, CreateQuestionCommentMutationVariables>;

/**
 * __useCreateQuestionCommentMutation__
 *
 * To run a mutation, you first call `useCreateQuestionCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateQuestionCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createQuestionCommentMutation, { data, loading, error }] = useCreateQuestionCommentMutation({
 *   variables: {
 *      comment: // value for 'comment'
 *   },
 * });
 */
export function useCreateQuestionCommentMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateQuestionCommentMutation, CreateQuestionCommentMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateQuestionCommentMutation, CreateQuestionCommentMutationVariables>(CreateQuestionCommentDocument, baseOptions);
      }
export type CreateQuestionCommentMutationHookResult = ReturnType<typeof useCreateQuestionCommentMutation>;
export type CreateQuestionCommentMutationResult = ApolloReactCommon.MutationResult<CreateQuestionCommentMutation>;
export type CreateQuestionCommentMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateQuestionCommentMutation, CreateQuestionCommentMutationVariables>;
export const CreateTaskDocument = gql`
    mutation CreateTask($task: CreateTaskInput!) {
  createTask(task: $task) {
    ...taskDetails
  }
}
    ${TaskDetailsFragmentDoc}`;
export type CreateTaskMutationFn = ApolloReactCommon.MutationFunction<CreateTaskMutation, CreateTaskMutationVariables>;

/**
 * __useCreateTaskMutation__
 *
 * To run a mutation, you first call `useCreateTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTaskMutation, { data, loading, error }] = useCreateTaskMutation({
 *   variables: {
 *      task: // value for 'task'
 *   },
 * });
 */
export function useCreateTaskMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateTaskMutation, CreateTaskMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateTaskMutation, CreateTaskMutationVariables>(CreateTaskDocument, baseOptions);
      }
export type CreateTaskMutationHookResult = ReturnType<typeof useCreateTaskMutation>;
export type CreateTaskMutationResult = ApolloReactCommon.MutationResult<CreateTaskMutation>;
export type CreateTaskMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateTaskMutation, CreateTaskMutationVariables>;
export const CreateTaskEntityRelationDocument = gql`
    mutation CreateTaskEntityRelation($sourceId: String!, $type: EntityRelationType!, $targetType: EntityType!, $targetId: String!) {
  createEntityRelation(input: {sourceType: TASK, sourceId: $sourceId, type: $type, targetType: $targetType, targetId: $targetId}) {
    id
    source {
      __typename
      ...taskDetails
    }
  }
}
    ${TaskDetailsFragmentDoc}`;
export type CreateTaskEntityRelationMutationFn = ApolloReactCommon.MutationFunction<CreateTaskEntityRelationMutation, CreateTaskEntityRelationMutationVariables>;

/**
 * __useCreateTaskEntityRelationMutation__
 *
 * To run a mutation, you first call `useCreateTaskEntityRelationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTaskEntityRelationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTaskEntityRelationMutation, { data, loading, error }] = useCreateTaskEntityRelationMutation({
 *   variables: {
 *      sourceId: // value for 'sourceId'
 *      type: // value for 'type'
 *      targetType: // value for 'targetType'
 *      targetId: // value for 'targetId'
 *   },
 * });
 */
export function useCreateTaskEntityRelationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateTaskEntityRelationMutation, CreateTaskEntityRelationMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateTaskEntityRelationMutation, CreateTaskEntityRelationMutationVariables>(CreateTaskEntityRelationDocument, baseOptions);
      }
export type CreateTaskEntityRelationMutationHookResult = ReturnType<typeof useCreateTaskEntityRelationMutation>;
export type CreateTaskEntityRelationMutationResult = ApolloReactCommon.MutationResult<CreateTaskEntityRelationMutation>;
export type CreateTaskEntityRelationMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateTaskEntityRelationMutation, CreateTaskEntityRelationMutationVariables>;
export const CreateTaskUnderMilestoneDocument = gql`
    mutation CreateTaskUnderMilestone($task: CreateTaskInput!) {
  createTask(task: $task) {
    id
    relatedEntities {
      id
      target {
        __typename
        ... on Task {
          ...taskDetails
        }
      }
    }
  }
}
    ${TaskDetailsFragmentDoc}`;
export type CreateTaskUnderMilestoneMutationFn = ApolloReactCommon.MutationFunction<CreateTaskUnderMilestoneMutation, CreateTaskUnderMilestoneMutationVariables>;

/**
 * __useCreateTaskUnderMilestoneMutation__
 *
 * To run a mutation, you first call `useCreateTaskUnderMilestoneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTaskUnderMilestoneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTaskUnderMilestoneMutation, { data, loading, error }] = useCreateTaskUnderMilestoneMutation({
 *   variables: {
 *      task: // value for 'task'
 *   },
 * });
 */
export function useCreateTaskUnderMilestoneMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateTaskUnderMilestoneMutation, CreateTaskUnderMilestoneMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateTaskUnderMilestoneMutation, CreateTaskUnderMilestoneMutationVariables>(CreateTaskUnderMilestoneDocument, baseOptions);
      }
export type CreateTaskUnderMilestoneMutationHookResult = ReturnType<typeof useCreateTaskUnderMilestoneMutation>;
export type CreateTaskUnderMilestoneMutationResult = ApolloReactCommon.MutationResult<CreateTaskUnderMilestoneMutation>;
export type CreateTaskUnderMilestoneMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateTaskUnderMilestoneMutation, CreateTaskUnderMilestoneMutationVariables>;
export const DeleteAnswerDocument = gql`
    mutation DeleteAnswer($answerId: String!) {
  deleteAnswer(id: $answerId) {
    id
    deleted
  }
}
    `;
export type DeleteAnswerMutationFn = ApolloReactCommon.MutationFunction<DeleteAnswerMutation, DeleteAnswerMutationVariables>;

/**
 * __useDeleteAnswerMutation__
 *
 * To run a mutation, you first call `useDeleteAnswerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAnswerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAnswerMutation, { data, loading, error }] = useDeleteAnswerMutation({
 *   variables: {
 *      answerId: // value for 'answerId'
 *   },
 * });
 */
export function useDeleteAnswerMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteAnswerMutation, DeleteAnswerMutationVariables>) {
        return ApolloReactHooks.useMutation<DeleteAnswerMutation, DeleteAnswerMutationVariables>(DeleteAnswerDocument, baseOptions);
      }
export type DeleteAnswerMutationHookResult = ReturnType<typeof useDeleteAnswerMutation>;
export type DeleteAnswerMutationResult = ApolloReactCommon.MutationResult<DeleteAnswerMutation>;
export type DeleteAnswerMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteAnswerMutation, DeleteAnswerMutationVariables>;
export const DeleteBoardDocument = gql`
    mutation DeleteBoard($boardId: String!, $faqDestinationBoard: String!, $deleteAllFaqs: Boolean!) {
  deleteBoard(id: $boardId, faqDestinationBoard: $faqDestinationBoard, deleteAllFaqs: $deleteAllFaqs) {
    id
    deleted
  }
}
    `;
export type DeleteBoardMutationFn = ApolloReactCommon.MutationFunction<DeleteBoardMutation, DeleteBoardMutationVariables>;

/**
 * __useDeleteBoardMutation__
 *
 * To run a mutation, you first call `useDeleteBoardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteBoardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteBoardMutation, { data, loading, error }] = useDeleteBoardMutation({
 *   variables: {
 *      boardId: // value for 'boardId'
 *      faqDestinationBoard: // value for 'faqDestinationBoard'
 *      deleteAllFaqs: // value for 'deleteAllFaqs'
 *   },
 * });
 */
export function useDeleteBoardMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteBoardMutation, DeleteBoardMutationVariables>) {
        return ApolloReactHooks.useMutation<DeleteBoardMutation, DeleteBoardMutationVariables>(DeleteBoardDocument, baseOptions);
      }
export type DeleteBoardMutationHookResult = ReturnType<typeof useDeleteBoardMutation>;
export type DeleteBoardMutationResult = ApolloReactCommon.MutationResult<DeleteBoardMutation>;
export type DeleteBoardMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteBoardMutation, DeleteBoardMutationVariables>;
export const DeleteCommentDocument = gql`
    mutation DeleteComment($commentId: String!) {
  deletePostComment(id: $commentId) {
    id
    deleted
  }
}
    `;
export type DeleteCommentMutationFn = ApolloReactCommon.MutationFunction<DeleteCommentMutation, DeleteCommentMutationVariables>;

/**
 * __useDeleteCommentMutation__
 *
 * To run a mutation, you first call `useDeleteCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCommentMutation, { data, loading, error }] = useDeleteCommentMutation({
 *   variables: {
 *      commentId: // value for 'commentId'
 *   },
 * });
 */
export function useDeleteCommentMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteCommentMutation, DeleteCommentMutationVariables>) {
        return ApolloReactHooks.useMutation<DeleteCommentMutation, DeleteCommentMutationVariables>(DeleteCommentDocument, baseOptions);
      }
export type DeleteCommentMutationHookResult = ReturnType<typeof useDeleteCommentMutation>;
export type DeleteCommentMutationResult = ApolloReactCommon.MutationResult<DeleteCommentMutation>;
export type DeleteCommentMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteCommentMutation, DeleteCommentMutationVariables>;
export const DeleteNotificationActivityDocument = gql`
    mutation DeleteNotificationActivity($notificationActivityId: String!) {
  deleteNotificationActivity(id: $notificationActivityId) {
    id
    deleted
  }
}
    `;
export type DeleteNotificationActivityMutationFn = ApolloReactCommon.MutationFunction<DeleteNotificationActivityMutation, DeleteNotificationActivityMutationVariables>;

/**
 * __useDeleteNotificationActivityMutation__
 *
 * To run a mutation, you first call `useDeleteNotificationActivityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteNotificationActivityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteNotificationActivityMutation, { data, loading, error }] = useDeleteNotificationActivityMutation({
 *   variables: {
 *      notificationActivityId: // value for 'notificationActivityId'
 *   },
 * });
 */
export function useDeleteNotificationActivityMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteNotificationActivityMutation, DeleteNotificationActivityMutationVariables>) {
        return ApolloReactHooks.useMutation<DeleteNotificationActivityMutation, DeleteNotificationActivityMutationVariables>(DeleteNotificationActivityDocument, baseOptions);
      }
export type DeleteNotificationActivityMutationHookResult = ReturnType<typeof useDeleteNotificationActivityMutation>;
export type DeleteNotificationActivityMutationResult = ApolloReactCommon.MutationResult<DeleteNotificationActivityMutation>;
export type DeleteNotificationActivityMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteNotificationActivityMutation, DeleteNotificationActivityMutationVariables>;
export const DeletePlexDocument = gql`
    mutation DeletePlex($plexId: String!) {
  deletePlex(id: $plexId) {
    id
    deleted
  }
}
    `;
export type DeletePlexMutationFn = ApolloReactCommon.MutationFunction<DeletePlexMutation, DeletePlexMutationVariables>;

/**
 * __useDeletePlexMutation__
 *
 * To run a mutation, you first call `useDeletePlexMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePlexMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePlexMutation, { data, loading, error }] = useDeletePlexMutation({
 *   variables: {
 *      plexId: // value for 'plexId'
 *   },
 * });
 */
export function useDeletePlexMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeletePlexMutation, DeletePlexMutationVariables>) {
        return ApolloReactHooks.useMutation<DeletePlexMutation, DeletePlexMutationVariables>(DeletePlexDocument, baseOptions);
      }
export type DeletePlexMutationHookResult = ReturnType<typeof useDeletePlexMutation>;
export type DeletePlexMutationResult = ApolloReactCommon.MutationResult<DeletePlexMutation>;
export type DeletePlexMutationOptions = ApolloReactCommon.BaseMutationOptions<DeletePlexMutation, DeletePlexMutationVariables>;
export const DeletePostDocument = gql`
    mutation DeletePost($postId: String!) {
  deletePost(id: $postId) {
    id
    deleted
    plex {
      id
      summary {
        id
        postsCount
      }
    }
  }
}
    `;
export type DeletePostMutationFn = ApolloReactCommon.MutationFunction<DeletePostMutation, DeletePostMutationVariables>;

/**
 * __useDeletePostMutation__
 *
 * To run a mutation, you first call `useDeletePostMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePostMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePostMutation, { data, loading, error }] = useDeletePostMutation({
 *   variables: {
 *      postId: // value for 'postId'
 *   },
 * });
 */
export function useDeletePostMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeletePostMutation, DeletePostMutationVariables>) {
        return ApolloReactHooks.useMutation<DeletePostMutation, DeletePostMutationVariables>(DeletePostDocument, baseOptions);
      }
export type DeletePostMutationHookResult = ReturnType<typeof useDeletePostMutation>;
export type DeletePostMutationResult = ApolloReactCommon.MutationResult<DeletePostMutation>;
export type DeletePostMutationOptions = ApolloReactCommon.BaseMutationOptions<DeletePostMutation, DeletePostMutationVariables>;
export const DeleteQuestionDocument = gql`
    mutation DeleteQuestion($questionId: String!, $filterPublishStatus: FilterPublishStatus!, $labelIds: [String!]!) {
  deleteQuestion(id: $questionId) {
    id
    board {
      id
      faqCount(filterPublishStatus: $filterPublishStatus, labelIds: $labelIds)
    }
    plex {
      id
      summary {
        id
        faqsCount
      }
    }
    deleted
  }
}
    `;
export type DeleteQuestionMutationFn = ApolloReactCommon.MutationFunction<DeleteQuestionMutation, DeleteQuestionMutationVariables>;

/**
 * __useDeleteQuestionMutation__
 *
 * To run a mutation, you first call `useDeleteQuestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteQuestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteQuestionMutation, { data, loading, error }] = useDeleteQuestionMutation({
 *   variables: {
 *      questionId: // value for 'questionId'
 *      filterPublishStatus: // value for 'filterPublishStatus'
 *      labelIds: // value for 'labelIds'
 *   },
 * });
 */
export function useDeleteQuestionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteQuestionMutation, DeleteQuestionMutationVariables>) {
        return ApolloReactHooks.useMutation<DeleteQuestionMutation, DeleteQuestionMutationVariables>(DeleteQuestionDocument, baseOptions);
      }
export type DeleteQuestionMutationHookResult = ReturnType<typeof useDeleteQuestionMutation>;
export type DeleteQuestionMutationResult = ApolloReactCommon.MutationResult<DeleteQuestionMutation>;
export type DeleteQuestionMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteQuestionMutation, DeleteQuestionMutationVariables>;
export const DeleteTaskDocument = gql`
    mutation DeleteTask($taskId: String!) {
  deleteTask(id: $taskId) {
    id
    deleted
    postContainer {
      id
      deleted
    }
  }
}
    `;
export type DeleteTaskMutationFn = ApolloReactCommon.MutationFunction<DeleteTaskMutation, DeleteTaskMutationVariables>;

/**
 * __useDeleteTaskMutation__
 *
 * To run a mutation, you first call `useDeleteTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTaskMutation, { data, loading, error }] = useDeleteTaskMutation({
 *   variables: {
 *      taskId: // value for 'taskId'
 *   },
 * });
 */
export function useDeleteTaskMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteTaskMutation, DeleteTaskMutationVariables>) {
        return ApolloReactHooks.useMutation<DeleteTaskMutation, DeleteTaskMutationVariables>(DeleteTaskDocument, baseOptions);
      }
export type DeleteTaskMutationHookResult = ReturnType<typeof useDeleteTaskMutation>;
export type DeleteTaskMutationResult = ApolloReactCommon.MutationResult<DeleteTaskMutation>;
export type DeleteTaskMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteTaskMutation, DeleteTaskMutationVariables>;
export const IgnoreQuestionTemplateDocument = gql`
    mutation IgnoreQuestionTemplate($plexId: String!, $templateId: String!) {
  ignoreQuestionTemplate(plexId: $plexId, templateId: $templateId) {
    ...questionDetails
  }
}
    ${QuestionDetailsFragmentDoc}`;
export type IgnoreQuestionTemplateMutationFn = ApolloReactCommon.MutationFunction<IgnoreQuestionTemplateMutation, IgnoreQuestionTemplateMutationVariables>;

/**
 * __useIgnoreQuestionTemplateMutation__
 *
 * To run a mutation, you first call `useIgnoreQuestionTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useIgnoreQuestionTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [ignoreQuestionTemplateMutation, { data, loading, error }] = useIgnoreQuestionTemplateMutation({
 *   variables: {
 *      plexId: // value for 'plexId'
 *      templateId: // value for 'templateId'
 *   },
 * });
 */
export function useIgnoreQuestionTemplateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<IgnoreQuestionTemplateMutation, IgnoreQuestionTemplateMutationVariables>) {
        return ApolloReactHooks.useMutation<IgnoreQuestionTemplateMutation, IgnoreQuestionTemplateMutationVariables>(IgnoreQuestionTemplateDocument, baseOptions);
      }
export type IgnoreQuestionTemplateMutationHookResult = ReturnType<typeof useIgnoreQuestionTemplateMutation>;
export type IgnoreQuestionTemplateMutationResult = ApolloReactCommon.MutationResult<IgnoreQuestionTemplateMutation>;
export type IgnoreQuestionTemplateMutationOptions = ApolloReactCommon.BaseMutationOptions<IgnoreQuestionTemplateMutation, IgnoreQuestionTemplateMutationVariables>;
export const ImportFactDocument = gql`
    mutation ImportFact($input: ImportFactInput!, $filterPublishStatus: FilterPublishStatus!, $labelIds: [String!]!) {
  importFact(input: $input) {
    ...questionDetails
    board {
      ...boardOverview
      faqCount(filterPublishStatus: $filterPublishStatus, labelIds: $labelIds)
    }
    plex {
      id
      summary {
        id
        faqsCount
      }
    }
  }
}
    ${QuestionDetailsFragmentDoc}
${BoardOverviewFragmentDoc}`;
export type ImportFactMutationFn = ApolloReactCommon.MutationFunction<ImportFactMutation, ImportFactMutationVariables>;

/**
 * __useImportFactMutation__
 *
 * To run a mutation, you first call `useImportFactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportFactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importFactMutation, { data, loading, error }] = useImportFactMutation({
 *   variables: {
 *      input: // value for 'input'
 *      filterPublishStatus: // value for 'filterPublishStatus'
 *      labelIds: // value for 'labelIds'
 *   },
 * });
 */
export function useImportFactMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ImportFactMutation, ImportFactMutationVariables>) {
        return ApolloReactHooks.useMutation<ImportFactMutation, ImportFactMutationVariables>(ImportFactDocument, baseOptions);
      }
export type ImportFactMutationHookResult = ReturnType<typeof useImportFactMutation>;
export type ImportFactMutationResult = ApolloReactCommon.MutationResult<ImportFactMutation>;
export type ImportFactMutationOptions = ApolloReactCommon.BaseMutationOptions<ImportFactMutation, ImportFactMutationVariables>;
export const ImportFaqsFromGoogleDocDocument = gql`
    mutation ImportFaqsFromGoogleDoc($input: ImportBoardInput!) {
  importBoard(input: $input) {
    ...boardDetails
  }
}
    ${BoardDetailsFragmentDoc}`;
export type ImportFaqsFromGoogleDocMutationFn = ApolloReactCommon.MutationFunction<ImportFaqsFromGoogleDocMutation, ImportFaqsFromGoogleDocMutationVariables>;

/**
 * __useImportFaqsFromGoogleDocMutation__
 *
 * To run a mutation, you first call `useImportFaqsFromGoogleDocMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportFaqsFromGoogleDocMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importFaqsFromGoogleDocMutation, { data, loading, error }] = useImportFaqsFromGoogleDocMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useImportFaqsFromGoogleDocMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ImportFaqsFromGoogleDocMutation, ImportFaqsFromGoogleDocMutationVariables>) {
        return ApolloReactHooks.useMutation<ImportFaqsFromGoogleDocMutation, ImportFaqsFromGoogleDocMutationVariables>(ImportFaqsFromGoogleDocDocument, baseOptions);
      }
export type ImportFaqsFromGoogleDocMutationHookResult = ReturnType<typeof useImportFaqsFromGoogleDocMutation>;
export type ImportFaqsFromGoogleDocMutationResult = ApolloReactCommon.MutationResult<ImportFaqsFromGoogleDocMutation>;
export type ImportFaqsFromGoogleDocMutationOptions = ApolloReactCommon.BaseMutationOptions<ImportFaqsFromGoogleDocMutation, ImportFaqsFromGoogleDocMutationVariables>;
export const ImportGoogleCalendarEventDocument = gql`
    mutation ImportGoogleCalendarEvent($event: GoogleCalendarEventInput!) {
  importEventFromGoogleCalendar(event: $event) {
    ...postDetails
  }
}
    ${PostDetailsFragmentDoc}`;
export type ImportGoogleCalendarEventMutationFn = ApolloReactCommon.MutationFunction<ImportGoogleCalendarEventMutation, ImportGoogleCalendarEventMutationVariables>;

/**
 * __useImportGoogleCalendarEventMutation__
 *
 * To run a mutation, you first call `useImportGoogleCalendarEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportGoogleCalendarEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importGoogleCalendarEventMutation, { data, loading, error }] = useImportGoogleCalendarEventMutation({
 *   variables: {
 *      event: // value for 'event'
 *   },
 * });
 */
export function useImportGoogleCalendarEventMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ImportGoogleCalendarEventMutation, ImportGoogleCalendarEventMutationVariables>) {
        return ApolloReactHooks.useMutation<ImportGoogleCalendarEventMutation, ImportGoogleCalendarEventMutationVariables>(ImportGoogleCalendarEventDocument, baseOptions);
      }
export type ImportGoogleCalendarEventMutationHookResult = ReturnType<typeof useImportGoogleCalendarEventMutation>;
export type ImportGoogleCalendarEventMutationResult = ApolloReactCommon.MutationResult<ImportGoogleCalendarEventMutation>;
export type ImportGoogleCalendarEventMutationOptions = ApolloReactCommon.BaseMutationOptions<ImportGoogleCalendarEventMutation, ImportGoogleCalendarEventMutationVariables>;
export const LeavePlexDocument = gql`
    mutation LeavePlex($plexId: String!) {
  leavePlex(plexId: $plexId) {
    ...fullPlexUserRelation
  }
}
    ${FullPlexUserRelationFragmentDoc}`;
export type LeavePlexMutationFn = ApolloReactCommon.MutationFunction<LeavePlexMutation, LeavePlexMutationVariables>;

/**
 * __useLeavePlexMutation__
 *
 * To run a mutation, you first call `useLeavePlexMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLeavePlexMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [leavePlexMutation, { data, loading, error }] = useLeavePlexMutation({
 *   variables: {
 *      plexId: // value for 'plexId'
 *   },
 * });
 */
export function useLeavePlexMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<LeavePlexMutation, LeavePlexMutationVariables>) {
        return ApolloReactHooks.useMutation<LeavePlexMutation, LeavePlexMutationVariables>(LeavePlexDocument, baseOptions);
      }
export type LeavePlexMutationHookResult = ReturnType<typeof useLeavePlexMutation>;
export type LeavePlexMutationResult = ApolloReactCommon.MutationResult<LeavePlexMutation>;
export type LeavePlexMutationOptions = ApolloReactCommon.BaseMutationOptions<LeavePlexMutation, LeavePlexMutationVariables>;
export const PromoteCommentToAnswerDocument = gql`
    mutation PromoteCommentToAnswer($commentId: String!) {
  promoteCommentToAnswer(commentId: $commentId) {
    ...questionDetails
  }
}
    ${QuestionDetailsFragmentDoc}`;
export type PromoteCommentToAnswerMutationFn = ApolloReactCommon.MutationFunction<PromoteCommentToAnswerMutation, PromoteCommentToAnswerMutationVariables>;

/**
 * __usePromoteCommentToAnswerMutation__
 *
 * To run a mutation, you first call `usePromoteCommentToAnswerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePromoteCommentToAnswerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [promoteCommentToAnswerMutation, { data, loading, error }] = usePromoteCommentToAnswerMutation({
 *   variables: {
 *      commentId: // value for 'commentId'
 *   },
 * });
 */
export function usePromoteCommentToAnswerMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<PromoteCommentToAnswerMutation, PromoteCommentToAnswerMutationVariables>) {
        return ApolloReactHooks.useMutation<PromoteCommentToAnswerMutation, PromoteCommentToAnswerMutationVariables>(PromoteCommentToAnswerDocument, baseOptions);
      }
export type PromoteCommentToAnswerMutationHookResult = ReturnType<typeof usePromoteCommentToAnswerMutation>;
export type PromoteCommentToAnswerMutationResult = ApolloReactCommon.MutationResult<PromoteCommentToAnswerMutation>;
export type PromoteCommentToAnswerMutationOptions = ApolloReactCommon.BaseMutationOptions<PromoteCommentToAnswerMutation, PromoteCommentToAnswerMutationVariables>;
export const PublishFactDocument = gql`
    mutation PublishFact($publishQuestionInput: PublishQuestionInput!) {
  publishQuestion(publishQuestionInput: $publishQuestionInput) {
    ...questionDetails
  }
}
    ${QuestionDetailsFragmentDoc}`;
export type PublishFactMutationFn = ApolloReactCommon.MutationFunction<PublishFactMutation, PublishFactMutationVariables>;

/**
 * __usePublishFactMutation__
 *
 * To run a mutation, you first call `usePublishFactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePublishFactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [publishFactMutation, { data, loading, error }] = usePublishFactMutation({
 *   variables: {
 *      publishQuestionInput: // value for 'publishQuestionInput'
 *   },
 * });
 */
export function usePublishFactMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<PublishFactMutation, PublishFactMutationVariables>) {
        return ApolloReactHooks.useMutation<PublishFactMutation, PublishFactMutationVariables>(PublishFactDocument, baseOptions);
      }
export type PublishFactMutationHookResult = ReturnType<typeof usePublishFactMutation>;
export type PublishFactMutationResult = ApolloReactCommon.MutationResult<PublishFactMutation>;
export type PublishFactMutationOptions = ApolloReactCommon.BaseMutationOptions<PublishFactMutation, PublishFactMutationVariables>;
export const PublishPostDocument = gql`
    mutation PublishPost($publishPostInput: PublishPostInput!) {
  publishPost(publishPostInput: $publishPostInput) {
    ...postDetails
  }
}
    ${PostDetailsFragmentDoc}`;
export type PublishPostMutationFn = ApolloReactCommon.MutationFunction<PublishPostMutation, PublishPostMutationVariables>;

/**
 * __usePublishPostMutation__
 *
 * To run a mutation, you first call `usePublishPostMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePublishPostMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [publishPostMutation, { data, loading, error }] = usePublishPostMutation({
 *   variables: {
 *      publishPostInput: // value for 'publishPostInput'
 *   },
 * });
 */
export function usePublishPostMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<PublishPostMutation, PublishPostMutationVariables>) {
        return ApolloReactHooks.useMutation<PublishPostMutation, PublishPostMutationVariables>(PublishPostDocument, baseOptions);
      }
export type PublishPostMutationHookResult = ReturnType<typeof usePublishPostMutation>;
export type PublishPostMutationResult = ApolloReactCommon.MutationResult<PublishPostMutation>;
export type PublishPostMutationOptions = ApolloReactCommon.BaseMutationOptions<PublishPostMutation, PublishPostMutationVariables>;
export const ReactToAnswerDocument = gql`
    mutation ReactToAnswer($reaction: AnswerReactionInput!) {
  reactToAnswer(answer: $reaction) {
    id
    currentUserReactions
    reactionCounts {
      type
      count
    }
  }
}
    `;
export type ReactToAnswerMutationFn = ApolloReactCommon.MutationFunction<ReactToAnswerMutation, ReactToAnswerMutationVariables>;

/**
 * __useReactToAnswerMutation__
 *
 * To run a mutation, you first call `useReactToAnswerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReactToAnswerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reactToAnswerMutation, { data, loading, error }] = useReactToAnswerMutation({
 *   variables: {
 *      reaction: // value for 'reaction'
 *   },
 * });
 */
export function useReactToAnswerMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ReactToAnswerMutation, ReactToAnswerMutationVariables>) {
        return ApolloReactHooks.useMutation<ReactToAnswerMutation, ReactToAnswerMutationVariables>(ReactToAnswerDocument, baseOptions);
      }
export type ReactToAnswerMutationHookResult = ReturnType<typeof useReactToAnswerMutation>;
export type ReactToAnswerMutationResult = ApolloReactCommon.MutationResult<ReactToAnswerMutation>;
export type ReactToAnswerMutationOptions = ApolloReactCommon.BaseMutationOptions<ReactToAnswerMutation, ReactToAnswerMutationVariables>;
export const ReactToCommentDocument = gql`
    mutation ReactToComment($reaction: ReactionInput!) {
  reactToComment(reaction: $reaction) {
    id
    currentUserReactions
    reactionCounts {
      type
      count
    }
  }
}
    `;
export type ReactToCommentMutationFn = ApolloReactCommon.MutationFunction<ReactToCommentMutation, ReactToCommentMutationVariables>;

/**
 * __useReactToCommentMutation__
 *
 * To run a mutation, you first call `useReactToCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReactToCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reactToCommentMutation, { data, loading, error }] = useReactToCommentMutation({
 *   variables: {
 *      reaction: // value for 'reaction'
 *   },
 * });
 */
export function useReactToCommentMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ReactToCommentMutation, ReactToCommentMutationVariables>) {
        return ApolloReactHooks.useMutation<ReactToCommentMutation, ReactToCommentMutationVariables>(ReactToCommentDocument, baseOptions);
      }
export type ReactToCommentMutationHookResult = ReturnType<typeof useReactToCommentMutation>;
export type ReactToCommentMutationResult = ApolloReactCommon.MutationResult<ReactToCommentMutation>;
export type ReactToCommentMutationOptions = ApolloReactCommon.BaseMutationOptions<ReactToCommentMutation, ReactToCommentMutationVariables>;
export const ReactToQuestionDocument = gql`
    mutation ReactToQuestion($reaction: QuestionReactionInput!) {
  reactToQuestion(reaction: $reaction) {
    id
    currentUserReactions
    reactionCounts {
      type
      count
    }
  }
}
    `;
export type ReactToQuestionMutationFn = ApolloReactCommon.MutationFunction<ReactToQuestionMutation, ReactToQuestionMutationVariables>;

/**
 * __useReactToQuestionMutation__
 *
 * To run a mutation, you first call `useReactToQuestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReactToQuestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reactToQuestionMutation, { data, loading, error }] = useReactToQuestionMutation({
 *   variables: {
 *      reaction: // value for 'reaction'
 *   },
 * });
 */
export function useReactToQuestionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ReactToQuestionMutation, ReactToQuestionMutationVariables>) {
        return ApolloReactHooks.useMutation<ReactToQuestionMutation, ReactToQuestionMutationVariables>(ReactToQuestionDocument, baseOptions);
      }
export type ReactToQuestionMutationHookResult = ReturnType<typeof useReactToQuestionMutation>;
export type ReactToQuestionMutationResult = ApolloReactCommon.MutationResult<ReactToQuestionMutation>;
export type ReactToQuestionMutationOptions = ApolloReactCommon.BaseMutationOptions<ReactToQuestionMutation, ReactToQuestionMutationVariables>;
export const ResetOnboardingDocument = gql`
    mutation ResetOnboarding {
  updateUserSettings(userSettingsInput: {resetOnboardingSteps: true}) {
    id
    ...userSettings
  }
}
    ${UserSettingsFragmentDoc}`;
export type ResetOnboardingMutationFn = ApolloReactCommon.MutationFunction<ResetOnboardingMutation, ResetOnboardingMutationVariables>;

/**
 * __useResetOnboardingMutation__
 *
 * To run a mutation, you first call `useResetOnboardingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetOnboardingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetOnboardingMutation, { data, loading, error }] = useResetOnboardingMutation({
 *   variables: {
 *   },
 * });
 */
export function useResetOnboardingMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ResetOnboardingMutation, ResetOnboardingMutationVariables>) {
        return ApolloReactHooks.useMutation<ResetOnboardingMutation, ResetOnboardingMutationVariables>(ResetOnboardingDocument, baseOptions);
      }
export type ResetOnboardingMutationHookResult = ReturnType<typeof useResetOnboardingMutation>;
export type ResetOnboardingMutationResult = ApolloReactCommon.MutationResult<ResetOnboardingMutation>;
export type ResetOnboardingMutationOptions = ApolloReactCommon.BaseMutationOptions<ResetOnboardingMutation, ResetOnboardingMutationVariables>;
export const SeenNotificationActivityDocument = gql`
    mutation SeenNotificationActivity($id: String!) {
  seenNotificationActivity(id: $id) {
    ...notificationActivity
  }
}
    ${NotificationActivityFragmentDoc}`;
export type SeenNotificationActivityMutationFn = ApolloReactCommon.MutationFunction<SeenNotificationActivityMutation, SeenNotificationActivityMutationVariables>;

/**
 * __useSeenNotificationActivityMutation__
 *
 * To run a mutation, you first call `useSeenNotificationActivityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSeenNotificationActivityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [seenNotificationActivityMutation, { data, loading, error }] = useSeenNotificationActivityMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSeenNotificationActivityMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SeenNotificationActivityMutation, SeenNotificationActivityMutationVariables>) {
        return ApolloReactHooks.useMutation<SeenNotificationActivityMutation, SeenNotificationActivityMutationVariables>(SeenNotificationActivityDocument, baseOptions);
      }
export type SeenNotificationActivityMutationHookResult = ReturnType<typeof useSeenNotificationActivityMutation>;
export type SeenNotificationActivityMutationResult = ApolloReactCommon.MutationResult<SeenNotificationActivityMutation>;
export type SeenNotificationActivityMutationOptions = ApolloReactCommon.BaseMutationOptions<SeenNotificationActivityMutation, SeenNotificationActivityMutationVariables>;
export const SeenUserNotificationsDocument = gql`
    mutation SeenUserNotifications($postsIds: [String!]!, $faqsIds: [String!]!) {
  seenUserNotifications(postsIds: $postsIds, faqsIds: $faqsIds) {
    ...feedNotification
  }
}
    ${FeedNotificationFragmentDoc}`;
export type SeenUserNotificationsMutationFn = ApolloReactCommon.MutationFunction<SeenUserNotificationsMutation, SeenUserNotificationsMutationVariables>;

/**
 * __useSeenUserNotificationsMutation__
 *
 * To run a mutation, you first call `useSeenUserNotificationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSeenUserNotificationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [seenUserNotificationsMutation, { data, loading, error }] = useSeenUserNotificationsMutation({
 *   variables: {
 *      postsIds: // value for 'postsIds'
 *      faqsIds: // value for 'faqsIds'
 *   },
 * });
 */
export function useSeenUserNotificationsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SeenUserNotificationsMutation, SeenUserNotificationsMutationVariables>) {
        return ApolloReactHooks.useMutation<SeenUserNotificationsMutation, SeenUserNotificationsMutationVariables>(SeenUserNotificationsDocument, baseOptions);
      }
export type SeenUserNotificationsMutationHookResult = ReturnType<typeof useSeenUserNotificationsMutation>;
export type SeenUserNotificationsMutationResult = ApolloReactCommon.MutationResult<SeenUserNotificationsMutation>;
export type SeenUserNotificationsMutationOptions = ApolloReactCommon.BaseMutationOptions<SeenUserNotificationsMutation, SeenUserNotificationsMutationVariables>;
export const ShareDocument = gql`
    mutation Share($shareInput: ShareInput!) {
  share(shareInput: $shareInput) {
    id
    sharedDate
  }
}
    `;
export type ShareMutationFn = ApolloReactCommon.MutationFunction<ShareMutation, ShareMutationVariables>;

/**
 * __useShareMutation__
 *
 * To run a mutation, you first call `useShareMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useShareMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [shareMutation, { data, loading, error }] = useShareMutation({
 *   variables: {
 *      shareInput: // value for 'shareInput'
 *   },
 * });
 */
export function useShareMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ShareMutation, ShareMutationVariables>) {
        return ApolloReactHooks.useMutation<ShareMutation, ShareMutationVariables>(ShareDocument, baseOptions);
      }
export type ShareMutationHookResult = ReturnType<typeof useShareMutation>;
export type ShareMutationResult = ApolloReactCommon.MutationResult<ShareMutation>;
export type ShareMutationOptions = ApolloReactCommon.BaseMutationOptions<ShareMutation, ShareMutationVariables>;
export const SubscribeToPlexDocument = gql`
    mutation SubscribeToPlex($plexId: String!) {
  subscribeToPlex(plexId: $plexId) {
    ...fullPlexUserRelation
  }
}
    ${FullPlexUserRelationFragmentDoc}`;
export type SubscribeToPlexMutationFn = ApolloReactCommon.MutationFunction<SubscribeToPlexMutation, SubscribeToPlexMutationVariables>;

/**
 * __useSubscribeToPlexMutation__
 *
 * To run a mutation, you first call `useSubscribeToPlexMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubscribeToPlexMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [subscribeToPlexMutation, { data, loading, error }] = useSubscribeToPlexMutation({
 *   variables: {
 *      plexId: // value for 'plexId'
 *   },
 * });
 */
export function useSubscribeToPlexMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SubscribeToPlexMutation, SubscribeToPlexMutationVariables>) {
        return ApolloReactHooks.useMutation<SubscribeToPlexMutation, SubscribeToPlexMutationVariables>(SubscribeToPlexDocument, baseOptions);
      }
export type SubscribeToPlexMutationHookResult = ReturnType<typeof useSubscribeToPlexMutation>;
export type SubscribeToPlexMutationResult = ApolloReactCommon.MutationResult<SubscribeToPlexMutation>;
export type SubscribeToPlexMutationOptions = ApolloReactCommon.BaseMutationOptions<SubscribeToPlexMutation, SubscribeToPlexMutationVariables>;
export const SyncBoardDocument = gql`
    mutation SyncBoard($input: SyncBoardInput!) {
  syncBoard(input: $input) {
    ...boardDetails
  }
}
    ${BoardDetailsFragmentDoc}`;
export type SyncBoardMutationFn = ApolloReactCommon.MutationFunction<SyncBoardMutation, SyncBoardMutationVariables>;

/**
 * __useSyncBoardMutation__
 *
 * To run a mutation, you first call `useSyncBoardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSyncBoardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [syncBoardMutation, { data, loading, error }] = useSyncBoardMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSyncBoardMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SyncBoardMutation, SyncBoardMutationVariables>) {
        return ApolloReactHooks.useMutation<SyncBoardMutation, SyncBoardMutationVariables>(SyncBoardDocument, baseOptions);
      }
export type SyncBoardMutationHookResult = ReturnType<typeof useSyncBoardMutation>;
export type SyncBoardMutationResult = ApolloReactCommon.MutationResult<SyncBoardMutation>;
export type SyncBoardMutationOptions = ApolloReactCommon.BaseMutationOptions<SyncBoardMutation, SyncBoardMutationVariables>;
export const UpdateAnswerDocument = gql`
    mutation UpdateAnswer($answer: UpdateAnswerInput!) {
  updateAnswer(answer: $answer) {
    ...fullAnswer
  }
}
    ${FullAnswerFragmentDoc}`;
export type UpdateAnswerMutationFn = ApolloReactCommon.MutationFunction<UpdateAnswerMutation, UpdateAnswerMutationVariables>;

/**
 * __useUpdateAnswerMutation__
 *
 * To run a mutation, you first call `useUpdateAnswerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAnswerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAnswerMutation, { data, loading, error }] = useUpdateAnswerMutation({
 *   variables: {
 *      answer: // value for 'answer'
 *   },
 * });
 */
export function useUpdateAnswerMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateAnswerMutation, UpdateAnswerMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateAnswerMutation, UpdateAnswerMutationVariables>(UpdateAnswerDocument, baseOptions);
      }
export type UpdateAnswerMutationHookResult = ReturnType<typeof useUpdateAnswerMutation>;
export type UpdateAnswerMutationResult = ApolloReactCommon.MutationResult<UpdateAnswerMutation>;
export type UpdateAnswerMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateAnswerMutation, UpdateAnswerMutationVariables>;
export const UpdateBoardDocument = gql`
    mutation UpdateBoard($id: String!, $board: UpdateBoardInput!) {
  updateBoard(id: $id, board: $board) {
    ...boardDetails
  }
}
    ${BoardDetailsFragmentDoc}`;
export type UpdateBoardMutationFn = ApolloReactCommon.MutationFunction<UpdateBoardMutation, UpdateBoardMutationVariables>;

/**
 * __useUpdateBoardMutation__
 *
 * To run a mutation, you first call `useUpdateBoardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBoardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBoardMutation, { data, loading, error }] = useUpdateBoardMutation({
 *   variables: {
 *      id: // value for 'id'
 *      board: // value for 'board'
 *   },
 * });
 */
export function useUpdateBoardMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateBoardMutation, UpdateBoardMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateBoardMutation, UpdateBoardMutationVariables>(UpdateBoardDocument, baseOptions);
      }
export type UpdateBoardMutationHookResult = ReturnType<typeof useUpdateBoardMutation>;
export type UpdateBoardMutationResult = ApolloReactCommon.MutationResult<UpdateBoardMutation>;
export type UpdateBoardMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateBoardMutation, UpdateBoardMutationVariables>;
export const UpdateDomainUserDocument = gql`
    mutation UpdateDomainUser($userId: String!, $status: UserStatus, $accessControl: AccessControlEnum) {
  updateDomainUser(userId: $userId, status: $status, accessControl: $accessControl) {
    id
    email
    name
    picture
    jobTitle
    status
    accessControl
  }
}
    `;
export type UpdateDomainUserMutationFn = ApolloReactCommon.MutationFunction<UpdateDomainUserMutation, UpdateDomainUserMutationVariables>;

/**
 * __useUpdateDomainUserMutation__
 *
 * To run a mutation, you first call `useUpdateDomainUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDomainUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDomainUserMutation, { data, loading, error }] = useUpdateDomainUserMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      status: // value for 'status'
 *      accessControl: // value for 'accessControl'
 *   },
 * });
 */
export function useUpdateDomainUserMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateDomainUserMutation, UpdateDomainUserMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateDomainUserMutation, UpdateDomainUserMutationVariables>(UpdateDomainUserDocument, baseOptions);
      }
export type UpdateDomainUserMutationHookResult = ReturnType<typeof useUpdateDomainUserMutation>;
export type UpdateDomainUserMutationResult = ApolloReactCommon.MutationResult<UpdateDomainUserMutation>;
export type UpdateDomainUserMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateDomainUserMutation, UpdateDomainUserMutationVariables>;
export const UpdateEventDocument = gql`
    mutation UpdateEvent($event: UpdateEventInput!) {
  updateEvent(event: $event) {
    ...postDetails
  }
}
    ${PostDetailsFragmentDoc}`;
export type UpdateEventMutationFn = ApolloReactCommon.MutationFunction<UpdateEventMutation, UpdateEventMutationVariables>;

/**
 * __useUpdateEventMutation__
 *
 * To run a mutation, you first call `useUpdateEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEventMutation, { data, loading, error }] = useUpdateEventMutation({
 *   variables: {
 *      event: // value for 'event'
 *   },
 * });
 */
export function useUpdateEventMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateEventMutation, UpdateEventMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateEventMutation, UpdateEventMutationVariables>(UpdateEventDocument, baseOptions);
      }
export type UpdateEventMutationHookResult = ReturnType<typeof useUpdateEventMutation>;
export type UpdateEventMutationResult = ApolloReactCommon.MutationResult<UpdateEventMutation>;
export type UpdateEventMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateEventMutation, UpdateEventMutationVariables>;
export const UpdateFactDocument = gql`
    mutation UpdateFact($question: UpdateQuestionInput!) {
  updateQuestion(question: $question) {
    ...questionDetails
  }
}
    ${QuestionDetailsFragmentDoc}`;
export type UpdateFactMutationFn = ApolloReactCommon.MutationFunction<UpdateFactMutation, UpdateFactMutationVariables>;

/**
 * __useUpdateFactMutation__
 *
 * To run a mutation, you first call `useUpdateFactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFactMutation, { data, loading, error }] = useUpdateFactMutation({
 *   variables: {
 *      question: // value for 'question'
 *   },
 * });
 */
export function useUpdateFactMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateFactMutation, UpdateFactMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateFactMutation, UpdateFactMutationVariables>(UpdateFactDocument, baseOptions);
      }
export type UpdateFactMutationHookResult = ReturnType<typeof useUpdateFactMutation>;
export type UpdateFactMutationResult = ApolloReactCommon.MutationResult<UpdateFactMutation>;
export type UpdateFactMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateFactMutation, UpdateFactMutationVariables>;
export const UpdateFactReviewProcessDocument = gql`
    mutation UpdateFactReviewProcess($input: UpdateFactReviewProcessInput!) {
  updateFactReviewProcess(input: $input) {
    id
    ...factReviewProcessDetails
    createdEntities {
      id
      source {
        __typename
        ... on Task {
          ...taskDetails
        }
      }
    }
  }
}
    ${FactReviewProcessDetailsFragmentDoc}
${TaskDetailsFragmentDoc}`;
export type UpdateFactReviewProcessMutationFn = ApolloReactCommon.MutationFunction<UpdateFactReviewProcessMutation, UpdateFactReviewProcessMutationVariables>;

/**
 * __useUpdateFactReviewProcessMutation__
 *
 * To run a mutation, you first call `useUpdateFactReviewProcessMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFactReviewProcessMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFactReviewProcessMutation, { data, loading, error }] = useUpdateFactReviewProcessMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateFactReviewProcessMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateFactReviewProcessMutation, UpdateFactReviewProcessMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateFactReviewProcessMutation, UpdateFactReviewProcessMutationVariables>(UpdateFactReviewProcessDocument, baseOptions);
      }
export type UpdateFactReviewProcessMutationHookResult = ReturnType<typeof useUpdateFactReviewProcessMutation>;
export type UpdateFactReviewProcessMutationResult = ApolloReactCommon.MutationResult<UpdateFactReviewProcessMutation>;
export type UpdateFactReviewProcessMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateFactReviewProcessMutation, UpdateFactReviewProcessMutationVariables>;
export const UpdatePaymentInformationDocument = gql`
    mutation UpdatePaymentInformation($paymentMethodId: String, $billingEmail: String, $billingAddress: String) {
  updatePaymentMethod(paymentMethodId: $paymentMethodId, billingEmail: $billingEmail, billingAddress: $billingAddress) {
    ...paymentInformation
  }
}
    ${PaymentInformationFragmentDoc}`;
export type UpdatePaymentInformationMutationFn = ApolloReactCommon.MutationFunction<UpdatePaymentInformationMutation, UpdatePaymentInformationMutationVariables>;

/**
 * __useUpdatePaymentInformationMutation__
 *
 * To run a mutation, you first call `useUpdatePaymentInformationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePaymentInformationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePaymentInformationMutation, { data, loading, error }] = useUpdatePaymentInformationMutation({
 *   variables: {
 *      paymentMethodId: // value for 'paymentMethodId'
 *      billingEmail: // value for 'billingEmail'
 *      billingAddress: // value for 'billingAddress'
 *   },
 * });
 */
export function useUpdatePaymentInformationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdatePaymentInformationMutation, UpdatePaymentInformationMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdatePaymentInformationMutation, UpdatePaymentInformationMutationVariables>(UpdatePaymentInformationDocument, baseOptions);
      }
export type UpdatePaymentInformationMutationHookResult = ReturnType<typeof useUpdatePaymentInformationMutation>;
export type UpdatePaymentInformationMutationResult = ApolloReactCommon.MutationResult<UpdatePaymentInformationMutation>;
export type UpdatePaymentInformationMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdatePaymentInformationMutation, UpdatePaymentInformationMutationVariables>;
export const UpdatePlexDocument = gql`
    mutation UpdatePlex($id: String!, $plex: PlexInput!) {
  updatePlex(id: $id, plex: $plex) {
    ...fullPlex
    ...fullPlexInputError
  }
}
    ${FullPlexFragmentDoc}
${FullPlexInputErrorFragmentDoc}`;
export type UpdatePlexMutationFn = ApolloReactCommon.MutationFunction<UpdatePlexMutation, UpdatePlexMutationVariables>;

/**
 * __useUpdatePlexMutation__
 *
 * To run a mutation, you first call `useUpdatePlexMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePlexMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePlexMutation, { data, loading, error }] = useUpdatePlexMutation({
 *   variables: {
 *      id: // value for 'id'
 *      plex: // value for 'plex'
 *   },
 * });
 */
export function useUpdatePlexMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdatePlexMutation, UpdatePlexMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdatePlexMutation, UpdatePlexMutationVariables>(UpdatePlexDocument, baseOptions);
      }
export type UpdatePlexMutationHookResult = ReturnType<typeof useUpdatePlexMutation>;
export type UpdatePlexMutationResult = ApolloReactCommon.MutationResult<UpdatePlexMutation>;
export type UpdatePlexMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdatePlexMutation, UpdatePlexMutationVariables>;
export const UpdatePostDocument = gql`
    mutation UpdatePost($post: UpdatePostInput!) {
  updatePost(post: $post) {
    ...postDetails
  }
}
    ${PostDetailsFragmentDoc}`;
export type UpdatePostMutationFn = ApolloReactCommon.MutationFunction<UpdatePostMutation, UpdatePostMutationVariables>;

/**
 * __useUpdatePostMutation__
 *
 * To run a mutation, you first call `useUpdatePostMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePostMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePostMutation, { data, loading, error }] = useUpdatePostMutation({
 *   variables: {
 *      post: // value for 'post'
 *   },
 * });
 */
export function useUpdatePostMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdatePostMutation, UpdatePostMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdatePostMutation, UpdatePostMutationVariables>(UpdatePostDocument, baseOptions);
      }
export type UpdatePostMutationHookResult = ReturnType<typeof useUpdatePostMutation>;
export type UpdatePostMutationResult = ApolloReactCommon.MutationResult<UpdatePostMutation>;
export type UpdatePostMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdatePostMutation, UpdatePostMutationVariables>;
export const UpdateTaskDocument = gql`
    mutation UpdateTask($task: UpdateTaskInput!) {
  updateTask(task: $task) {
    ...taskDetails
  }
}
    ${TaskDetailsFragmentDoc}`;
export type UpdateTaskMutationFn = ApolloReactCommon.MutationFunction<UpdateTaskMutation, UpdateTaskMutationVariables>;

/**
 * __useUpdateTaskMutation__
 *
 * To run a mutation, you first call `useUpdateTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTaskMutation, { data, loading, error }] = useUpdateTaskMutation({
 *   variables: {
 *      task: // value for 'task'
 *   },
 * });
 */
export function useUpdateTaskMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateTaskMutation, UpdateTaskMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateTaskMutation, UpdateTaskMutationVariables>(UpdateTaskDocument, baseOptions);
      }
export type UpdateTaskMutationHookResult = ReturnType<typeof useUpdateTaskMutation>;
export type UpdateTaskMutationResult = ApolloReactCommon.MutationResult<UpdateTaskMutation>;
export type UpdateTaskMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateTaskMutation, UpdateTaskMutationVariables>;
export const UpdateUserSettingsDocument = gql`
    mutation UpdateUserSettings($userSettingsInput: UserSettingsInput!) {
  updateUserSettings(userSettingsInput: $userSettingsInput) {
    id
    ...userSettings
  }
}
    ${UserSettingsFragmentDoc}`;
export type UpdateUserSettingsMutationFn = ApolloReactCommon.MutationFunction<UpdateUserSettingsMutation, UpdateUserSettingsMutationVariables>;

/**
 * __useUpdateUserSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateUserSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserSettingsMutation, { data, loading, error }] = useUpdateUserSettingsMutation({
 *   variables: {
 *      userSettingsInput: // value for 'userSettingsInput'
 *   },
 * });
 */
export function useUpdateUserSettingsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateUserSettingsMutation, UpdateUserSettingsMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateUserSettingsMutation, UpdateUserSettingsMutationVariables>(UpdateUserSettingsDocument, baseOptions);
      }
export type UpdateUserSettingsMutationHookResult = ReturnType<typeof useUpdateUserSettingsMutation>;
export type UpdateUserSettingsMutationResult = ApolloReactCommon.MutationResult<UpdateUserSettingsMutation>;
export type UpdateUserSettingsMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateUserSettingsMutation, UpdateUserSettingsMutationVariables>;
export const UploadFileDocument = gql`
    mutation UploadFile($url: String!) {
  uploadFile(url: $url) {
    plexAssetUrl
  }
}
    `;
export type UploadFileMutationFn = ApolloReactCommon.MutationFunction<UploadFileMutation, UploadFileMutationVariables>;

/**
 * __useUploadFileMutation__
 *
 * To run a mutation, you first call `useUploadFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadFileMutation, { data, loading, error }] = useUploadFileMutation({
 *   variables: {
 *      url: // value for 'url'
 *   },
 * });
 */
export function useUploadFileMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UploadFileMutation, UploadFileMutationVariables>) {
        return ApolloReactHooks.useMutation<UploadFileMutation, UploadFileMutationVariables>(UploadFileDocument, baseOptions);
      }
export type UploadFileMutationHookResult = ReturnType<typeof useUploadFileMutation>;
export type UploadFileMutationResult = ApolloReactCommon.MutationResult<UploadFileMutation>;
export type UploadFileMutationOptions = ApolloReactCommon.BaseMutationOptions<UploadFileMutation, UploadFileMutationVariables>;
export const WatchPostDocument = gql`
    mutation WatchPost($payload: WatchPostPayload!) {
  watchPost(payload: $payload) {
    ...postDetails
  }
}
    ${PostDetailsFragmentDoc}`;
export type WatchPostMutationFn = ApolloReactCommon.MutationFunction<WatchPostMutation, WatchPostMutationVariables>;

/**
 * __useWatchPostMutation__
 *
 * To run a mutation, you first call `useWatchPostMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWatchPostMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [watchPostMutation, { data, loading, error }] = useWatchPostMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useWatchPostMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<WatchPostMutation, WatchPostMutationVariables>) {
        return ApolloReactHooks.useMutation<WatchPostMutation, WatchPostMutationVariables>(WatchPostDocument, baseOptions);
      }
export type WatchPostMutationHookResult = ReturnType<typeof useWatchPostMutation>;
export type WatchPostMutationResult = ApolloReactCommon.MutationResult<WatchPostMutation>;
export type WatchPostMutationOptions = ApolloReactCommon.BaseMutationOptions<WatchPostMutation, WatchPostMutationVariables>;
export const WatchQuestionDocument = gql`
    mutation WatchQuestion($payload: WatchQuestionPayload!) {
  watchQuestion(payload: $payload) {
    ...questionDetails
  }
}
    ${QuestionDetailsFragmentDoc}`;
export type WatchQuestionMutationFn = ApolloReactCommon.MutationFunction<WatchQuestionMutation, WatchQuestionMutationVariables>;

/**
 * __useWatchQuestionMutation__
 *
 * To run a mutation, you first call `useWatchQuestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWatchQuestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [watchQuestionMutation, { data, loading, error }] = useWatchQuestionMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useWatchQuestionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<WatchQuestionMutation, WatchQuestionMutationVariables>) {
        return ApolloReactHooks.useMutation<WatchQuestionMutation, WatchQuestionMutationVariables>(WatchQuestionDocument, baseOptions);
      }
export type WatchQuestionMutationHookResult = ReturnType<typeof useWatchQuestionMutation>;
export type WatchQuestionMutationResult = ApolloReactCommon.MutationResult<WatchQuestionMutation>;
export type WatchQuestionMutationOptions = ApolloReactCommon.BaseMutationOptions<WatchQuestionMutation, WatchQuestionMutationVariables>;
export const AnalyticsPostClickDocument = gql`
    mutation AnalyticsPostClick($postId: String!) {
  analyticsPostClick(id: $postId)
}
    `;
export type AnalyticsPostClickMutationFn = ApolloReactCommon.MutationFunction<AnalyticsPostClickMutation, AnalyticsPostClickMutationVariables>;

/**
 * __useAnalyticsPostClickMutation__
 *
 * To run a mutation, you first call `useAnalyticsPostClickMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAnalyticsPostClickMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [analyticsPostClickMutation, { data, loading, error }] = useAnalyticsPostClickMutation({
 *   variables: {
 *      postId: // value for 'postId'
 *   },
 * });
 */
export function useAnalyticsPostClickMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AnalyticsPostClickMutation, AnalyticsPostClickMutationVariables>) {
        return ApolloReactHooks.useMutation<AnalyticsPostClickMutation, AnalyticsPostClickMutationVariables>(AnalyticsPostClickDocument, baseOptions);
      }
export type AnalyticsPostClickMutationHookResult = ReturnType<typeof useAnalyticsPostClickMutation>;
export type AnalyticsPostClickMutationResult = ApolloReactCommon.MutationResult<AnalyticsPostClickMutation>;
export type AnalyticsPostClickMutationOptions = ApolloReactCommon.BaseMutationOptions<AnalyticsPostClickMutation, AnalyticsPostClickMutationVariables>;
export const AnalyticsPostImpressionDocument = gql`
    mutation AnalyticsPostImpression($postId: String!) {
  analyticsPostImpression(id: $postId)
}
    `;
export type AnalyticsPostImpressionMutationFn = ApolloReactCommon.MutationFunction<AnalyticsPostImpressionMutation, AnalyticsPostImpressionMutationVariables>;

/**
 * __useAnalyticsPostImpressionMutation__
 *
 * To run a mutation, you first call `useAnalyticsPostImpressionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAnalyticsPostImpressionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [analyticsPostImpressionMutation, { data, loading, error }] = useAnalyticsPostImpressionMutation({
 *   variables: {
 *      postId: // value for 'postId'
 *   },
 * });
 */
export function useAnalyticsPostImpressionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AnalyticsPostImpressionMutation, AnalyticsPostImpressionMutationVariables>) {
        return ApolloReactHooks.useMutation<AnalyticsPostImpressionMutation, AnalyticsPostImpressionMutationVariables>(AnalyticsPostImpressionDocument, baseOptions);
      }
export type AnalyticsPostImpressionMutationHookResult = ReturnType<typeof useAnalyticsPostImpressionMutation>;
export type AnalyticsPostImpressionMutationResult = ApolloReactCommon.MutationResult<AnalyticsPostImpressionMutation>;
export type AnalyticsPostImpressionMutationOptions = ApolloReactCommon.BaseMutationOptions<AnalyticsPostImpressionMutation, AnalyticsPostImpressionMutationVariables>;
export const AnalyticsQuestionClickDocument = gql`
    mutation AnalyticsQuestionClick($questionId: String!) {
  analyticsQuestionClick(id: $questionId)
}
    `;
export type AnalyticsQuestionClickMutationFn = ApolloReactCommon.MutationFunction<AnalyticsQuestionClickMutation, AnalyticsQuestionClickMutationVariables>;

/**
 * __useAnalyticsQuestionClickMutation__
 *
 * To run a mutation, you first call `useAnalyticsQuestionClickMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAnalyticsQuestionClickMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [analyticsQuestionClickMutation, { data, loading, error }] = useAnalyticsQuestionClickMutation({
 *   variables: {
 *      questionId: // value for 'questionId'
 *   },
 * });
 */
export function useAnalyticsQuestionClickMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AnalyticsQuestionClickMutation, AnalyticsQuestionClickMutationVariables>) {
        return ApolloReactHooks.useMutation<AnalyticsQuestionClickMutation, AnalyticsQuestionClickMutationVariables>(AnalyticsQuestionClickDocument, baseOptions);
      }
export type AnalyticsQuestionClickMutationHookResult = ReturnType<typeof useAnalyticsQuestionClickMutation>;
export type AnalyticsQuestionClickMutationResult = ApolloReactCommon.MutationResult<AnalyticsQuestionClickMutation>;
export type AnalyticsQuestionClickMutationOptions = ApolloReactCommon.BaseMutationOptions<AnalyticsQuestionClickMutation, AnalyticsQuestionClickMutationVariables>;
export const AnalyticsQuestionImpressionDocument = gql`
    mutation AnalyticsQuestionImpression($questionId: String!) {
  analyticsQuestionImpression(id: $questionId)
}
    `;
export type AnalyticsQuestionImpressionMutationFn = ApolloReactCommon.MutationFunction<AnalyticsQuestionImpressionMutation, AnalyticsQuestionImpressionMutationVariables>;

/**
 * __useAnalyticsQuestionImpressionMutation__
 *
 * To run a mutation, you first call `useAnalyticsQuestionImpressionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAnalyticsQuestionImpressionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [analyticsQuestionImpressionMutation, { data, loading, error }] = useAnalyticsQuestionImpressionMutation({
 *   variables: {
 *      questionId: // value for 'questionId'
 *   },
 * });
 */
export function useAnalyticsQuestionImpressionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AnalyticsQuestionImpressionMutation, AnalyticsQuestionImpressionMutationVariables>) {
        return ApolloReactHooks.useMutation<AnalyticsQuestionImpressionMutation, AnalyticsQuestionImpressionMutationVariables>(AnalyticsQuestionImpressionDocument, baseOptions);
      }
export type AnalyticsQuestionImpressionMutationHookResult = ReturnType<typeof useAnalyticsQuestionImpressionMutation>;
export type AnalyticsQuestionImpressionMutationResult = ApolloReactCommon.MutationResult<AnalyticsQuestionImpressionMutation>;
export type AnalyticsQuestionImpressionMutationOptions = ApolloReactCommon.BaseMutationOptions<AnalyticsQuestionImpressionMutation, AnalyticsQuestionImpressionMutationVariables>;
export const DeleteTaskEntityRelationDocument = gql`
    mutation DeleteTaskEntityRelation($entityRelationId: String!) {
  deleteEntityRelation(entityRelationId: $entityRelationId) {
    ...taskDetailsEntityRelation
  }
}
    ${TaskDetailsEntityRelationFragmentDoc}`;
export type DeleteTaskEntityRelationMutationFn = ApolloReactCommon.MutationFunction<DeleteTaskEntityRelationMutation, DeleteTaskEntityRelationMutationVariables>;

/**
 * __useDeleteTaskEntityRelationMutation__
 *
 * To run a mutation, you first call `useDeleteTaskEntityRelationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTaskEntityRelationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTaskEntityRelationMutation, { data, loading, error }] = useDeleteTaskEntityRelationMutation({
 *   variables: {
 *      entityRelationId: // value for 'entityRelationId'
 *   },
 * });
 */
export function useDeleteTaskEntityRelationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteTaskEntityRelationMutation, DeleteTaskEntityRelationMutationVariables>) {
        return ApolloReactHooks.useMutation<DeleteTaskEntityRelationMutation, DeleteTaskEntityRelationMutationVariables>(DeleteTaskEntityRelationDocument, baseOptions);
      }
export type DeleteTaskEntityRelationMutationHookResult = ReturnType<typeof useDeleteTaskEntityRelationMutation>;
export type DeleteTaskEntityRelationMutationResult = ApolloReactCommon.MutationResult<DeleteTaskEntityRelationMutation>;
export type DeleteTaskEntityRelationMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteTaskEntityRelationMutation, DeleteTaskEntityRelationMutationVariables>;
export const DomainPlexesDocument = gql`
    query DomainPlexes($cursor: String) {
  currentUser {
    id
    domain {
      id
      plexes(cursor: $cursor, limit: 60) {
        items {
          ...plexDomainSummary
        }
        nextCursor
      }
    }
  }
}
    ${PlexDomainSummaryFragmentDoc}`;

/**
 * __useDomainPlexesQuery__
 *
 * To run a query within a React component, call `useDomainPlexesQuery` and pass it any options that fit your needs.
 * When your component renders, `useDomainPlexesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDomainPlexesQuery({
 *   variables: {
 *      cursor: // value for 'cursor'
 *   },
 * });
 */
export function useDomainPlexesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<DomainPlexesQuery, DomainPlexesQueryVariables>) {
        return ApolloReactHooks.useQuery<DomainPlexesQuery, DomainPlexesQueryVariables>(DomainPlexesDocument, baseOptions);
      }
export function useDomainPlexesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<DomainPlexesQuery, DomainPlexesQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<DomainPlexesQuery, DomainPlexesQueryVariables>(DomainPlexesDocument, baseOptions);
        }
export type DomainPlexesQueryHookResult = ReturnType<typeof useDomainPlexesQuery>;
export type DomainPlexesLazyQueryHookResult = ReturnType<typeof useDomainPlexesLazyQuery>;
export type DomainPlexesQueryResult = ApolloReactCommon.QueryResult<DomainPlexesQuery, DomainPlexesQueryVariables>;
export const DomainSlackChannelsDocument = gql`
    query DomainSlackChannels($cursor: String) {
  currentUser {
    id
    domain {
      id
      slackChannels(cursor: $cursor, limit: 200) {
        results {
          id
          name
        }
        nextCursor
      }
    }
  }
}
    `;

/**
 * __useDomainSlackChannelsQuery__
 *
 * To run a query within a React component, call `useDomainSlackChannelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDomainSlackChannelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDomainSlackChannelsQuery({
 *   variables: {
 *      cursor: // value for 'cursor'
 *   },
 * });
 */
export function useDomainSlackChannelsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<DomainSlackChannelsQuery, DomainSlackChannelsQueryVariables>) {
        return ApolloReactHooks.useQuery<DomainSlackChannelsQuery, DomainSlackChannelsQueryVariables>(DomainSlackChannelsDocument, baseOptions);
      }
export function useDomainSlackChannelsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<DomainSlackChannelsQuery, DomainSlackChannelsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<DomainSlackChannelsQuery, DomainSlackChannelsQueryVariables>(DomainSlackChannelsDocument, baseOptions);
        }
export type DomainSlackChannelsQueryHookResult = ReturnType<typeof useDomainSlackChannelsQuery>;
export type DomainSlackChannelsLazyQueryHookResult = ReturnType<typeof useDomainSlackChannelsLazyQuery>;
export type DomainSlackChannelsQueryResult = ApolloReactCommon.QueryResult<DomainSlackChannelsQuery, DomainSlackChannelsQueryVariables>;
export const GetBoardBeforeSyncDocument = gql`
    query GetBoardBeforeSync($boardId: String!) {
  loggedIn {
    boardById(id: $boardId) {
      id
      plexId
      source {
        __typename
        ... on GoogleDocumentSource {
          url
          headingIds
        }
      }
      questions(limit: 100, filterPublishStatus: ALL, labelIds: []) {
        items {
          id
          source {
            __typename
            ... on GoogleDocumentSource {
              externalEntityId
              headingIds
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetBoardBeforeSyncQuery__
 *
 * To run a query within a React component, call `useGetBoardBeforeSyncQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBoardBeforeSyncQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBoardBeforeSyncQuery({
 *   variables: {
 *      boardId: // value for 'boardId'
 *   },
 * });
 */
export function useGetBoardBeforeSyncQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetBoardBeforeSyncQuery, GetBoardBeforeSyncQueryVariables>) {
        return ApolloReactHooks.useQuery<GetBoardBeforeSyncQuery, GetBoardBeforeSyncQueryVariables>(GetBoardBeforeSyncDocument, baseOptions);
      }
export function useGetBoardBeforeSyncLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetBoardBeforeSyncQuery, GetBoardBeforeSyncQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetBoardBeforeSyncQuery, GetBoardBeforeSyncQueryVariables>(GetBoardBeforeSyncDocument, baseOptions);
        }
export type GetBoardBeforeSyncQueryHookResult = ReturnType<typeof useGetBoardBeforeSyncQuery>;
export type GetBoardBeforeSyncLazyQueryHookResult = ReturnType<typeof useGetBoardBeforeSyncLazyQuery>;
export type GetBoardBeforeSyncQueryResult = ApolloReactCommon.QueryResult<GetBoardBeforeSyncQuery, GetBoardBeforeSyncQueryVariables>;
export const GetBoardByIdDocument = gql`
    query GetBoardById($boardId: String!) {
  loggedIn {
    boardById(id: $boardId) {
      ...boardDetails
    }
  }
}
    ${BoardDetailsFragmentDoc}`;

/**
 * __useGetBoardByIdQuery__
 *
 * To run a query within a React component, call `useGetBoardByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBoardByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBoardByIdQuery({
 *   variables: {
 *      boardId: // value for 'boardId'
 *   },
 * });
 */
export function useGetBoardByIdQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetBoardByIdQuery, GetBoardByIdQueryVariables>) {
        return ApolloReactHooks.useQuery<GetBoardByIdQuery, GetBoardByIdQueryVariables>(GetBoardByIdDocument, baseOptions);
      }
export function useGetBoardByIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetBoardByIdQuery, GetBoardByIdQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetBoardByIdQuery, GetBoardByIdQueryVariables>(GetBoardByIdDocument, baseOptions);
        }
export type GetBoardByIdQueryHookResult = ReturnType<typeof useGetBoardByIdQuery>;
export type GetBoardByIdLazyQueryHookResult = ReturnType<typeof useGetBoardByIdLazyQuery>;
export type GetBoardByIdQueryResult = ApolloReactCommon.QueryResult<GetBoardByIdQuery, GetBoardByIdQueryVariables>;
export const GetFeedQuestionsInBoardDocument = gql`
    query GetFeedQuestionsInBoard($boardId: String!, $cursor: Int, $filterPublishStatus: FilterPublishStatus!, $labelIds: [String!]!) {
  loggedIn {
    boardById(id: $boardId) {
      questions(cursor: $cursor, limit: 30, filterPublishStatus: $filterPublishStatus, labelIds: $labelIds) {
        items {
          ...feedQuestionDetails
        }
        nextCursor
      }
    }
  }
}
    ${FeedQuestionDetailsFragmentDoc}`;

/**
 * __useGetFeedQuestionsInBoardQuery__
 *
 * To run a query within a React component, call `useGetFeedQuestionsInBoardQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFeedQuestionsInBoardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFeedQuestionsInBoardQuery({
 *   variables: {
 *      boardId: // value for 'boardId'
 *      cursor: // value for 'cursor'
 *      filterPublishStatus: // value for 'filterPublishStatus'
 *      labelIds: // value for 'labelIds'
 *   },
 * });
 */
export function useGetFeedQuestionsInBoardQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetFeedQuestionsInBoardQuery, GetFeedQuestionsInBoardQueryVariables>) {
        return ApolloReactHooks.useQuery<GetFeedQuestionsInBoardQuery, GetFeedQuestionsInBoardQueryVariables>(GetFeedQuestionsInBoardDocument, baseOptions);
      }
export function useGetFeedQuestionsInBoardLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetFeedQuestionsInBoardQuery, GetFeedQuestionsInBoardQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetFeedQuestionsInBoardQuery, GetFeedQuestionsInBoardQueryVariables>(GetFeedQuestionsInBoardDocument, baseOptions);
        }
export type GetFeedQuestionsInBoardQueryHookResult = ReturnType<typeof useGetFeedQuestionsInBoardQuery>;
export type GetFeedQuestionsInBoardLazyQueryHookResult = ReturnType<typeof useGetFeedQuestionsInBoardLazyQuery>;
export type GetFeedQuestionsInBoardQueryResult = ApolloReactCommon.QueryResult<GetFeedQuestionsInBoardQuery, GetFeedQuestionsInBoardQueryVariables>;
export const GetBoardTemplatesDocument = gql`
    query GetBoardTemplates {
  boardTemplates {
    ...fullBoardTemplate
  }
}
    ${FullBoardTemplateFragmentDoc}`;

/**
 * __useGetBoardTemplatesQuery__
 *
 * To run a query within a React component, call `useGetBoardTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBoardTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBoardTemplatesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetBoardTemplatesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetBoardTemplatesQuery, GetBoardTemplatesQueryVariables>) {
        return ApolloReactHooks.useQuery<GetBoardTemplatesQuery, GetBoardTemplatesQueryVariables>(GetBoardTemplatesDocument, baseOptions);
      }
export function useGetBoardTemplatesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetBoardTemplatesQuery, GetBoardTemplatesQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetBoardTemplatesQuery, GetBoardTemplatesQueryVariables>(GetBoardTemplatesDocument, baseOptions);
        }
export type GetBoardTemplatesQueryHookResult = ReturnType<typeof useGetBoardTemplatesQuery>;
export type GetBoardTemplatesLazyQueryHookResult = ReturnType<typeof useGetBoardTemplatesLazyQuery>;
export type GetBoardTemplatesQueryResult = ApolloReactCommon.QueryResult<GetBoardTemplatesQuery, GetBoardTemplatesQueryVariables>;
export const GetBoardsNamesDocument = gql`
    query GetBoardsNames($plexId: String!) {
  loggedIn {
    plexById(id: $plexId) {
      id
      boards {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useGetBoardsNamesQuery__
 *
 * To run a query within a React component, call `useGetBoardsNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBoardsNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBoardsNamesQuery({
 *   variables: {
 *      plexId: // value for 'plexId'
 *   },
 * });
 */
export function useGetBoardsNamesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetBoardsNamesQuery, GetBoardsNamesQueryVariables>) {
        return ApolloReactHooks.useQuery<GetBoardsNamesQuery, GetBoardsNamesQueryVariables>(GetBoardsNamesDocument, baseOptions);
      }
export function useGetBoardsNamesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetBoardsNamesQuery, GetBoardsNamesQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetBoardsNamesQuery, GetBoardsNamesQueryVariables>(GetBoardsNamesDocument, baseOptions);
        }
export type GetBoardsNamesQueryHookResult = ReturnType<typeof useGetBoardsNamesQuery>;
export type GetBoardsNamesLazyQueryHookResult = ReturnType<typeof useGetBoardsNamesLazyQuery>;
export type GetBoardsNamesQueryResult = ApolloReactCommon.QueryResult<GetBoardsNamesQuery, GetBoardsNamesQueryVariables>;
export const GetCommentDocument = gql`
    query GetComment($commentId: String!) {
  loggedIn {
    commentById(id: $commentId) {
      id
      body
      question {
        id
        boardId
      }
      post {
        id
        plex {
          id
          defaultBoardId
        }
      }
    }
  }
}
    `;

/**
 * __useGetCommentQuery__
 *
 * To run a query within a React component, call `useGetCommentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCommentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCommentQuery({
 *   variables: {
 *      commentId: // value for 'commentId'
 *   },
 * });
 */
export function useGetCommentQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetCommentQuery, GetCommentQueryVariables>) {
        return ApolloReactHooks.useQuery<GetCommentQuery, GetCommentQueryVariables>(GetCommentDocument, baseOptions);
      }
export function useGetCommentLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetCommentQuery, GetCommentQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetCommentQuery, GetCommentQueryVariables>(GetCommentDocument, baseOptions);
        }
export type GetCommentQueryHookResult = ReturnType<typeof useGetCommentQuery>;
export type GetCommentLazyQueryHookResult = ReturnType<typeof useGetCommentLazyQuery>;
export type GetCommentQueryResult = ApolloReactCommon.QueryResult<GetCommentQuery, GetCommentQueryVariables>;
export const GetDocumentToImportDocument = gql`
    query GetDocumentToImport($url: String!) {
  linkMetadata(url: $url) {
    details {
      __typename
      ... on GoogleDocLinkMetadata {
        fileId
        headingId
        bookmarkId
        fileMetadata {
          externalEntityId
        }
        document {
          __typename
          ... on GoogleDoc {
            title
            content
          }
          ... on GoogleDocError {
            code
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetDocumentToImportQuery__
 *
 * To run a query within a React component, call `useGetDocumentToImportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDocumentToImportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDocumentToImportQuery({
 *   variables: {
 *      url: // value for 'url'
 *   },
 * });
 */
export function useGetDocumentToImportQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetDocumentToImportQuery, GetDocumentToImportQueryVariables>) {
        return ApolloReactHooks.useQuery<GetDocumentToImportQuery, GetDocumentToImportQueryVariables>(GetDocumentToImportDocument, baseOptions);
      }
export function useGetDocumentToImportLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetDocumentToImportQuery, GetDocumentToImportQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetDocumentToImportQuery, GetDocumentToImportQueryVariables>(GetDocumentToImportDocument, baseOptions);
        }
export type GetDocumentToImportQueryHookResult = ReturnType<typeof useGetDocumentToImportQuery>;
export type GetDocumentToImportLazyQueryHookResult = ReturnType<typeof useGetDocumentToImportLazyQuery>;
export type GetDocumentToImportQueryResult = ApolloReactCommon.QueryResult<GetDocumentToImportQuery, GetDocumentToImportQueryVariables>;
export const GetDomainUsersDocument = gql`
    query GetDomainUsers($cursor: String, $limit: Int) {
  currentUser {
    id
    domain {
      id
      users(cursor: $cursor, limit: $limit) {
        users {
          id
          email
          name
          picture
          jobTitle
          status
          accessControl
        }
        nextCursor
      }
    }
  }
}
    `;

/**
 * __useGetDomainUsersQuery__
 *
 * To run a query within a React component, call `useGetDomainUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDomainUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDomainUsersQuery({
 *   variables: {
 *      cursor: // value for 'cursor'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetDomainUsersQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetDomainUsersQuery, GetDomainUsersQueryVariables>) {
        return ApolloReactHooks.useQuery<GetDomainUsersQuery, GetDomainUsersQueryVariables>(GetDomainUsersDocument, baseOptions);
      }
export function useGetDomainUsersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetDomainUsersQuery, GetDomainUsersQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetDomainUsersQuery, GetDomainUsersQueryVariables>(GetDomainUsersDocument, baseOptions);
        }
export type GetDomainUsersQueryHookResult = ReturnType<typeof useGetDomainUsersQuery>;
export type GetDomainUsersLazyQueryHookResult = ReturnType<typeof useGetDomainUsersLazyQuery>;
export type GetDomainUsersQueryResult = ApolloReactCommon.QueryResult<GetDomainUsersQuery, GetDomainUsersQueryVariables>;
export const GetFactAnswerDetailsDocument = gql`
    query GetFactAnswerDetails($factAnswerId: String!) {
  loggedIn {
    factAnswerById(id: $factAnswerId) {
      ...fullAnswer
    }
  }
}
    ${FullAnswerFragmentDoc}`;

/**
 * __useGetFactAnswerDetailsQuery__
 *
 * To run a query within a React component, call `useGetFactAnswerDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFactAnswerDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFactAnswerDetailsQuery({
 *   variables: {
 *      factAnswerId: // value for 'factAnswerId'
 *   },
 * });
 */
export function useGetFactAnswerDetailsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetFactAnswerDetailsQuery, GetFactAnswerDetailsQueryVariables>) {
        return ApolloReactHooks.useQuery<GetFactAnswerDetailsQuery, GetFactAnswerDetailsQueryVariables>(GetFactAnswerDetailsDocument, baseOptions);
      }
export function useGetFactAnswerDetailsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetFactAnswerDetailsQuery, GetFactAnswerDetailsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetFactAnswerDetailsQuery, GetFactAnswerDetailsQueryVariables>(GetFactAnswerDetailsDocument, baseOptions);
        }
export type GetFactAnswerDetailsQueryHookResult = ReturnType<typeof useGetFactAnswerDetailsQuery>;
export type GetFactAnswerDetailsLazyQueryHookResult = ReturnType<typeof useGetFactAnswerDetailsLazyQuery>;
export type GetFactAnswerDetailsQueryResult = ApolloReactCommon.QueryResult<GetFactAnswerDetailsQuery, GetFactAnswerDetailsQueryVariables>;
export const GetFactReviewProcessDocument = gql`
    query GetFactReviewProcess($factReviewProcessId: String!) {
  factReviewProcessById(id: $factReviewProcessId) {
    ...factReviewProcessDetails
  }
}
    ${FactReviewProcessDetailsFragmentDoc}`;

/**
 * __useGetFactReviewProcessQuery__
 *
 * To run a query within a React component, call `useGetFactReviewProcessQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFactReviewProcessQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFactReviewProcessQuery({
 *   variables: {
 *      factReviewProcessId: // value for 'factReviewProcessId'
 *   },
 * });
 */
export function useGetFactReviewProcessQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetFactReviewProcessQuery, GetFactReviewProcessQueryVariables>) {
        return ApolloReactHooks.useQuery<GetFactReviewProcessQuery, GetFactReviewProcessQueryVariables>(GetFactReviewProcessDocument, baseOptions);
      }
export function useGetFactReviewProcessLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetFactReviewProcessQuery, GetFactReviewProcessQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetFactReviewProcessQuery, GetFactReviewProcessQueryVariables>(GetFactReviewProcessDocument, baseOptions);
        }
export type GetFactReviewProcessQueryHookResult = ReturnType<typeof useGetFactReviewProcessQuery>;
export type GetFactReviewProcessLazyQueryHookResult = ReturnType<typeof useGetFactReviewProcessLazyQuery>;
export type GetFactReviewProcessQueryResult = ApolloReactCommon.QueryResult<GetFactReviewProcessQuery, GetFactReviewProcessQueryVariables>;
export const GetFeedBoardsDocument = gql`
    query GetFeedBoards($cursor: Int, $plexIds: [String!]!, $filterPublishStatus: FilterPublishStatus!, $labelIds: [String!]!) {
  loggedIn {
    feedBoards(cursor: $cursor, plexIds: $plexIds) {
      nextCursor
      items {
        ...feedBoardResponse
      }
    }
  }
}
    ${FeedBoardResponseFragmentDoc}`;

/**
 * __useGetFeedBoardsQuery__
 *
 * To run a query within a React component, call `useGetFeedBoardsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFeedBoardsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFeedBoardsQuery({
 *   variables: {
 *      cursor: // value for 'cursor'
 *      plexIds: // value for 'plexIds'
 *      filterPublishStatus: // value for 'filterPublishStatus'
 *      labelIds: // value for 'labelIds'
 *   },
 * });
 */
export function useGetFeedBoardsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetFeedBoardsQuery, GetFeedBoardsQueryVariables>) {
        return ApolloReactHooks.useQuery<GetFeedBoardsQuery, GetFeedBoardsQueryVariables>(GetFeedBoardsDocument, baseOptions);
      }
export function useGetFeedBoardsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetFeedBoardsQuery, GetFeedBoardsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetFeedBoardsQuery, GetFeedBoardsQueryVariables>(GetFeedBoardsDocument, baseOptions);
        }
export type GetFeedBoardsQueryHookResult = ReturnType<typeof useGetFeedBoardsQuery>;
export type GetFeedBoardsLazyQueryHookResult = ReturnType<typeof useGetFeedBoardsLazyQuery>;
export type GetFeedBoardsQueryResult = ApolloReactCommon.QueryResult<GetFeedBoardsQuery, GetFeedBoardsQueryVariables>;
export const GetGoogleCalendarEventsDocument = gql`
    query GetGoogleCalendarEvents($calendarId: String!, $startTimeMin: DateTime, $startTimeMax: DateTime, $limit: Int, $cursor: String) {
  currentUser {
    id
    googleCalendarEvents(calendarId: $calendarId, limit: $limit, startTimeMin: $startTimeMin, startTimeMax: $startTimeMax, cursor: $cursor) {
      events {
        id
        summary
        description
        creator
        startTime
      }
      nextCursor
    }
  }
}
    `;

/**
 * __useGetGoogleCalendarEventsQuery__
 *
 * To run a query within a React component, call `useGetGoogleCalendarEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGoogleCalendarEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGoogleCalendarEventsQuery({
 *   variables: {
 *      calendarId: // value for 'calendarId'
 *      startTimeMin: // value for 'startTimeMin'
 *      startTimeMax: // value for 'startTimeMax'
 *      limit: // value for 'limit'
 *      cursor: // value for 'cursor'
 *   },
 * });
 */
export function useGetGoogleCalendarEventsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetGoogleCalendarEventsQuery, GetGoogleCalendarEventsQueryVariables>) {
        return ApolloReactHooks.useQuery<GetGoogleCalendarEventsQuery, GetGoogleCalendarEventsQueryVariables>(GetGoogleCalendarEventsDocument, baseOptions);
      }
export function useGetGoogleCalendarEventsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetGoogleCalendarEventsQuery, GetGoogleCalendarEventsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetGoogleCalendarEventsQuery, GetGoogleCalendarEventsQueryVariables>(GetGoogleCalendarEventsDocument, baseOptions);
        }
export type GetGoogleCalendarEventsQueryHookResult = ReturnType<typeof useGetGoogleCalendarEventsQuery>;
export type GetGoogleCalendarEventsLazyQueryHookResult = ReturnType<typeof useGetGoogleCalendarEventsLazyQuery>;
export type GetGoogleCalendarEventsQueryResult = ApolloReactCommon.QueryResult<GetGoogleCalendarEventsQuery, GetGoogleCalendarEventsQueryVariables>;
export const GetGoogleCalendarsDocument = gql`
    query GetGoogleCalendars {
  currentUser {
    id
    googleCalendars {
      id
      summary
      description
    }
  }
}
    `;

/**
 * __useGetGoogleCalendarsQuery__
 *
 * To run a query within a React component, call `useGetGoogleCalendarsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGoogleCalendarsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGoogleCalendarsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetGoogleCalendarsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetGoogleCalendarsQuery, GetGoogleCalendarsQueryVariables>) {
        return ApolloReactHooks.useQuery<GetGoogleCalendarsQuery, GetGoogleCalendarsQueryVariables>(GetGoogleCalendarsDocument, baseOptions);
      }
export function useGetGoogleCalendarsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetGoogleCalendarsQuery, GetGoogleCalendarsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetGoogleCalendarsQuery, GetGoogleCalendarsQueryVariables>(GetGoogleCalendarsDocument, baseOptions);
        }
export type GetGoogleCalendarsQueryHookResult = ReturnType<typeof useGetGoogleCalendarsQuery>;
export type GetGoogleCalendarsLazyQueryHookResult = ReturnType<typeof useGetGoogleCalendarsLazyQuery>;
export type GetGoogleCalendarsQueryResult = ApolloReactCommon.QueryResult<GetGoogleCalendarsQuery, GetGoogleCalendarsQueryVariables>;
export const GetLabelsDocument = gql`
    query GetLabels {
  loggedIn {
    labels {
      id
      name
    }
  }
}
    `;

/**
 * __useGetLabelsQuery__
 *
 * To run a query within a React component, call `useGetLabelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLabelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLabelsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetLabelsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetLabelsQuery, GetLabelsQueryVariables>) {
        return ApolloReactHooks.useQuery<GetLabelsQuery, GetLabelsQueryVariables>(GetLabelsDocument, baseOptions);
      }
export function useGetLabelsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetLabelsQuery, GetLabelsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetLabelsQuery, GetLabelsQueryVariables>(GetLabelsDocument, baseOptions);
        }
export type GetLabelsQueryHookResult = ReturnType<typeof useGetLabelsQuery>;
export type GetLabelsLazyQueryHookResult = ReturnType<typeof useGetLabelsLazyQuery>;
export type GetLabelsQueryResult = ApolloReactCommon.QueryResult<GetLabelsQuery, GetLabelsQueryVariables>;
export const GetLinkMetadataDocument = gql`
    query GetLinkMetadata($url: String!) {
  linkMetadata(url: $url) {
    ...linkPreviewMetadata
  }
}
    ${LinkPreviewMetadataFragmentDoc}`;

/**
 * __useGetLinkMetadataQuery__
 *
 * To run a query within a React component, call `useGetLinkMetadataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLinkMetadataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLinkMetadataQuery({
 *   variables: {
 *      url: // value for 'url'
 *   },
 * });
 */
export function useGetLinkMetadataQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetLinkMetadataQuery, GetLinkMetadataQueryVariables>) {
        return ApolloReactHooks.useQuery<GetLinkMetadataQuery, GetLinkMetadataQueryVariables>(GetLinkMetadataDocument, baseOptions);
      }
export function useGetLinkMetadataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetLinkMetadataQuery, GetLinkMetadataQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetLinkMetadataQuery, GetLinkMetadataQueryVariables>(GetLinkMetadataDocument, baseOptions);
        }
export type GetLinkMetadataQueryHookResult = ReturnType<typeof useGetLinkMetadataQuery>;
export type GetLinkMetadataLazyQueryHookResult = ReturnType<typeof useGetLinkMetadataLazyQuery>;
export type GetLinkMetadataQueryResult = ApolloReactCommon.QueryResult<GetLinkMetadataQuery, GetLinkMetadataQueryVariables>;
export const GetLoggedInUserDocument = gql`
    query GetLoggedInUser {
  currentUser {
    id
    email
    status
    plexes {
      ...plexOverview
    }
    domain {
      ...domain
    }
    ...userSettings
  }
}
    ${PlexOverviewFragmentDoc}
${DomainFragmentDoc}
${UserSettingsFragmentDoc}`;

/**
 * __useGetLoggedInUserQuery__
 *
 * To run a query within a React component, call `useGetLoggedInUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLoggedInUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLoggedInUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetLoggedInUserQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetLoggedInUserQuery, GetLoggedInUserQueryVariables>) {
        return ApolloReactHooks.useQuery<GetLoggedInUserQuery, GetLoggedInUserQueryVariables>(GetLoggedInUserDocument, baseOptions);
      }
export function useGetLoggedInUserLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetLoggedInUserQuery, GetLoggedInUserQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetLoggedInUserQuery, GetLoggedInUserQueryVariables>(GetLoggedInUserDocument, baseOptions);
        }
export type GetLoggedInUserQueryHookResult = ReturnType<typeof useGetLoggedInUserQuery>;
export type GetLoggedInUserLazyQueryHookResult = ReturnType<typeof useGetLoggedInUserLazyQuery>;
export type GetLoggedInUserQueryResult = ApolloReactCommon.QueryResult<GetLoggedInUserQuery, GetLoggedInUserQueryVariables>;
export const GetNotificationsActivityDocument = gql`
    query GetNotificationsActivity($cursor: Int) {
  loggedIn {
    notificationsActivity(cursor: $cursor) {
      items {
        ...notificationActivity
      }
      nextCursor
    }
  }
}
    ${NotificationActivityFragmentDoc}`;

/**
 * __useGetNotificationsActivityQuery__
 *
 * To run a query within a React component, call `useGetNotificationsActivityQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNotificationsActivityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNotificationsActivityQuery({
 *   variables: {
 *      cursor: // value for 'cursor'
 *   },
 * });
 */
export function useGetNotificationsActivityQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetNotificationsActivityQuery, GetNotificationsActivityQueryVariables>) {
        return ApolloReactHooks.useQuery<GetNotificationsActivityQuery, GetNotificationsActivityQueryVariables>(GetNotificationsActivityDocument, baseOptions);
      }
export function useGetNotificationsActivityLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetNotificationsActivityQuery, GetNotificationsActivityQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetNotificationsActivityQuery, GetNotificationsActivityQueryVariables>(GetNotificationsActivityDocument, baseOptions);
        }
export type GetNotificationsActivityQueryHookResult = ReturnType<typeof useGetNotificationsActivityQuery>;
export type GetNotificationsActivityLazyQueryHookResult = ReturnType<typeof useGetNotificationsActivityLazyQuery>;
export type GetNotificationsActivityQueryResult = ApolloReactCommon.QueryResult<GetNotificationsActivityQuery, GetNotificationsActivityQueryVariables>;
export const GetNotificationsActivityUnreadCountDocument = gql`
    query GetNotificationsActivityUnreadCount {
  loggedIn {
    notificationsActivityUnreadCount
  }
}
    `;

/**
 * __useGetNotificationsActivityUnreadCountQuery__
 *
 * To run a query within a React component, call `useGetNotificationsActivityUnreadCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNotificationsActivityUnreadCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNotificationsActivityUnreadCountQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetNotificationsActivityUnreadCountQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetNotificationsActivityUnreadCountQuery, GetNotificationsActivityUnreadCountQueryVariables>) {
        return ApolloReactHooks.useQuery<GetNotificationsActivityUnreadCountQuery, GetNotificationsActivityUnreadCountQueryVariables>(GetNotificationsActivityUnreadCountDocument, baseOptions);
      }
export function useGetNotificationsActivityUnreadCountLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetNotificationsActivityUnreadCountQuery, GetNotificationsActivityUnreadCountQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetNotificationsActivityUnreadCountQuery, GetNotificationsActivityUnreadCountQueryVariables>(GetNotificationsActivityUnreadCountDocument, baseOptions);
        }
export type GetNotificationsActivityUnreadCountQueryHookResult = ReturnType<typeof useGetNotificationsActivityUnreadCountQuery>;
export type GetNotificationsActivityUnreadCountLazyQueryHookResult = ReturnType<typeof useGetNotificationsActivityUnreadCountLazyQuery>;
export type GetNotificationsActivityUnreadCountQueryResult = ApolloReactCommon.QueryResult<GetNotificationsActivityUnreadCountQuery, GetNotificationsActivityUnreadCountQueryVariables>;
export const GetPaymentInformationDocument = gql`
    query GetPaymentInformation {
  currentUser {
    id
    domain {
      ...paymentInformation
    }
  }
}
    ${PaymentInformationFragmentDoc}`;

/**
 * __useGetPaymentInformationQuery__
 *
 * To run a query within a React component, call `useGetPaymentInformationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaymentInformationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaymentInformationQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPaymentInformationQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetPaymentInformationQuery, GetPaymentInformationQueryVariables>) {
        return ApolloReactHooks.useQuery<GetPaymentInformationQuery, GetPaymentInformationQueryVariables>(GetPaymentInformationDocument, baseOptions);
      }
export function useGetPaymentInformationLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetPaymentInformationQuery, GetPaymentInformationQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetPaymentInformationQuery, GetPaymentInformationQueryVariables>(GetPaymentInformationDocument, baseOptions);
        }
export type GetPaymentInformationQueryHookResult = ReturnType<typeof useGetPaymentInformationQuery>;
export type GetPaymentInformationLazyQueryHookResult = ReturnType<typeof useGetPaymentInformationLazyQuery>;
export type GetPaymentInformationQueryResult = ApolloReactCommon.QueryResult<GetPaymentInformationQuery, GetPaymentInformationQueryVariables>;
export const GetPlexDocument = gql`
    query GetPlex($plexId: String!) {
  loggedIn {
    plexById(id: $plexId) {
      ...fullPlex
    }
  }
}
    ${FullPlexFragmentDoc}`;

/**
 * __useGetPlexQuery__
 *
 * To run a query within a React component, call `useGetPlexQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPlexQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPlexQuery({
 *   variables: {
 *      plexId: // value for 'plexId'
 *   },
 * });
 */
export function useGetPlexQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetPlexQuery, GetPlexQueryVariables>) {
        return ApolloReactHooks.useQuery<GetPlexQuery, GetPlexQueryVariables>(GetPlexDocument, baseOptions);
      }
export function useGetPlexLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetPlexQuery, GetPlexQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetPlexQuery, GetPlexQueryVariables>(GetPlexDocument, baseOptions);
        }
export type GetPlexQueryHookResult = ReturnType<typeof useGetPlexQuery>;
export type GetPlexLazyQueryHookResult = ReturnType<typeof useGetPlexLazyQuery>;
export type GetPlexQueryResult = ApolloReactCommon.QueryResult<GetPlexQuery, GetPlexQueryVariables>;
export const GetPlexDetailsDocument = gql`
    query GetPlexDetails($plexId: String!) {
  loggedIn {
    plexById(id: $plexId) {
      ...plexDetails
    }
  }
}
    ${PlexDetailsFragmentDoc}`;

/**
 * __useGetPlexDetailsQuery__
 *
 * To run a query within a React component, call `useGetPlexDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPlexDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPlexDetailsQuery({
 *   variables: {
 *      plexId: // value for 'plexId'
 *   },
 * });
 */
export function useGetPlexDetailsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetPlexDetailsQuery, GetPlexDetailsQueryVariables>) {
        return ApolloReactHooks.useQuery<GetPlexDetailsQuery, GetPlexDetailsQueryVariables>(GetPlexDetailsDocument, baseOptions);
      }
export function useGetPlexDetailsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetPlexDetailsQuery, GetPlexDetailsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetPlexDetailsQuery, GetPlexDetailsQueryVariables>(GetPlexDetailsDocument, baseOptions);
        }
export type GetPlexDetailsQueryHookResult = ReturnType<typeof useGetPlexDetailsQuery>;
export type GetPlexDetailsLazyQueryHookResult = ReturnType<typeof useGetPlexDetailsLazyQuery>;
export type GetPlexDetailsQueryResult = ApolloReactCommon.QueryResult<GetPlexDetailsQuery, GetPlexDetailsQueryVariables>;
export const GetPlexGoogleCalendarsDocument = gql`
    query GetPlexGoogleCalendars($plexId: String!) {
  loggedIn {
    plexById(id: $plexId) {
      id
      googleCalendars {
        id
        googleCalendarId
        description
        summary
      }
    }
  }
}
    `;

/**
 * __useGetPlexGoogleCalendarsQuery__
 *
 * To run a query within a React component, call `useGetPlexGoogleCalendarsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPlexGoogleCalendarsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPlexGoogleCalendarsQuery({
 *   variables: {
 *      plexId: // value for 'plexId'
 *   },
 * });
 */
export function useGetPlexGoogleCalendarsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetPlexGoogleCalendarsQuery, GetPlexGoogleCalendarsQueryVariables>) {
        return ApolloReactHooks.useQuery<GetPlexGoogleCalendarsQuery, GetPlexGoogleCalendarsQueryVariables>(GetPlexGoogleCalendarsDocument, baseOptions);
      }
export function useGetPlexGoogleCalendarsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetPlexGoogleCalendarsQuery, GetPlexGoogleCalendarsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetPlexGoogleCalendarsQuery, GetPlexGoogleCalendarsQueryVariables>(GetPlexGoogleCalendarsDocument, baseOptions);
        }
export type GetPlexGoogleCalendarsQueryHookResult = ReturnType<typeof useGetPlexGoogleCalendarsQuery>;
export type GetPlexGoogleCalendarsLazyQueryHookResult = ReturnType<typeof useGetPlexGoogleCalendarsLazyQuery>;
export type GetPlexGoogleCalendarsQueryResult = ApolloReactCommon.QueryResult<GetPlexGoogleCalendarsQuery, GetPlexGoogleCalendarsQueryVariables>;
export const GetPlexOverviewDocument = gql`
    query GetPlexOverview($plexId: String!) {
  loggedIn {
    plexById(id: $plexId) {
      ...plexOverview
    }
  }
}
    ${PlexOverviewFragmentDoc}`;

/**
 * __useGetPlexOverviewQuery__
 *
 * To run a query within a React component, call `useGetPlexOverviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPlexOverviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPlexOverviewQuery({
 *   variables: {
 *      plexId: // value for 'plexId'
 *   },
 * });
 */
export function useGetPlexOverviewQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetPlexOverviewQuery, GetPlexOverviewQueryVariables>) {
        return ApolloReactHooks.useQuery<GetPlexOverviewQuery, GetPlexOverviewQueryVariables>(GetPlexOverviewDocument, baseOptions);
      }
export function useGetPlexOverviewLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetPlexOverviewQuery, GetPlexOverviewQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetPlexOverviewQuery, GetPlexOverviewQueryVariables>(GetPlexOverviewDocument, baseOptions);
        }
export type GetPlexOverviewQueryHookResult = ReturnType<typeof useGetPlexOverviewQuery>;
export type GetPlexOverviewLazyQueryHookResult = ReturnType<typeof useGetPlexOverviewLazyQuery>;
export type GetPlexOverviewQueryResult = ApolloReactCommon.QueryResult<GetPlexOverviewQuery, GetPlexOverviewQueryVariables>;
export const GetPlexSummaryDocument = gql`
    query GetPlexSummary($plexId: String!) {
  loggedIn {
    plexById(id: $plexId) {
      ...plexSummary
    }
  }
}
    ${PlexSummaryFragmentDoc}`;

/**
 * __useGetPlexSummaryQuery__
 *
 * To run a query within a React component, call `useGetPlexSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPlexSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPlexSummaryQuery({
 *   variables: {
 *      plexId: // value for 'plexId'
 *   },
 * });
 */
export function useGetPlexSummaryQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetPlexSummaryQuery, GetPlexSummaryQueryVariables>) {
        return ApolloReactHooks.useQuery<GetPlexSummaryQuery, GetPlexSummaryQueryVariables>(GetPlexSummaryDocument, baseOptions);
      }
export function useGetPlexSummaryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetPlexSummaryQuery, GetPlexSummaryQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetPlexSummaryQuery, GetPlexSummaryQueryVariables>(GetPlexSummaryDocument, baseOptions);
        }
export type GetPlexSummaryQueryHookResult = ReturnType<typeof useGetPlexSummaryQuery>;
export type GetPlexSummaryLazyQueryHookResult = ReturnType<typeof useGetPlexSummaryLazyQuery>;
export type GetPlexSummaryQueryResult = ApolloReactCommon.QueryResult<GetPlexSummaryQuery, GetPlexSummaryQueryVariables>;
export const GetPostCommentsDocument = gql`
    query GetPostComments($postId: String!) {
  loggedIn {
    postById(postId: $postId) {
      id
      deleted
      comments {
        ...fullComment
      }
    }
  }
}
    ${FullCommentFragmentDoc}`;

/**
 * __useGetPostCommentsQuery__
 *
 * To run a query within a React component, call `useGetPostCommentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPostCommentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPostCommentsQuery({
 *   variables: {
 *      postId: // value for 'postId'
 *   },
 * });
 */
export function useGetPostCommentsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetPostCommentsQuery, GetPostCommentsQueryVariables>) {
        return ApolloReactHooks.useQuery<GetPostCommentsQuery, GetPostCommentsQueryVariables>(GetPostCommentsDocument, baseOptions);
      }
export function useGetPostCommentsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetPostCommentsQuery, GetPostCommentsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetPostCommentsQuery, GetPostCommentsQueryVariables>(GetPostCommentsDocument, baseOptions);
        }
export type GetPostCommentsQueryHookResult = ReturnType<typeof useGetPostCommentsQuery>;
export type GetPostCommentsLazyQueryHookResult = ReturnType<typeof useGetPostCommentsLazyQuery>;
export type GetPostCommentsQueryResult = ApolloReactCommon.QueryResult<GetPostCommentsQuery, GetPostCommentsQueryVariables>;
export const GetPostDocument = gql`
    query GetPost($postId: String!) {
  loggedIn {
    postById(postId: $postId) {
      ...postDetails
    }
  }
}
    ${PostDetailsFragmentDoc}`;

/**
 * __useGetPostQuery__
 *
 * To run a query within a React component, call `useGetPostQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPostQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPostQuery({
 *   variables: {
 *      postId: // value for 'postId'
 *   },
 * });
 */
export function useGetPostQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetPostQuery, GetPostQueryVariables>) {
        return ApolloReactHooks.useQuery<GetPostQuery, GetPostQueryVariables>(GetPostDocument, baseOptions);
      }
export function useGetPostLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetPostQuery, GetPostQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetPostQuery, GetPostQueryVariables>(GetPostDocument, baseOptions);
        }
export type GetPostQueryHookResult = ReturnType<typeof useGetPostQuery>;
export type GetPostLazyQueryHookResult = ReturnType<typeof useGetPostLazyQuery>;
export type GetPostQueryResult = ApolloReactCommon.QueryResult<GetPostQuery, GetPostQueryVariables>;
export const GetPostsDocument = gql`
    query GetPosts($cursor: String, $plexIds: [String!]!, $types: [PostType!]!, $publishStatuses: [PublishStatus!]!, $labelIds: [String!]!) {
  posts(cursor: $cursor, limit: 10, timeOrder: DESC, filters: {plexIds: $plexIds, types: $types, publishStatuses: $publishStatuses, labelIds: $labelIds}) {
    items {
      ...feedPostDetails
    }
    nextCursor
  }
}
    ${FeedPostDetailsFragmentDoc}`;

/**
 * __useGetPostsQuery__
 *
 * To run a query within a React component, call `useGetPostsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPostsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPostsQuery({
 *   variables: {
 *      cursor: // value for 'cursor'
 *      plexIds: // value for 'plexIds'
 *      types: // value for 'types'
 *      publishStatuses: // value for 'publishStatuses'
 *      labelIds: // value for 'labelIds'
 *   },
 * });
 */
export function useGetPostsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetPostsQuery, GetPostsQueryVariables>) {
        return ApolloReactHooks.useQuery<GetPostsQuery, GetPostsQueryVariables>(GetPostsDocument, baseOptions);
      }
export function useGetPostsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetPostsQuery, GetPostsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetPostsQuery, GetPostsQueryVariables>(GetPostsDocument, baseOptions);
        }
export type GetPostsQueryHookResult = ReturnType<typeof useGetPostsQuery>;
export type GetPostsLazyQueryHookResult = ReturnType<typeof useGetPostsLazyQuery>;
export type GetPostsQueryResult = ApolloReactCommon.QueryResult<GetPostsQuery, GetPostsQueryVariables>;
export const GetQuestionCommentsDocument = gql`
    query GetQuestionComments($questionId: String!) {
  loggedIn {
    questionById(id: $questionId) {
      id
      comments {
        ...fullComment
      }
    }
  }
}
    ${FullCommentFragmentDoc}`;

/**
 * __useGetQuestionCommentsQuery__
 *
 * To run a query within a React component, call `useGetQuestionCommentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQuestionCommentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQuestionCommentsQuery({
 *   variables: {
 *      questionId: // value for 'questionId'
 *   },
 * });
 */
export function useGetQuestionCommentsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetQuestionCommentsQuery, GetQuestionCommentsQueryVariables>) {
        return ApolloReactHooks.useQuery<GetQuestionCommentsQuery, GetQuestionCommentsQueryVariables>(GetQuestionCommentsDocument, baseOptions);
      }
export function useGetQuestionCommentsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetQuestionCommentsQuery, GetQuestionCommentsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetQuestionCommentsQuery, GetQuestionCommentsQueryVariables>(GetQuestionCommentsDocument, baseOptions);
        }
export type GetQuestionCommentsQueryHookResult = ReturnType<typeof useGetQuestionCommentsQuery>;
export type GetQuestionCommentsLazyQueryHookResult = ReturnType<typeof useGetQuestionCommentsLazyQuery>;
export type GetQuestionCommentsQueryResult = ApolloReactCommon.QueryResult<GetQuestionCommentsQuery, GetQuestionCommentsQueryVariables>;
export const GetQuestionDetailsDocument = gql`
    query GetQuestionDetails($questionId: String!) {
  loggedIn {
    questionById(id: $questionId) {
      ...questionDetails
    }
  }
}
    ${QuestionDetailsFragmentDoc}`;

/**
 * __useGetQuestionDetailsQuery__
 *
 * To run a query within a React component, call `useGetQuestionDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQuestionDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQuestionDetailsQuery({
 *   variables: {
 *      questionId: // value for 'questionId'
 *   },
 * });
 */
export function useGetQuestionDetailsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetQuestionDetailsQuery, GetQuestionDetailsQueryVariables>) {
        return ApolloReactHooks.useQuery<GetQuestionDetailsQuery, GetQuestionDetailsQueryVariables>(GetQuestionDetailsDocument, baseOptions);
      }
export function useGetQuestionDetailsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetQuestionDetailsQuery, GetQuestionDetailsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetQuestionDetailsQuery, GetQuestionDetailsQueryVariables>(GetQuestionDetailsDocument, baseOptions);
        }
export type GetQuestionDetailsQueryHookResult = ReturnType<typeof useGetQuestionDetailsQuery>;
export type GetQuestionDetailsLazyQueryHookResult = ReturnType<typeof useGetQuestionDetailsLazyQuery>;
export type GetQuestionDetailsQueryResult = ApolloReactCommon.QueryResult<GetQuestionDetailsQuery, GetQuestionDetailsQueryVariables>;
export const GetStripePublicKeyDocument = gql`
    query GetStripePublicKey {
  loggedIn {
    stripePublicKey
  }
}
    `;

/**
 * __useGetStripePublicKeyQuery__
 *
 * To run a query within a React component, call `useGetStripePublicKeyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStripePublicKeyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStripePublicKeyQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetStripePublicKeyQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetStripePublicKeyQuery, GetStripePublicKeyQueryVariables>) {
        return ApolloReactHooks.useQuery<GetStripePublicKeyQuery, GetStripePublicKeyQueryVariables>(GetStripePublicKeyDocument, baseOptions);
      }
export function useGetStripePublicKeyLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetStripePublicKeyQuery, GetStripePublicKeyQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetStripePublicKeyQuery, GetStripePublicKeyQueryVariables>(GetStripePublicKeyDocument, baseOptions);
        }
export type GetStripePublicKeyQueryHookResult = ReturnType<typeof useGetStripePublicKeyQuery>;
export type GetStripePublicKeyLazyQueryHookResult = ReturnType<typeof useGetStripePublicKeyLazyQuery>;
export type GetStripePublicKeyQueryResult = ApolloReactCommon.QueryResult<GetStripePublicKeyQuery, GetStripePublicKeyQueryVariables>;
export const GetTaskDetailsDocument = gql`
    query GetTaskDetails($taskId: String!) {
  taskById(taskId: $taskId) {
    ...taskDetails
  }
}
    ${TaskDetailsFragmentDoc}`;

/**
 * __useGetTaskDetailsQuery__
 *
 * To run a query within a React component, call `useGetTaskDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTaskDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTaskDetailsQuery({
 *   variables: {
 *      taskId: // value for 'taskId'
 *   },
 * });
 */
export function useGetTaskDetailsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetTaskDetailsQuery, GetTaskDetailsQueryVariables>) {
        return ApolloReactHooks.useQuery<GetTaskDetailsQuery, GetTaskDetailsQueryVariables>(GetTaskDetailsDocument, baseOptions);
      }
export function useGetTaskDetailsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetTaskDetailsQuery, GetTaskDetailsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetTaskDetailsQuery, GetTaskDetailsQueryVariables>(GetTaskDetailsDocument, baseOptions);
        }
export type GetTaskDetailsQueryHookResult = ReturnType<typeof useGetTaskDetailsQuery>;
export type GetTaskDetailsLazyQueryHookResult = ReturnType<typeof useGetTaskDetailsLazyQuery>;
export type GetTaskDetailsQueryResult = ApolloReactCommon.QueryResult<GetTaskDetailsQuery, GetTaskDetailsQueryVariables>;
export const GetTasksDocument = gql`
    query GetTasks($cursor: String, $plexIds: [String!]!, $publishStatuses: [PublishStatus!]!, $types: [TaskType!]!, $labelIds: [String!]!, $order: TasksOrder!) {
  tasks(cursor: $cursor, limit: 10, filters: {plexIds: $plexIds, publishStatuses: $publishStatuses, types: $types, labelIds: $labelIds}, order: $order) {
    items {
      id
      permalink
      type
      publishStatus
      status
      title
      body
      assignee {
        id
        name
        picture
      }
      mentions {
        ...mentionsPlexRegisteredUser
      }
      links {
        ...linkPreviewMetadata
      }
      author {
        id
        name
      }
      plex {
        id
        name
        color
      }
      labels {
        id
        name
      }
      dueDate
      deleted
    }
    nextCursor
  }
}
    ${MentionsPlexRegisteredUserFragmentDoc}
${LinkPreviewMetadataFragmentDoc}`;

/**
 * __useGetTasksQuery__
 *
 * To run a query within a React component, call `useGetTasksQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTasksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTasksQuery({
 *   variables: {
 *      cursor: // value for 'cursor'
 *      plexIds: // value for 'plexIds'
 *      publishStatuses: // value for 'publishStatuses'
 *      types: // value for 'types'
 *      labelIds: // value for 'labelIds'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useGetTasksQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetTasksQuery, GetTasksQueryVariables>) {
        return ApolloReactHooks.useQuery<GetTasksQuery, GetTasksQueryVariables>(GetTasksDocument, baseOptions);
      }
export function useGetTasksLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetTasksQuery, GetTasksQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetTasksQuery, GetTasksQueryVariables>(GetTasksDocument, baseOptions);
        }
export type GetTasksQueryHookResult = ReturnType<typeof useGetTasksQuery>;
export type GetTasksLazyQueryHookResult = ReturnType<typeof useGetTasksLazyQuery>;
export type GetTasksQueryResult = ApolloReactCommon.QueryResult<GetTasksQuery, GetTasksQueryVariables>;
export const GetTimelineDocument = gql`
    query GetTimeline($cursor: String, $plexIds: [String!]!, $publishStatuses: [PublishStatus!]!, $labelIds: [String!]!, $before: DateTime!, $onOrAfter: DateTime!, $types: [PostType!]!) {
  posts(cursor: $cursor, limit: 30, timeOrder: DESC, filters: {plexIds: $plexIds, types: $types, publishStatuses: $publishStatuses, labelIds: $labelIds, before: $before, onOrAfter: $onOrAfter}) {
    items {
      ...feedPostDetails
    }
    nextCursor
  }
}
    ${FeedPostDetailsFragmentDoc}`;

/**
 * __useGetTimelineQuery__
 *
 * To run a query within a React component, call `useGetTimelineQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTimelineQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTimelineQuery({
 *   variables: {
 *      cursor: // value for 'cursor'
 *      plexIds: // value for 'plexIds'
 *      publishStatuses: // value for 'publishStatuses'
 *      labelIds: // value for 'labelIds'
 *      before: // value for 'before'
 *      onOrAfter: // value for 'onOrAfter'
 *      types: // value for 'types'
 *   },
 * });
 */
export function useGetTimelineQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetTimelineQuery, GetTimelineQueryVariables>) {
        return ApolloReactHooks.useQuery<GetTimelineQuery, GetTimelineQueryVariables>(GetTimelineDocument, baseOptions);
      }
export function useGetTimelineLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetTimelineQuery, GetTimelineQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetTimelineQuery, GetTimelineQueryVariables>(GetTimelineDocument, baseOptions);
        }
export type GetTimelineQueryHookResult = ReturnType<typeof useGetTimelineQuery>;
export type GetTimelineLazyQueryHookResult = ReturnType<typeof useGetTimelineLazyQuery>;
export type GetTimelineQueryResult = ApolloReactCommon.QueryResult<GetTimelineQuery, GetTimelineQueryVariables>;
export const GetUserNotificationsDocument = gql`
    query GetUserNotifications {
  loggedIn {
    __typename
    notifications {
      __typename
      ...feedNotification
    }
  }
}
    ${FeedNotificationFragmentDoc}`;

/**
 * __useGetUserNotificationsQuery__
 *
 * To run a query within a React component, call `useGetUserNotificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserNotificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserNotificationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserNotificationsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetUserNotificationsQuery, GetUserNotificationsQueryVariables>) {
        return ApolloReactHooks.useQuery<GetUserNotificationsQuery, GetUserNotificationsQueryVariables>(GetUserNotificationsDocument, baseOptions);
      }
export function useGetUserNotificationsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetUserNotificationsQuery, GetUserNotificationsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetUserNotificationsQuery, GetUserNotificationsQueryVariables>(GetUserNotificationsDocument, baseOptions);
        }
export type GetUserNotificationsQueryHookResult = ReturnType<typeof useGetUserNotificationsQuery>;
export type GetUserNotificationsLazyQueryHookResult = ReturnType<typeof useGetUserNotificationsLazyQuery>;
export type GetUserNotificationsQueryResult = ApolloReactCommon.QueryResult<GetUserNotificationsQuery, GetUserNotificationsQueryVariables>;
export const SearchCollaboratorsDocument = gql`
    query SearchCollaborators($query: String, $onlySignedUpUsers: Boolean) {
  loggedIn {
    searchUsers(searchQuery: $query, onlySignedUpUsers: $onlySignedUpUsers) {
      results {
        id
        plexUserId
        name
        email
        picture
        source
      }
    }
  }
}
    `;

/**
 * __useSearchCollaboratorsQuery__
 *
 * To run a query within a React component, call `useSearchCollaboratorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchCollaboratorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchCollaboratorsQuery({
 *   variables: {
 *      query: // value for 'query'
 *      onlySignedUpUsers: // value for 'onlySignedUpUsers'
 *   },
 * });
 */
export function useSearchCollaboratorsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<SearchCollaboratorsQuery, SearchCollaboratorsQueryVariables>) {
        return ApolloReactHooks.useQuery<SearchCollaboratorsQuery, SearchCollaboratorsQueryVariables>(SearchCollaboratorsDocument, baseOptions);
      }
export function useSearchCollaboratorsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SearchCollaboratorsQuery, SearchCollaboratorsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<SearchCollaboratorsQuery, SearchCollaboratorsQueryVariables>(SearchCollaboratorsDocument, baseOptions);
        }
export type SearchCollaboratorsQueryHookResult = ReturnType<typeof useSearchCollaboratorsQuery>;
export type SearchCollaboratorsLazyQueryHookResult = ReturnType<typeof useSearchCollaboratorsLazyQuery>;
export type SearchCollaboratorsQueryResult = ApolloReactCommon.QueryResult<SearchCollaboratorsQuery, SearchCollaboratorsQueryVariables>;
export const SearchEverythingDocument = gql`
    query SearchEverything($query: String!, $cursor: String, $filters: SearchFilters!, $sortOrder: SearchSortOrder!) {
  currentUser {
    __typename
    id
    domain {
      __typename
      id
      search(query: $query, cursor: $cursor, limit: 30, filters: $filters, sortOrder: $sortOrder) {
        nextCursor
        items {
          __typename
          id
          body {
            __typename
            ... on SearchPostBody {
              __typename
              permalink
              title
              author
              body
              createdAt
              updatedAt
              publishStatus
              postType
              plexId
            }
            ... on SearchQuestionBody {
              __typename
              permalink
              text
              author
              createdAt
              updatedAt
              questionStatus
              plexId
              acceptedAnswerBody
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useSearchEverythingQuery__
 *
 * To run a query within a React component, call `useSearchEverythingQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchEverythingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchEverythingQuery({
 *   variables: {
 *      query: // value for 'query'
 *      cursor: // value for 'cursor'
 *      filters: // value for 'filters'
 *      sortOrder: // value for 'sortOrder'
 *   },
 * });
 */
export function useSearchEverythingQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<SearchEverythingQuery, SearchEverythingQueryVariables>) {
        return ApolloReactHooks.useQuery<SearchEverythingQuery, SearchEverythingQueryVariables>(SearchEverythingDocument, baseOptions);
      }
export function useSearchEverythingLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SearchEverythingQuery, SearchEverythingQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<SearchEverythingQuery, SearchEverythingQueryVariables>(SearchEverythingDocument, baseOptions);
        }
export type SearchEverythingQueryHookResult = ReturnType<typeof useSearchEverythingQuery>;
export type SearchEverythingLazyQueryHookResult = ReturnType<typeof useSearchEverythingLazyQuery>;
export type SearchEverythingQueryResult = ApolloReactCommon.QueryResult<SearchEverythingQuery, SearchEverythingQueryVariables>;
export const GetAnalyticsItemsDocument = gql`
    query GetAnalyticsItems($plexId: String!, $targetType: AnalyticsItemType!, $cursor: Int, $timeOrder: TimeOrder!) {
  loggedIn {
    plexById(id: $plexId) {
      id
      analytics {
        items(plexId: $plexId, targetType: $targetType, cursor: $cursor, limit: 10, timeOrder: $timeOrder) {
          ...analyticsItems
        }
      }
    }
  }
}
    ${AnalyticsItemsFragmentDoc}`;

/**
 * __useGetAnalyticsItemsQuery__
 *
 * To run a query within a React component, call `useGetAnalyticsItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAnalyticsItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAnalyticsItemsQuery({
 *   variables: {
 *      plexId: // value for 'plexId'
 *      targetType: // value for 'targetType'
 *      cursor: // value for 'cursor'
 *      timeOrder: // value for 'timeOrder'
 *   },
 * });
 */
export function useGetAnalyticsItemsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetAnalyticsItemsQuery, GetAnalyticsItemsQueryVariables>) {
        return ApolloReactHooks.useQuery<GetAnalyticsItemsQuery, GetAnalyticsItemsQueryVariables>(GetAnalyticsItemsDocument, baseOptions);
      }
export function useGetAnalyticsItemsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetAnalyticsItemsQuery, GetAnalyticsItemsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetAnalyticsItemsQuery, GetAnalyticsItemsQueryVariables>(GetAnalyticsItemsDocument, baseOptions);
        }
export type GetAnalyticsItemsQueryHookResult = ReturnType<typeof useGetAnalyticsItemsQuery>;
export type GetAnalyticsItemsLazyQueryHookResult = ReturnType<typeof useGetAnalyticsItemsLazyQuery>;
export type GetAnalyticsItemsQueryResult = ApolloReactCommon.QueryResult<GetAnalyticsItemsQuery, GetAnalyticsItemsQueryVariables>;
export const GetAnalyticsSummaryDocument = gql`
    query GetAnalyticsSummary($plexId: String!, $targetType: AnalyticsItemType!, $cursor: Int, $timeOrder: TimeOrder!) {
  loggedIn {
    plexById(id: $plexId) {
      id
      name
      analytics {
        audience(plexId: $plexId)
        impressions(plexId: $plexId)
        clicks(plexId: $plexId)
        commentsCount(plexId: $plexId)
        reactionsCount(plexId: $plexId)
        items(plexId: $plexId, targetType: $targetType, cursor: $cursor, limit: 10, timeOrder: $timeOrder) {
          ...analyticsItems
        }
      }
    }
  }
}
    ${AnalyticsItemsFragmentDoc}`;

/**
 * __useGetAnalyticsSummaryQuery__
 *
 * To run a query within a React component, call `useGetAnalyticsSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAnalyticsSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAnalyticsSummaryQuery({
 *   variables: {
 *      plexId: // value for 'plexId'
 *      targetType: // value for 'targetType'
 *      cursor: // value for 'cursor'
 *      timeOrder: // value for 'timeOrder'
 *   },
 * });
 */
export function useGetAnalyticsSummaryQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetAnalyticsSummaryQuery, GetAnalyticsSummaryQueryVariables>) {
        return ApolloReactHooks.useQuery<GetAnalyticsSummaryQuery, GetAnalyticsSummaryQueryVariables>(GetAnalyticsSummaryDocument, baseOptions);
      }
export function useGetAnalyticsSummaryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetAnalyticsSummaryQuery, GetAnalyticsSummaryQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetAnalyticsSummaryQuery, GetAnalyticsSummaryQueryVariables>(GetAnalyticsSummaryDocument, baseOptions);
        }
export type GetAnalyticsSummaryQueryHookResult = ReturnType<typeof useGetAnalyticsSummaryQuery>;
export type GetAnalyticsSummaryLazyQueryHookResult = ReturnType<typeof useGetAnalyticsSummaryLazyQuery>;
export type GetAnalyticsSummaryQueryResult = ApolloReactCommon.QueryResult<GetAnalyticsSummaryQuery, GetAnalyticsSummaryQueryVariables>;
export const GetPostAnalyticsDocument = gql`
    query GetPostAnalytics($postId: String!) {
  loggedIn {
    postById(postId: $postId) {
      id
      analytics {
        ...analyticsOneItem
      }
      title
      publishStatus
      publishedDate
      plex {
        id
        name
        color
      }
      deleted
    }
  }
}
    ${AnalyticsOneItemFragmentDoc}`;

/**
 * __useGetPostAnalyticsQuery__
 *
 * To run a query within a React component, call `useGetPostAnalyticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPostAnalyticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPostAnalyticsQuery({
 *   variables: {
 *      postId: // value for 'postId'
 *   },
 * });
 */
export function useGetPostAnalyticsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetPostAnalyticsQuery, GetPostAnalyticsQueryVariables>) {
        return ApolloReactHooks.useQuery<GetPostAnalyticsQuery, GetPostAnalyticsQueryVariables>(GetPostAnalyticsDocument, baseOptions);
      }
export function useGetPostAnalyticsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetPostAnalyticsQuery, GetPostAnalyticsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetPostAnalyticsQuery, GetPostAnalyticsQueryVariables>(GetPostAnalyticsDocument, baseOptions);
        }
export type GetPostAnalyticsQueryHookResult = ReturnType<typeof useGetPostAnalyticsQuery>;
export type GetPostAnalyticsLazyQueryHookResult = ReturnType<typeof useGetPostAnalyticsLazyQuery>;
export type GetPostAnalyticsQueryResult = ApolloReactCommon.QueryResult<GetPostAnalyticsQuery, GetPostAnalyticsQueryVariables>;
export const GetQuestionAnalyticsDocument = gql`
    query GetQuestionAnalytics($questionId: String!) {
  loggedIn {
    questionById(id: $questionId) {
      id
      analytics {
        ...analyticsOneItem
      }
      text
      status
      publishChangedAt
      plex {
        id
        name
        color
      }
      deleted
    }
  }
}
    ${AnalyticsOneItemFragmentDoc}`;

/**
 * __useGetQuestionAnalyticsQuery__
 *
 * To run a query within a React component, call `useGetQuestionAnalyticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQuestionAnalyticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQuestionAnalyticsQuery({
 *   variables: {
 *      questionId: // value for 'questionId'
 *   },
 * });
 */
export function useGetQuestionAnalyticsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetQuestionAnalyticsQuery, GetQuestionAnalyticsQueryVariables>) {
        return ApolloReactHooks.useQuery<GetQuestionAnalyticsQuery, GetQuestionAnalyticsQueryVariables>(GetQuestionAnalyticsDocument, baseOptions);
      }
export function useGetQuestionAnalyticsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetQuestionAnalyticsQuery, GetQuestionAnalyticsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetQuestionAnalyticsQuery, GetQuestionAnalyticsQueryVariables>(GetQuestionAnalyticsDocument, baseOptions);
        }
export type GetQuestionAnalyticsQueryHookResult = ReturnType<typeof useGetQuestionAnalyticsQuery>;
export type GetQuestionAnalyticsLazyQueryHookResult = ReturnType<typeof useGetQuestionAnalyticsLazyQuery>;
export type GetQuestionAnalyticsQueryResult = ApolloReactCommon.QueryResult<GetQuestionAnalyticsQuery, GetQuestionAnalyticsQueryVariables>;
export const GetAnswersSubscriptionDocument = gql`
    subscription GetAnswersSubscription($questionId: String!) {
  answer(questionId: $questionId) {
    ...fullAnswer
  }
}
    ${FullAnswerFragmentDoc}`;

/**
 * __useGetAnswersSubscriptionSubscription__
 *
 * To run a query within a React component, call `useGetAnswersSubscriptionSubscription` and pass it any options that fit your needs.
 * When your component renders, `useGetAnswersSubscriptionSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAnswersSubscriptionSubscription({
 *   variables: {
 *      questionId: // value for 'questionId'
 *   },
 * });
 */
export function useGetAnswersSubscriptionSubscription(baseOptions?: ApolloReactHooks.SubscriptionHookOptions<GetAnswersSubscriptionSubscription, GetAnswersSubscriptionSubscriptionVariables>) {
        return ApolloReactHooks.useSubscription<GetAnswersSubscriptionSubscription, GetAnswersSubscriptionSubscriptionVariables>(GetAnswersSubscriptionDocument, baseOptions);
      }
export type GetAnswersSubscriptionSubscriptionHookResult = ReturnType<typeof useGetAnswersSubscriptionSubscription>;
export type GetAnswersSubscriptionSubscriptionResult = ApolloReactCommon.SubscriptionResult<GetAnswersSubscriptionSubscription>;
export const GetBoardsSubscriptionDocument = gql`
    subscription GetBoardsSubscription($plexIds: [String!]!, $filterPublishStatus: FilterPublishStatus!, $labelIds: [String!]!) {
  board(plexIds: $plexIds) {
    ...boardOverview
    questions(filterPublishStatus: $filterPublishStatus, labelIds: $labelIds) {
      items {
        ...feedQuestionDetails
      }
      nextCursor
    }
    faqCount(filterPublishStatus: $filterPublishStatus, labelIds: $labelIds)
    deleted
  }
}
    ${BoardOverviewFragmentDoc}
${FeedQuestionDetailsFragmentDoc}`;

/**
 * __useGetBoardsSubscriptionSubscription__
 *
 * To run a query within a React component, call `useGetBoardsSubscriptionSubscription` and pass it any options that fit your needs.
 * When your component renders, `useGetBoardsSubscriptionSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBoardsSubscriptionSubscription({
 *   variables: {
 *      plexIds: // value for 'plexIds'
 *      filterPublishStatus: // value for 'filterPublishStatus'
 *      labelIds: // value for 'labelIds'
 *   },
 * });
 */
export function useGetBoardsSubscriptionSubscription(baseOptions?: ApolloReactHooks.SubscriptionHookOptions<GetBoardsSubscriptionSubscription, GetBoardsSubscriptionSubscriptionVariables>) {
        return ApolloReactHooks.useSubscription<GetBoardsSubscriptionSubscription, GetBoardsSubscriptionSubscriptionVariables>(GetBoardsSubscriptionDocument, baseOptions);
      }
export type GetBoardsSubscriptionSubscriptionHookResult = ReturnType<typeof useGetBoardsSubscriptionSubscription>;
export type GetBoardsSubscriptionSubscriptionResult = ApolloReactCommon.SubscriptionResult<GetBoardsSubscriptionSubscription>;
export const GetCommentsSubscriptionDocument = gql`
    subscription GetCommentsSubscription($id: String!, $isPost: Boolean!) {
  comment(id: $id, isPost: $isPost) {
    ...fullComment
  }
}
    ${FullCommentFragmentDoc}`;

/**
 * __useGetCommentsSubscriptionSubscription__
 *
 * To run a query within a React component, call `useGetCommentsSubscriptionSubscription` and pass it any options that fit your needs.
 * When your component renders, `useGetCommentsSubscriptionSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCommentsSubscriptionSubscription({
 *   variables: {
 *      id: // value for 'id'
 *      isPost: // value for 'isPost'
 *   },
 * });
 */
export function useGetCommentsSubscriptionSubscription(baseOptions?: ApolloReactHooks.SubscriptionHookOptions<GetCommentsSubscriptionSubscription, GetCommentsSubscriptionSubscriptionVariables>) {
        return ApolloReactHooks.useSubscription<GetCommentsSubscriptionSubscription, GetCommentsSubscriptionSubscriptionVariables>(GetCommentsSubscriptionDocument, baseOptions);
      }
export type GetCommentsSubscriptionSubscriptionHookResult = ReturnType<typeof useGetCommentsSubscriptionSubscription>;
export type GetCommentsSubscriptionSubscriptionResult = ApolloReactCommon.SubscriptionResult<GetCommentsSubscriptionSubscription>;
export const GetNotificationActivityDocument = gql`
    subscription GetNotificationActivity {
  notificationActivity {
    ...notificationActivity
    totalUnreadCount
  }
}
    ${NotificationActivityFragmentDoc}`;

/**
 * __useGetNotificationActivitySubscription__
 *
 * To run a query within a React component, call `useGetNotificationActivitySubscription` and pass it any options that fit your needs.
 * When your component renders, `useGetNotificationActivitySubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNotificationActivitySubscription({
 *   variables: {
 *   },
 * });
 */
export function useGetNotificationActivitySubscription(baseOptions?: ApolloReactHooks.SubscriptionHookOptions<GetNotificationActivitySubscription, GetNotificationActivitySubscriptionVariables>) {
        return ApolloReactHooks.useSubscription<GetNotificationActivitySubscription, GetNotificationActivitySubscriptionVariables>(GetNotificationActivityDocument, baseOptions);
      }
export type GetNotificationActivitySubscriptionHookResult = ReturnType<typeof useGetNotificationActivitySubscription>;
export type GetNotificationActivitySubscriptionResult = ApolloReactCommon.SubscriptionResult<GetNotificationActivitySubscription>;
export const GetUserNotificationsSubscriptionDocument = gql`
    subscription GetUserNotificationsSubscription {
  userNotifications {
    notifications {
      ...feedNotification
    }
  }
}
    ${FeedNotificationFragmentDoc}`;

/**
 * __useGetUserNotificationsSubscriptionSubscription__
 *
 * To run a query within a React component, call `useGetUserNotificationsSubscriptionSubscription` and pass it any options that fit your needs.
 * When your component renders, `useGetUserNotificationsSubscriptionSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserNotificationsSubscriptionSubscription({
 *   variables: {
 *   },
 * });
 */
export function useGetUserNotificationsSubscriptionSubscription(baseOptions?: ApolloReactHooks.SubscriptionHookOptions<GetUserNotificationsSubscriptionSubscription, GetUserNotificationsSubscriptionSubscriptionVariables>) {
        return ApolloReactHooks.useSubscription<GetUserNotificationsSubscriptionSubscription, GetUserNotificationsSubscriptionSubscriptionVariables>(GetUserNotificationsSubscriptionDocument, baseOptions);
      }
export type GetUserNotificationsSubscriptionSubscriptionHookResult = ReturnType<typeof useGetUserNotificationsSubscriptionSubscription>;
export type GetUserNotificationsSubscriptionSubscriptionResult = ApolloReactCommon.SubscriptionResult<GetUserNotificationsSubscriptionSubscription>;
export const GetPostsSubscriptionDocument = gql`
    subscription GetPostsSubscription($plexIds: [String!]!, $types: [PostType!]!, $publishStatuses: [PublishStatus!]!, $labelIds: [String!]!, $before: DateTime, $onOrAfter: DateTime) {
  posts(filters: {plexIds: $plexIds, types: $types, publishStatuses: $publishStatuses, labelIds: $labelIds, before: $before, onOrAfter: $onOrAfter}) {
    ...postDetails
    comments {
      ...fullComment
    }
    plex {
      id
      summary {
        id
        postsCount
      }
    }
  }
}
    ${PostDetailsFragmentDoc}
${FullCommentFragmentDoc}`;

/**
 * __useGetPostsSubscriptionSubscription__
 *
 * To run a query within a React component, call `useGetPostsSubscriptionSubscription` and pass it any options that fit your needs.
 * When your component renders, `useGetPostsSubscriptionSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPostsSubscriptionSubscription({
 *   variables: {
 *      plexIds: // value for 'plexIds'
 *      types: // value for 'types'
 *      publishStatuses: // value for 'publishStatuses'
 *      labelIds: // value for 'labelIds'
 *      before: // value for 'before'
 *      onOrAfter: // value for 'onOrAfter'
 *   },
 * });
 */
export function useGetPostsSubscriptionSubscription(baseOptions?: ApolloReactHooks.SubscriptionHookOptions<GetPostsSubscriptionSubscription, GetPostsSubscriptionSubscriptionVariables>) {
        return ApolloReactHooks.useSubscription<GetPostsSubscriptionSubscription, GetPostsSubscriptionSubscriptionVariables>(GetPostsSubscriptionDocument, baseOptions);
      }
export type GetPostsSubscriptionSubscriptionHookResult = ReturnType<typeof useGetPostsSubscriptionSubscription>;
export type GetPostsSubscriptionSubscriptionResult = ApolloReactCommon.SubscriptionResult<GetPostsSubscriptionSubscription>;
export const GetQuestionPositionSubscriptionDocument = gql`
    subscription GetQuestionPositionSubscription($boardId: String!) {
  questionPosition(boardId: $boardId) {
    boardId
    positions {
      id
      positionInBoard
    }
  }
}
    `;

/**
 * __useGetQuestionPositionSubscriptionSubscription__
 *
 * To run a query within a React component, call `useGetQuestionPositionSubscriptionSubscription` and pass it any options that fit your needs.
 * When your component renders, `useGetQuestionPositionSubscriptionSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQuestionPositionSubscriptionSubscription({
 *   variables: {
 *      boardId: // value for 'boardId'
 *   },
 * });
 */
export function useGetQuestionPositionSubscriptionSubscription(baseOptions?: ApolloReactHooks.SubscriptionHookOptions<GetQuestionPositionSubscriptionSubscription, GetQuestionPositionSubscriptionSubscriptionVariables>) {
        return ApolloReactHooks.useSubscription<GetQuestionPositionSubscriptionSubscription, GetQuestionPositionSubscriptionSubscriptionVariables>(GetQuestionPositionSubscriptionDocument, baseOptions);
      }
export type GetQuestionPositionSubscriptionSubscriptionHookResult = ReturnType<typeof useGetQuestionPositionSubscriptionSubscription>;
export type GetQuestionPositionSubscriptionSubscriptionResult = ApolloReactCommon.SubscriptionResult<GetQuestionPositionSubscriptionSubscription>;
export const GetQuestionsSubscriptionDocument = gql`
    subscription GetQuestionsSubscription($boardId: String!, $filterPublishStatus: FilterPublishStatus!, $labelIds: [String!]!) {
  question(boardId: $boardId, filterPublishStatus: $filterPublishStatus, labelIds: $labelIds) {
    ...feedQuestionDetails
    plex {
      id
      summary {
        id
        faqsCount
      }
    }
  }
}
    ${FeedQuestionDetailsFragmentDoc}`;

/**
 * __useGetQuestionsSubscriptionSubscription__
 *
 * To run a query within a React component, call `useGetQuestionsSubscriptionSubscription` and pass it any options that fit your needs.
 * When your component renders, `useGetQuestionsSubscriptionSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQuestionsSubscriptionSubscription({
 *   variables: {
 *      boardId: // value for 'boardId'
 *      filterPublishStatus: // value for 'filterPublishStatus'
 *      labelIds: // value for 'labelIds'
 *   },
 * });
 */
export function useGetQuestionsSubscriptionSubscription(baseOptions?: ApolloReactHooks.SubscriptionHookOptions<GetQuestionsSubscriptionSubscription, GetQuestionsSubscriptionSubscriptionVariables>) {
        return ApolloReactHooks.useSubscription<GetQuestionsSubscriptionSubscription, GetQuestionsSubscriptionSubscriptionVariables>(GetQuestionsSubscriptionDocument, baseOptions);
      }
export type GetQuestionsSubscriptionSubscriptionHookResult = ReturnType<typeof useGetQuestionsSubscriptionSubscription>;
export type GetQuestionsSubscriptionSubscriptionResult = ApolloReactCommon.SubscriptionResult<GetQuestionsSubscriptionSubscription>;